import { AgreementCategoryStaff } from "../../generated/dto/AgreementCategoryStaff";
import { AgreementInstanceStaff } from "../../generated/dto/AgreementInstanceStaff";
import { AgreementStaff } from "../../generated/dto/AgreementStaff";
import { ApClassAttendanceStaff } from "../../generated/dto/ApClassAttendanceStaff";
import { ApClassFormatStaff } from "../../generated/dto/ApClassFormatStaff";
import { ApClassMember } from "../../generated/dto/ApClassMember";
import { ApClassSessionStaff } from "../../generated/dto/ApClassSessionStaff";
import { ApClassSignupStaff } from "../../generated/dto/ApClassSignupStaff";
import { ApClassStaff } from "../../generated/dto/ApClassStaff";
import { ApClassTypeOverrideStaff } from "../../generated/dto/ApClassTypeOverrideStaff";
import { ApClassTypeStaff } from "../../generated/dto/ApClassTypeStaff";
import { BalanceLookupCooldownStaff } from "../../generated/dto/BalanceLookupCooldownStaff";
import { BalanceStaff } from "../../generated/dto/BalanceStaff";
import { BalanceTransactionStaff } from "../../generated/dto/BalanceTransactionStaff";
import { CardStaff } from "../../generated/dto/CardStaff";
import { CashDrawerChangeStaff } from "../../generated/dto/CashDrawerChangeStaff";
import { CashDrawerStaff } from "../../generated/dto/CashDrawerStaff";
import { CashDrawerTotalStaff } from "../../generated/dto/CashDrawerTotalStaff";
import { CatalogDiscountCategoryStaff } from "../../generated/dto/CatalogDiscountCategoryStaff";
import { CatalogDiscountInstanceStaff } from "../../generated/dto/CatalogDiscountInstanceStaff";
import { CatalogDiscountStaff } from "../../generated/dto/CatalogDiscountStaff";
import { CatalogItemAgreementStaff } from "../../generated/dto/CatalogItemAgreementStaff";
import { CatalogItemCategoryStaff } from "../../generated/dto/CatalogItemCategoryStaff";
import { CatalogItemDiscountStaff } from "../../generated/dto/CatalogItemDiscountStaff";
import { CatalogItemInstanceStaff } from "../../generated/dto/CatalogItemInstanceStaff";
import { CatalogItemStaff } from "../../generated/dto/CatalogItemStaff";
import { CatalogItemTaxStaff } from "../../generated/dto/CatalogItemTaxStaff";
import { CatalogStaff } from "../../generated/dto/CatalogStaff";
import { CatalogTaxStaff } from "../../generated/dto/CatalogTaxStaff";
import { CategoryStaff } from "../../generated/dto/CategoryStaff";
import { ClassLocationStaff } from "../../generated/dto/ClassLocationStaff";
import { DailySalesReportStaff } from "../../generated/dto/DailySalesReportStaff";
import { DamageWaiverStaff } from "../../generated/dto/DamageWaiverStaff";
import { DonationStaff } from "../../generated/dto/DonationStaff";
import { GuestPrivilegeStaff } from "../../generated/dto/GuestPrivilegeStaff";
import { InvalidOrderReportStaff } from "../../generated/dto/InvalidOrderReportStaff";
import { InvalidSignupReasonStaff } from "../../generated/dto/InvalidSignupReasonStaff";
import { InvalidSignupReportStaff } from "../../generated/dto/InvalidSignupReportStaff";
import { JpClassAttendanceStaff } from "../../generated/dto/JpClassAttendanceStaff";
import { JpClassMember } from "../../generated/dto/JpClassMember";
import { JpClassSessionStaff } from "../../generated/dto/JpClassSessionStaff";
import { JpClassSignupStaff } from "../../generated/dto/JpClassSignupStaff";
import { JpClassStaff } from "../../generated/dto/JpClassStaff";
import { JpClassStaggerStaff } from "../../generated/dto/JpClassStaggerStaff";
import { JpClassTypeOverrideStaff } from "../../generated/dto/JpClassTypeOverrideStaff";
import { JpClassTypeStaff } from "../../generated/dto/JpClassTypeStaff";
import { LineItemDiscountInstanceStaff } from "../../generated/dto/LineItemDiscountInstanceStaff";
import { LineItemMember } from "../../generated/dto/LineItemMember";
import { LineItemRefundStaff } from "../../generated/dto/LineItemRefundStaff";
import { LineItemRefundTaxStaff } from "../../generated/dto/LineItemRefundTaxStaff";
import { LineItemStaff } from "../../generated/dto/LineItemStaff";
import { LineItemTaxStaff } from "../../generated/dto/LineItemTaxStaff";
import { MembershipMember } from "../../generated/dto/MembershipMember";
import { MembershipStaff } from "../../generated/dto/MembershipStaff";
import { MembershipTypeDiscountStaff } from "../../generated/dto/MembershipTypeDiscountStaff";
import { MembershipTypeStaff } from "../../generated/dto/MembershipTypeStaff";
import { OrderMember } from "../../generated/dto/OrderMember";
import { OrderPaymentStaff } from "../../generated/dto/OrderPaymentStaff";
import { OrderRefundStaff } from "../../generated/dto/OrderRefundStaff";
import { OrderStaff } from "../../generated/dto/OrderStaff";
import { PaymentRefundStaff } from "../../generated/dto/PaymentRefundStaff";
import { PersonAddressStaff } from "../../generated/dto/PersonAddressStaff";
import { PersonAgreementInstanceStaff } from "../../generated/dto/PersonAgreementInstanceStaff";
import { PersonBalanceStaff } from "../../generated/dto/PersonBalanceStaff";
import { PersonCheckInStaff } from "../../generated/dto/PersonCheckInStaff";
import { PersonCommentStaff } from "../../generated/dto/PersonCommentStaff";
import { PersonMember } from "../../generated/dto/PersonMember";
import { PersonPersonTypeStaff } from "../../generated/dto/PersonPersonTypeStaff";
import { PersonPhoneStaff } from "../../generated/dto/PersonPhoneStaff";
import { PersonRatingStaff } from "../../generated/dto/PersonRatingStaff";
import { PersonRelationStaff } from "../../generated/dto/PersonRelationStaff";
import { PersonSkillChangeStaff } from "../../generated/dto/PersonSkillChangeStaff";
import { PersonSkillStaff } from "../../generated/dto/PersonSkillStaff";
import { PersonStaff } from "../../generated/dto/PersonStaff";
import { PersonTagStaff } from "../../generated/dto/PersonTagStaff";
import { PrinterStaff } from "../../generated/dto/PrinterStaff";
import { ProductStaff } from "../../generated/dto/ProductStaff";
import { PurchaseDeliveryStaff } from "../../generated/dto/PurchaseDeliveryStaff";
import { RatingChangeStaff } from "../../generated/dto/RatingChangeStaff";
import { RatingProgramStaff } from "../../generated/dto/RatingProgramStaff";
import { RatingStaff } from "../../generated/dto/RatingStaff";
import { ReportRunStaff } from "../../generated/dto/ReportRunStaff";
import { RoleAssignmentStaff } from "../../generated/dto/RoleAssignmentStaff";
import { RolePermissionStaff } from "../../generated/dto/RolePermissionStaff";
import { RoleStaff } from "../../generated/dto/RoleStaff";
import { ScopesStaff } from "../../generated/dto/ScopesStaff";
import { SignoutCrewStaff } from "../../generated/dto/SignoutCrewStaff";
import { SignoutStaff } from "../../generated/dto/SignoutStaff";
import { SkillAssessmentStaff } from "../../generated/dto/SkillAssessmentStaff";
import { StockChangeStaff } from "../../generated/dto/StockChangeStaff";
import { TestChildResource } from "../../generated/dto/TestChildResource";
import { TestResource } from "../../generated/dto/TestResource";
import { UserPermissionStaff } from "../../generated/dto/UserPermissionStaff";
import { UserStaff } from "../../generated/dto/UserStaff";
import { YearlyDateStaff } from "../../generated/dto/YearlyDateStaff";
import { cbiFrontendServiceContext } from "../context/CbiFrontendServiceContext";

type CbiDtoFieldCodec =
  | { readonly field: string; readonly kind: "date" | "date-time"; readonly collection: boolean }
  | { readonly field: string; readonly kind: "dto"; readonly dto: string; readonly collection: boolean };

const cbiDtoFieldCodecs: Readonly<Record<string, readonly CbiDtoFieldCodec[]>> = {
  "generated.dto.AddToCart": [
    { field: "itemInstance", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "parent", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "options", kind: "dto", dto: "org.communityboating.services.orders.purchasables.ProvisionOptions", collection: false },
    { field: "updateLine", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "generated.dto.Agreement": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.Catalog", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItemAgreement", collection: true },
    { field: "agreementInstances", kind: "dto", dto: "generated.dto.AgreementInstance", collection: true },
    { field: "agreementCategories", kind: "dto", dto: "generated.dto.AgreementCategory", collection: true },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.AgreementCategory": [
    { field: "agreementId", kind: "dto", dto: "generated.dto.Agreement", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.Category", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.AgreementCategoryDTOBase": [
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.AgreementCategoryMember": [
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.AgreementCategoryStaff": [
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementStaff", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CategoryStaff", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.AgreementDTOBase": [
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.AgreementInstance": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.Agreement", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.AgreementInstanceDTOBase": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.AgreementInstanceMember": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.AgreementInstanceSearchParams": [
    { field: "startActiveExact", kind: "date-time", collection: false },
    { field: "startActiveAnyOf", kind: "date-time", collection: true },
    { field: "startActiveLess", kind: "date-time", collection: false },
    { field: "startActiveLessEq", kind: "date-time", collection: false },
    { field: "startActiveGreater", kind: "date-time", collection: false },
    { field: "startActiveGreaterEq", kind: "date-time", collection: false },
    { field: "endActiveExact", kind: "date-time", collection: false },
    { field: "endActiveAnyOf", kind: "date-time", collection: true },
    { field: "endActiveLess", kind: "date-time", collection: false },
    { field: "endActiveLessEq", kind: "date-time", collection: false },
    { field: "endActiveGreater", kind: "date-time", collection: false },
    { field: "endActiveGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.AgreementInstanceStaff": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementStaff", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.AgreementMember": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogMember", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItemAgreementMember", collection: true },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.AgreementStaff": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogStaff", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItemAgreementStaff", collection: true },
    { field: "agreementInstances", kind: "dto", dto: "generated.dto.AgreementInstanceStaff", collection: true },
    { field: "agreementCategories", kind: "dto", dto: "generated.dto.AgreementCategoryStaff", collection: true },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.AgreementVersionChangeRequest": [
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.ApClass": [
    { field: "cancelByOverride", kind: "date-time", collection: false },
    { field: "signupsStartOverride", kind: "date-time", collection: false },
    { field: "cancelledDatetime", kind: "date-time", collection: false },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "formatId", kind: "dto", dto: "generated.dto.ApClassFormat", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocation", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "sessions", kind: "dto", dto: "generated.dto.ApClassSession", collection: true },
    { field: "signups", kind: "dto", dto: "generated.dto.ApClassSignup", collection: true },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassType", collection: false },
  ],
  "generated.dto.ApClassAttendance": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.ApClassSession", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignup", collection: false },
  ],
  "generated.dto.ApClassAttendanceDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassAttendanceMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassAttendanceStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.ApClassSessionStaff", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupStaff", collection: false },
  ],
  "generated.dto.ApClassDTOBase": [
    { field: "cancelByOverride", kind: "date-time", collection: false },
    { field: "signupsStartOverride", kind: "date-time", collection: false },
    { field: "cancelledDatetime", kind: "date-time", collection: false },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassFormat": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassType", collection: false },
    { field: "instances", kind: "dto", dto: "generated.dto.ApClass", collection: true },
  ],
  "generated.dto.ApClassFormatDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassFormatMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassFormatStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: false },
    { field: "instances", kind: "dto", dto: "generated.dto.ApClassStaff", collection: true },
  ],
  "generated.dto.ApClassMember": [
    { field: "cancelByOverride", kind: "date-time", collection: false },
    { field: "signupsStartOverride", kind: "date-time", collection: false },
    { field: "cancelledDatetime", kind: "date-time", collection: false },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassSearchParams": [
    { field: "cancelByOverrideExact", kind: "date-time", collection: false },
    { field: "cancelByOverrideAnyOf", kind: "date-time", collection: true },
    { field: "cancelByOverrideLess", kind: "date-time", collection: false },
    { field: "cancelByOverrideLessEq", kind: "date-time", collection: false },
    { field: "cancelByOverrideGreater", kind: "date-time", collection: false },
    { field: "cancelByOverrideGreaterEq", kind: "date-time", collection: false },
    { field: "signupsStartOverrideExact", kind: "date-time", collection: false },
    { field: "signupsStartOverrideAnyOf", kind: "date-time", collection: true },
    { field: "signupsStartOverrideLess", kind: "date-time", collection: false },
    { field: "signupsStartOverrideLessEq", kind: "date-time", collection: false },
    { field: "signupsStartOverrideGreater", kind: "date-time", collection: false },
    { field: "signupsStartOverrideGreaterEq", kind: "date-time", collection: false },
    { field: "cancelledDatetimeExact", kind: "date-time", collection: false },
    { field: "cancelledDatetimeAnyOf", kind: "date-time", collection: true },
    { field: "cancelledDatetimeLess", kind: "date-time", collection: false },
    { field: "cancelledDatetimeLessEq", kind: "date-time", collection: false },
    { field: "cancelledDatetimeGreater", kind: "date-time", collection: false },
    { field: "cancelledDatetimeGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassSession": [
    { field: "sessionDateTime", kind: "date-time", collection: false },
    { field: "cancelledDateTime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClass", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.ApClassAttendance", collection: true },
  ],
  "generated.dto.ApClassSessionDTOBase": [
    { field: "sessionDateTime", kind: "date-time", collection: false },
    { field: "cancelledDateTime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassSessionMember": [
    { field: "sessionDateTime", kind: "date-time", collection: false },
    { field: "cancelledDateTime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassSessionSearchParams": [
    { field: "sessionDateTimeExact", kind: "date-time", collection: false },
    { field: "sessionDateTimeAnyOf", kind: "date-time", collection: true },
    { field: "sessionDateTimeLess", kind: "date-time", collection: false },
    { field: "sessionDateTimeLessEq", kind: "date-time", collection: false },
    { field: "sessionDateTimeGreater", kind: "date-time", collection: false },
    { field: "sessionDateTimeGreaterEq", kind: "date-time", collection: false },
    { field: "cancelledDateTimeExact", kind: "date-time", collection: false },
    { field: "cancelledDateTimeAnyOf", kind: "date-time", collection: true },
    { field: "cancelledDateTimeLess", kind: "date-time", collection: false },
    { field: "cancelledDateTimeLessEq", kind: "date-time", collection: false },
    { field: "cancelledDateTimeGreater", kind: "date-time", collection: false },
    { field: "cancelledDateTimeGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassSessionStaff": [
    { field: "sessionDateTime", kind: "date-time", collection: false },
    { field: "cancelledDateTime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClassStaff", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.ApClassAttendanceStaff", collection: true },
  ],
  "generated.dto.ApClassSignup": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "lineItems", kind: "dto", dto: "generated.dto.LineItemRef", collection: true },
    { field: "wlResult", kind: "dto", dto: "generated.dto.ApClassWlResult", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClass", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.ApClassAttendance", collection: true },
  ],
  "generated.dto.ApClassSignupDTOBase": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassSignupMember": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "lineItems", kind: "dto", dto: "generated.dto.LineItemRef", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassSignupStaff": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "lineItems", kind: "dto", dto: "generated.dto.LineItemRef", collection: true },
    { field: "wlResult", kind: "dto", dto: "generated.dto.ApClassWlResultStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClassStaff", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.ApClassAttendanceStaff", collection: true },
  ],
  "generated.dto.ApClassStaff": [
    { field: "cancelByOverride", kind: "date-time", collection: false },
    { field: "signupsStartOverride", kind: "date-time", collection: false },
    { field: "cancelledDatetime", kind: "date-time", collection: false },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "formatId", kind: "dto", dto: "generated.dto.ApClassFormatStaff", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocationStaff", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "sessions", kind: "dto", dto: "generated.dto.ApClassSessionStaff", collection: true },
    { field: "signups", kind: "dto", dto: "generated.dto.ApClassSignupStaff", collection: true },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: false },
  ],
  "generated.dto.ApClassType": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.ApClassType", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.ApClassType", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "formats", kind: "dto", dto: "generated.dto.ApClassFormat", collection: true },
    { field: "typesRequiringThisAsPrereq", kind: "dto", dto: "generated.dto.ApClassType", collection: true },
    { field: "typesRequiringThisAsOverkill", kind: "dto", dto: "generated.dto.ApClassType", collection: true },
    { field: "classes", kind: "dto", dto: "generated.dto.ApClass", collection: true },
    { field: "overrides", kind: "dto", dto: "generated.dto.ApClassTypeOverride", collection: true },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.ApClassTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.ApClassTypeMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.ApClassTypeOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassType", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassTypeOverrideDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassTypeOverrideStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassTypeSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassTypeStaff": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "formats", kind: "dto", dto: "generated.dto.ApClassFormatStaff", collection: true },
    { field: "typesRequiringThisAsPrereq", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: true },
    { field: "typesRequiringThisAsOverkill", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: true },
    { field: "classes", kind: "dto", dto: "generated.dto.ApClassStaff", collection: true },
    { field: "overrides", kind: "dto", dto: "generated.dto.ApClassTypeOverrideStaff", collection: true },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.ApClassWlResult": [
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignup", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassWlResultDTOBase": [
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassWlResultMember": [
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupMember", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ApClassWlResultRef": [
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
  ],
  "generated.dto.ApClassWlResultStaff": [
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupStaff", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.AssessmentDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.AssessmentStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.AuthTokens": [
    { field: "accessToken", kind: "dto", dto: "org.communityboating.models.data.JwtToken", collection: false },
    { field: "refreshToken", kind: "dto", dto: "org.communityboating.models.data.JwtToken", collection: false },
  ],
  "generated.dto.BalanceDTOBase": [
    { field: "balanceExpirationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.BalanceLookupCooldownDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.BalanceLookupCooldownStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "balanceMatch", kind: "dto", dto: "generated.dto.BalanceStaff", collection: false },
  ],
  "generated.dto.BalanceMember": [
    { field: "balanceExpirationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "transactions", kind: "dto", dto: "generated.dto.BalanceTransactionMember", collection: true },
  ],
  "generated.dto.BalanceMemberPage": [
    { field: "items", kind: "dto", dto: "generated.dto.BalanceMember", collection: true },
  ],
  "generated.dto.BalanceSaveRequest": [
    { field: "balanceExpirationDate", kind: "date-time", collection: false },
    { field: "people", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
  ],
  "generated.dto.BalanceSearchOptions": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.BalanceSearchParams": [
    { field: "balanceExpirationDateExact", kind: "date-time", collection: false },
    { field: "balanceExpirationDateAnyOf", kind: "date-time", collection: true },
    { field: "balanceExpirationDateLess", kind: "date-time", collection: false },
    { field: "balanceExpirationDateLessEq", kind: "date-time", collection: false },
    { field: "balanceExpirationDateGreater", kind: "date-time", collection: false },
    { field: "balanceExpirationDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.BalanceStaff": [
    { field: "balanceExpirationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "balanceOwner", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "personBalances", kind: "dto", dto: "generated.dto.PersonBalanceStaff", collection: true },
    { field: "transactions", kind: "dto", dto: "generated.dto.BalanceTransactionStaff", collection: true },
  ],
  "generated.dto.BalanceStaffPage": [
    { field: "items", kind: "dto", dto: "generated.dto.BalanceStaff", collection: true },
  ],
  "generated.dto.BalanceTransactionDTOBase": [
    { field: "transactionDateTime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.BalanceTransactionMember": [
    { field: "transactionDateTime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.BalanceTransactionSearchParams": [
    { field: "transactionDateTimeExact", kind: "date-time", collection: false },
    { field: "transactionDateTimeAnyOf", kind: "date-time", collection: true },
    { field: "transactionDateTimeLess", kind: "date-time", collection: false },
    { field: "transactionDateTimeLessEq", kind: "date-time", collection: false },
    { field: "transactionDateTimeGreater", kind: "date-time", collection: false },
    { field: "transactionDateTimeGreaterEq", kind: "date-time", collection: false },
    { field: "purchaseDateExact", kind: "date-time", collection: false },
    { field: "purchaseDateAnyOf", kind: "date-time", collection: true },
    { field: "purchaseDateLess", kind: "date-time", collection: false },
    { field: "purchaseDateLessEq", kind: "date-time", collection: false },
    { field: "purchaseDateGreater", kind: "date-time", collection: false },
    { field: "purchaseDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.BalanceTransactionStaff": [
    { field: "transactionDateTime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "balanceId", kind: "dto", dto: "generated.dto.BalanceStaff", collection: false },
  ],
  "generated.dto.BoatTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.BoatTypeMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.BoatTypeStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CacheStatusDTOBase": [
    { field: "lastUpdated", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CacheStatusStaff": [
    { field: "lastUpdated", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.Card": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "issueDate", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CardDTOBase": [
    { field: "issueDate", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CardEditCardRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "card", kind: "dto", dto: "generated.dto.CardRef", collection: false },
  ],
  "generated.dto.CardIssueFreeCardRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "issueDate", kind: "date-time", collection: false },
  ],
  "generated.dto.CardMember": [
    { field: "issueDate", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CardSearchParams": [
    { field: "issueDateExact", kind: "date-time", collection: false },
    { field: "issueDateAnyOf", kind: "date-time", collection: true },
    { field: "issueDateLess", kind: "date-time", collection: false },
    { field: "issueDateLessEq", kind: "date-time", collection: false },
    { field: "issueDateGreater", kind: "date-time", collection: false },
    { field: "issueDateGreaterEq", kind: "date-time", collection: false },
    { field: "purchaseDateExact", kind: "date-time", collection: false },
    { field: "purchaseDateAnyOf", kind: "date-time", collection: true },
    { field: "purchaseDateLess", kind: "date-time", collection: false },
    { field: "purchaseDateLessEq", kind: "date-time", collection: false },
    { field: "purchaseDateGreater", kind: "date-time", collection: false },
    { field: "purchaseDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.CardStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "issueDate", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CashDrawerAddCashRequest": [
    { field: "drawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "generated.dto.CashDrawerChangeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CashDrawerChangeStaff": [
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CashDrawerDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CashDrawerDayChangesRequest": [
    { field: "drawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
    { field: "date", kind: "date", collection: false },
  ],
  "generated.dto.CashDrawerOpenDayRequest": [
    { field: "drawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
    { field: "date", kind: "date", collection: false },
  ],
  "generated.dto.CashDrawerRemoveCashRequest": [
    { field: "drawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "generated.dto.CashDrawerSaveCountRequest": [
    { field: "total", kind: "dto", dto: "generated.dto.CashDrawerTotalRef", collection: false },
  ],
  "generated.dto.CashDrawerSaveStartingCountRequest": [
    { field: "total", kind: "dto", dto: "generated.dto.CashDrawerTotalRef", collection: false },
  ],
  "generated.dto.CashDrawerSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.CashDrawerStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "printer", kind: "dto", dto: "generated.dto.PrinterStaff", collection: false },
    { field: "changes", kind: "dto", dto: "generated.dto.CashDrawerChangeStaff", collection: true },
    { field: "totals", kind: "dto", dto: "generated.dto.CashDrawerTotalStaff", collection: true },
  ],
  "generated.dto.CashDrawerTotalDTOBase": [
    { field: "reportDate", kind: "date", collection: false },
    { field: "finalizedOn", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CashDrawerTotalStaff": [
    { field: "reportDate", kind: "date", collection: false },
    { field: "finalizedOn", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerStaff", collection: false },
  ],
  "generated.dto.CashTransactionDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CashTransactionStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.Catalog": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItem", collection: true },
    { field: "products", kind: "dto", dto: "generated.dto.Product", collection: true },
    { field: "agreements", kind: "dto", dto: "generated.dto.Agreement", collection: true },
    { field: "taxes", kind: "dto", dto: "generated.dto.CatalogTax", collection: true },
    { field: "discounts", kind: "dto", dto: "generated.dto.CatalogDiscount", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogDTOBase": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogDiscount": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.Catalog", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CatalogDiscountCategory", collection: false },
    { field: "discountInstances", kind: "dto", dto: "generated.dto.CatalogDiscountInstance", collection: true },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountCategoryRef", collection: false },
  ],
  "generated.dto.CatalogDiscountCategory": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discounts", kind: "dto", dto: "generated.dto.CatalogDiscount", collection: true },
  ],
  "generated.dto.CatalogDiscountCategoryDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogDiscountCategoryMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogDiscountCategoryStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discounts", kind: "dto", dto: "generated.dto.CatalogDiscountStaff", collection: true },
  ],
  "generated.dto.CatalogDiscountDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountCategoryRef", collection: false },
  ],
  "generated.dto.CatalogDiscountInstance": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscount", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogDiscountInstanceDTOBase": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogDiscountInstanceMember": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogDiscountInstanceStaff": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountStaff", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogDiscountMember": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountCategoryRef", collection: false },
  ],
  "generated.dto.CatalogDiscountSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogDiscountStaff": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CatalogDiscountCategoryStaff", collection: false },
    { field: "discountInstances", kind: "dto", dto: "generated.dto.CatalogDiscountInstanceStaff", collection: true },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountCategoryRef", collection: false },
  ],
  "generated.dto.CatalogItem": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.Catalog", collection: false },
    { field: "itemInstances", kind: "dto", dto: "generated.dto.CatalogItemInstance", collection: true },
    { field: "categories", kind: "dto", dto: "generated.dto.CatalogItemCategory", collection: true },
    { field: "agreements", kind: "dto", dto: "generated.dto.CatalogItemAgreement", collection: true },
    { field: "taxes", kind: "dto", dto: "generated.dto.CatalogItemTax", collection: true },
    { field: "itemDiscounts", kind: "dto", dto: "generated.dto.CatalogItemDiscount", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "productId", kind: "dto", dto: "generated.dto.Product", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "productIdTargetIds", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
  ],
  "generated.dto.CatalogItemAgreement": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItem", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.Agreement", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.CatalogItemAgreementDTOBase": [
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.CatalogItemAgreementMember": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemMember", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementMember", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.CatalogItemAgreementStaff": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemStaff", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementStaff", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.CatalogItemAgreementsInternalAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemAgreementsInternalAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogItemAgreementsStaffAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemAgreementsStaffAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogItemCategoriesInternalAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemCategoriesInternalAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogItemCategoriesStaffAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemCategoriesStaffAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogItemCategory": [
    { field: "item", kind: "dto", dto: "generated.dto.CatalogItem", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.Category", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.CatalogItemCategoryDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.CatalogItemCategoryMember": [
    { field: "item", kind: "dto", dto: "generated.dto.CatalogItemMember", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CategoryMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.CatalogItemCategoryStaff": [
    { field: "item", kind: "dto", dto: "generated.dto.CatalogItemStaff", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CategoryStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "categoryIdTargetIds", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.CatalogItemDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "productIdTargetIds", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
  ],
  "generated.dto.CatalogItemDiscount": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItem", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscount", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogItemDiscountDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogItemDiscountMember": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemMember", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogItemDiscountStaff": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemStaff", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "discountIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CatalogItemInstance": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItem", collection: false },
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "stockChanges", kind: "dto", dto: "generated.dto.StockChange", collection: true },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
  ],
  "generated.dto.CatalogItemInstanceDTOBase": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
  ],
  "generated.dto.CatalogItemInstanceMember": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemMember", collection: false },
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
  ],
  "generated.dto.CatalogItemInstanceStaff": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemStaff", collection: false },
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "stockChanges", kind: "dto", dto: "generated.dto.StockChangeStaff", collection: true },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
  ],
  "generated.dto.CatalogItemItemDiscountsInternalAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemItemDiscountsInternalAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogItemItemDiscountsStaffAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemItemDiscountsStaffAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogItemMember": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogMember", collection: false },
    { field: "itemInstances", kind: "dto", dto: "generated.dto.CatalogItemInstanceMember", collection: true },
    { field: "categories", kind: "dto", dto: "generated.dto.CatalogItemCategoryMember", collection: true },
    { field: "agreements", kind: "dto", dto: "generated.dto.CatalogItemAgreementMember", collection: true },
    { field: "taxes", kind: "dto", dto: "generated.dto.CatalogItemTaxMember", collection: true },
    { field: "itemDiscounts", kind: "dto", dto: "generated.dto.CatalogItemDiscountMember", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "productIdTargetIds", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
  ],
  "generated.dto.CatalogItemSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogItemStaff": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogStaff", collection: false },
    { field: "itemInstances", kind: "dto", dto: "generated.dto.CatalogItemInstanceStaff", collection: true },
    { field: "categories", kind: "dto", dto: "generated.dto.CatalogItemCategoryStaff", collection: true },
    { field: "agreements", kind: "dto", dto: "generated.dto.CatalogItemAgreementStaff", collection: true },
    { field: "taxes", kind: "dto", dto: "generated.dto.CatalogItemTaxStaff", collection: true },
    { field: "itemDiscounts", kind: "dto", dto: "generated.dto.CatalogItemDiscountStaff", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "productId", kind: "dto", dto: "generated.dto.ProductStaff", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "productIdTargetIds", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
  ],
  "generated.dto.CatalogItemTax": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItem", collection: false },
    { field: "taxId", kind: "dto", dto: "generated.dto.CatalogTax", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "taxIdTargetIds", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
  ],
  "generated.dto.CatalogItemTaxDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "taxIdTargetIds", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
  ],
  "generated.dto.CatalogItemTaxMember": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemMember", collection: false },
    { field: "taxId", kind: "dto", dto: "generated.dto.CatalogTaxMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "taxIdTargetIds", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
  ],
  "generated.dto.CatalogItemTaxStaff": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemStaff", collection: false },
    { field: "taxId", kind: "dto", dto: "generated.dto.CatalogTaxStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "taxIdTargetIds", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
  ],
  "generated.dto.CatalogItemTaxesInternalAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemTaxesInternalAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogItemTaxesStaffAssignmentInput": [
    { field: "target", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CatalogItemTaxesStaffAssignmentOptions", collection: false },
  ],
  "generated.dto.CatalogMember": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItemMember", collection: true },
    { field: "products", kind: "dto", dto: "generated.dto.ProductMember", collection: true },
    { field: "agreements", kind: "dto", dto: "generated.dto.AgreementMember", collection: true },
    { field: "taxes", kind: "dto", dto: "generated.dto.CatalogTaxMember", collection: true },
    { field: "discounts", kind: "dto", dto: "generated.dto.CatalogDiscountMember", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogPriceChangeRequest": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
  ],
  "generated.dto.CatalogSearchParams": [
    { field: "startActiveExact", kind: "date-time", collection: false },
    { field: "startActiveAnyOf", kind: "date-time", collection: true },
    { field: "startActiveLess", kind: "date-time", collection: false },
    { field: "startActiveLessEq", kind: "date-time", collection: false },
    { field: "startActiveGreater", kind: "date-time", collection: false },
    { field: "startActiveGreaterEq", kind: "date-time", collection: false },
    { field: "endActiveExact", kind: "date-time", collection: false },
    { field: "endActiveAnyOf", kind: "date-time", collection: true },
    { field: "endActiveLess", kind: "date-time", collection: false },
    { field: "endActiveLessEq", kind: "date-time", collection: false },
    { field: "endActiveGreater", kind: "date-time", collection: false },
    { field: "endActiveGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogStaff": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItemStaff", collection: true },
    { field: "products", kind: "dto", dto: "generated.dto.ProductStaff", collection: true },
    { field: "agreements", kind: "dto", dto: "generated.dto.AgreementStaff", collection: true },
    { field: "taxes", kind: "dto", dto: "generated.dto.CatalogTaxStaff", collection: true },
    { field: "discounts", kind: "dto", dto: "generated.dto.CatalogDiscountStaff", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogTax": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.Catalog", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.CatalogTaxDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.CatalogTaxMember": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.CatalogTaxSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.CatalogTaxStaff": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.Category": [
    { field: "itemCategories", kind: "dto", dto: "generated.dto.CatalogItemCategory", collection: true },
    { field: "agreementCategories", kind: "dto", dto: "generated.dto.AgreementCategory", collection: true },
  ],
  "generated.dto.CategoryMember": [
    { field: "itemCategories", kind: "dto", dto: "generated.dto.CatalogItemCategoryMember", collection: true },
  ],
  "generated.dto.CategoryStaff": [
    { field: "itemCategories", kind: "dto", dto: "generated.dto.CatalogItemCategoryStaff", collection: true },
    { field: "agreementCategories", kind: "dto", dto: "generated.dto.AgreementCategoryStaff", collection: true },
  ],
  "generated.dto.CheckoutReadiness": [
    { field: "problems", kind: "dto", dto: "org.communityboating.services.orders.CheckoutProblem", collection: true },
  ],
  "generated.dto.ClassAvailability": [
    { field: "availableOn", kind: "date-time", collection: false },
    { field: "catalogItemInstanceId", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
    { field: "staggers", kind: "dto", dto: "generated.dto.ClassAvailabilityStagger", collection: true },
  ],
  "generated.dto.ClassAvailabilityStagger": [
    { field: "staggerDate", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassEligibility": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "checks", kind: "dto", dto: "generated.dto.ClassEligibilityCheck", collection: true },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "purchaseHoldExpiresOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassEnrollmentResult": [
    { field: "signup", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.ClassLocation": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "apClasses", kind: "dto", dto: "generated.dto.ApClass", collection: true },
    { field: "jpClasses", kind: "dto", dto: "generated.dto.JpClass", collection: true },
  ],
  "generated.dto.ClassLocationDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassLocationMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassLocationStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "apClasses", kind: "dto", dto: "generated.dto.ApClassStaff", collection: true },
    { field: "jpClasses", kind: "dto", dto: "generated.dto.JpClassStaff", collection: true },
  ],
  "generated.dto.ClassSessionUnified": [
    { field: "sessionDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassSignupBaseBase": [
    { field: "signupDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassSignupUnified": [
    { field: "signupDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassUnifiedCompareClassesRequest": [
    { field: "options", kind: "dto", dto: "org.communityboating.services.classes.UnifiedClassSearchOptions", collection: false },
  ],
  "generated.dto.ClassUnifiedCreateGuidedSailRequest": [
    { field: "timeslot", kind: "date-time", collection: false },
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.ClassUnifiedDTOBase": [
    { field: "sessions", kind: "dto", dto: "generated.dto.ClassSessionUnified", collection: true },
  ],
  "generated.dto.ClassUnifiedEnrollInstructorRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.ClassUnifiedEnrollRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "overrides", kind: "dto", dto: "org.communityboating.services.classes.ClassEnrollmentOverrides", collection: false },
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.ClassUnifiedGuidedSailTimeslotsRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.ClassUnifiedMember": [
    { field: "classType", kind: "dto", dto: "generated.dto.ClassTypeUnified", collection: false },
    { field: "sessions", kind: "dto", dto: "generated.dto.ClassSessionUnified", collection: true },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "eligibility", kind: "dto", dto: "generated.dto.ClassEligibility", collection: true },
  ],
  "generated.dto.ClassUnifiedPublic": [
    { field: "sessions", kind: "dto", dto: "generated.dto.ClassSessionUnified", collection: true },
  ],
  "generated.dto.ClassUnifiedSavePersonClassOverrideRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.ClassUnifiedSearchClassUnifiedRequest": [
    { field: "params", kind: "dto", dto: "org.communityboating.services.classes.ClassUnifiedStaffSearchParams", collection: false },
  ],
  "generated.dto.ClassUnifiedStaff": [
    { field: "classType", kind: "dto", dto: "generated.dto.ClassTypeUnified", collection: false },
    { field: "sessions", kind: "dto", dto: "generated.dto.ClassSessionUnified", collection: true },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "eligibility", kind: "dto", dto: "generated.dto.ClassEligibility", collection: true },
    { field: "signups", kind: "dto", dto: "generated.dto.ClassSignupUnified", collection: true },
    { field: "waitlistResults", kind: "dto", dto: "generated.dto.ClassWlResultUnified", collection: true },
  ],
  "generated.dto.ClassUnifiedUnenrollInstructorRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.ClassUnifiedUnenrollRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.ClassWlResultBaseBase": [
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.ClassWlResultUnified": [
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.CompleteMemberRegistration": [
    { field: "identity", kind: "dto", dto: "org.communityboating.services.people.CompleteMemberProfile", collection: false },
    { field: "profile", kind: "dto", dto: "org.communityboating.services.people.MemberProfileUpdate", collection: false },
  ],
  "generated.dto.ConfigureDelivery": [
    { field: "personLookup", kind: "dto", dto: "generated.dto.PersonLookupRef", collection: false },
    { field: "targetPerson", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "targetAddress", kind: "dto", dto: "generated.dto.AddressRef", collection: false },
  ],
  "generated.dto.CreateAgreement": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.CreateAgreementCategory": [
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.CreateAgreementInstance": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.CreateApClass": [
    { field: "cancelByOverride", kind: "date-time", collection: false },
    { field: "signupsStartOverride", kind: "date-time", collection: false },
    { field: "cancelledDatetime", kind: "date-time", collection: false },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "formatId", kind: "dto", dto: "generated.dto.ApClassFormatRef", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocationRef", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
  ],
  "generated.dto.CreateApClassAttendance": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.ApClassSessionRef", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
  ],
  "generated.dto.CreateApClassFormat": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
  ],
  "generated.dto.CreateApClassSession": [
    { field: "sessionDateTime", kind: "date-time", collection: false },
    { field: "cancelledDateTime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClassRef", collection: false },
  ],
  "generated.dto.CreateApClassSignup": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClassRef", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.CreateApClassType": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateApClassTypeOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateApClassWlResult": [
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateBoatType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateCashDrawer": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "printer", kind: "dto", dto: "generated.dto.PrinterRef", collection: false },
  ],
  "generated.dto.CreateCatalog": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateCatalogDiscount": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CatalogDiscountCategoryRef", collection: false },
  ],
  "generated.dto.CreateCatalogDiscountCategory": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateCatalogDiscountInstance": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.CreateCatalogItemAgreement": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.CreateCatalogItemCategory": [
    { field: "item", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateCatalogItemDTOBase": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "productId", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
  ],
  "generated.dto.CreateCatalogItemDiscount": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateCatalogItemInstance": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateCatalogItemStaff": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "productId", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
    { field: "categoriesAssignments", kind: "dto", dto: "generated.dto.CatalogItemCategoriesStaffAssignmentInput", collection: true },
    { field: "agreementsAssignments", kind: "dto", dto: "generated.dto.CatalogItemAgreementsStaffAssignmentInput", collection: true },
    { field: "taxesAssignments", kind: "dto", dto: "generated.dto.CatalogItemTaxesStaffAssignmentInput", collection: true },
    { field: "itemDiscountsAssignments", kind: "dto", dto: "generated.dto.CatalogItemItemDiscountsStaffAssignmentInput", collection: true },
  ],
  "generated.dto.CreateCatalogItemTax": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "taxId", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateCatalogTax": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateClassLocation": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateDamageWaiverType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateDatetimeRange": [
    { field: "startDatetime", kind: "date-time", collection: false },
    { field: "endDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateDonation": [
    { field: "fundId", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "initiativeId", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "donationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.CreateDonationFundDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateDonationFundStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateDonationInitiative": [
    { field: "targetFund", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateEiiOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateJpClass": [
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocationRef", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.CreateJpClassAttendance": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.JpClassSessionRef", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupRef", collection: false },
  ],
  "generated.dto.CreateJpClassSession": [
    { field: "sessionDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassRef", collection: false },
  ],
  "generated.dto.CreateJpClassSignup": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassRef", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.CreateJpClassStagger": [
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassRef", collection: false },
    { field: "staggerDate", kind: "date-time", collection: false },
    { field: "reserveRelease", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateJpClassType": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateJpClassTypeOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateJpClassWlResult": [
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupRef", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "preapprovedExp", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateMembershipType": [
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateMembershipTypeDiscount": [
    { field: "membershipTypeId", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePersonAddress": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "addressId", kind: "dto", dto: "generated.dto.AddressRef", collection: false },
  ],
  "generated.dto.CreatePersonDTOBase": [
    { field: "dob", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePersonMember": [
    { field: "dob", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePersonPersonType": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePersonPhone": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "phoneId", kind: "dto", dto: "generated.dto.PhoneRef", collection: false },
  ],
  "generated.dto.CreatePersonReferral": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePersonRelation": [
    { field: "aPersonId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "bPersonId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePersonStaff": [
    { field: "personType", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
    { field: "dob", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePersonType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePrinterDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreatePrinterStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateProduct": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateRating": [
    { field: "overriddenBy", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateRatingProgram": [
    { field: "ratingId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateRoleAssignment": [
    { field: "userId", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "roleId", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
    { field: "assignedBy", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "assignedOn", kind: "date", collection: false },
  ],
  "generated.dto.CreateRolePermission": [
    { field: "roleId", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
    { field: "scopeId", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
  ],
  "generated.dto.CreateStockChange": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemInstanceId", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.CreateSunsetTime": [
    { field: "forDate", kind: "date-time", collection: false },
    { field: "sunset", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateSwimProofMethod": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateTag": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateTestChildResource": [
    { field: "testResource", kind: "dto", dto: "generated.dto.TestResourceRef", collection: false },
  ],
  "generated.dto.CreateTestResource": [
    { field: "testFieldDate", kind: "date", collection: false },
    { field: "testFieldDateTime", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateUserDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateUserPermission": [
    { field: "userId", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "scopeId", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
    { field: "assignedBy", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "assignedOn", kind: "date", collection: false },
  ],
  "generated.dto.CreateUserStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.CreateYearlyDate": [
    { field: "itemId", kind: "dto", dto: "generated.dto.YearlyDateItemRef", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "endDate", kind: "date-time", collection: false },
  ],
  "generated.dto.DailySalesCategoryAmountDTOBase": [
    { field: "rowId", kind: "dto", dto: "generated.dto.DailySalesReportRef", collection: false },
  ],
  "generated.dto.DailySalesCategoryAmountStaff": [
    { field: "rowId", kind: "dto", dto: "generated.dto.DailySalesReportRef", collection: false },
  ],
  "generated.dto.DailySalesDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "categories", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesCategory", collection: true },
    { field: "summary", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesSummary", collection: false },
  ],
  "generated.dto.DailySalesPaymentTypeAmountDTOBase": [
    { field: "rowId", kind: "dto", dto: "generated.dto.DailySalesReportRef", collection: false },
  ],
  "generated.dto.DailySalesPaymentTypeAmountStaff": [
    { field: "rowId", kind: "dto", dto: "generated.dto.DailySalesReportRef", collection: false },
  ],
  "generated.dto.DailySalesReportDTOBase": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "forDate", kind: "date", collection: false },
  ],
  "generated.dto.DailySalesReportSearchParams": [
    { field: "forDateExact", kind: "date", collection: false },
    { field: "forDateAnyOf", kind: "date", collection: true },
    { field: "forDateLess", kind: "date", collection: false },
    { field: "forDateLessEq", kind: "date", collection: false },
    { field: "forDateGreater", kind: "date", collection: false },
    { field: "forDateGreaterEq", kind: "date", collection: false },
  ],
  "generated.dto.DailySalesReportStaff": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "forDate", kind: "date", collection: false },
    { field: "categoryAmounts", kind: "dto", dto: "generated.dto.DailySalesCategoryAmountStaff", collection: true },
    { field: "paymentTypeAmounts", kind: "dto", dto: "generated.dto.DailySalesPaymentTypeAmountStaff", collection: true },
  ],
  "generated.dto.DailySalesRequest": [
    { field: "createdOnStart", kind: "date", collection: false },
    { field: "createdOnEnd", kind: "date", collection: false },
    { field: "capturableOnStart", kind: "date", collection: false },
    { field: "capturableOnEnd", kind: "date", collection: false },
    { field: "dateStart", kind: "date", collection: false },
    { field: "dateEnd", kind: "date", collection: false },
  ],
  "generated.dto.DailySalesStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesDataset", collection: false },
  ],
  "generated.dto.DailySalesSummary": [
    { field: "categoryAmounts", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesCategoryTotal", collection: true },
    { field: "paymentTypeAmounts", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesPaymentTotal", collection: true },
  ],
  "generated.dto.DamageWaiver": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "expirationDate", kind: "date-time", collection: false },
    { field: "damageWaiverTypeId", kind: "dto", dto: "generated.dto.DamageWaiverType", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "damageWaiverTypeIdTargetIds", kind: "dto", dto: "generated.dto.DamageWaiverTypeRef", collection: false },
  ],
  "generated.dto.DamageWaiverDTOBase": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "expirationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "damageWaiverTypeIdTargetIds", kind: "dto", dto: "generated.dto.DamageWaiverTypeRef", collection: false },
  ],
  "generated.dto.DamageWaiverMember": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "expirationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "damageWaiverTypeIdTargetIds", kind: "dto", dto: "generated.dto.DamageWaiverTypeRef", collection: false },
  ],
  "generated.dto.DamageWaiverSearchParams": [
    { field: "purchaseDateExact", kind: "date-time", collection: false },
    { field: "purchaseDateAnyOf", kind: "date-time", collection: true },
    { field: "purchaseDateLess", kind: "date-time", collection: false },
    { field: "purchaseDateLessEq", kind: "date-time", collection: false },
    { field: "purchaseDateGreater", kind: "date-time", collection: false },
    { field: "purchaseDateGreaterEq", kind: "date-time", collection: false },
    { field: "startDateExact", kind: "date-time", collection: false },
    { field: "startDateAnyOf", kind: "date-time", collection: true },
    { field: "startDateLess", kind: "date-time", collection: false },
    { field: "startDateLessEq", kind: "date-time", collection: false },
    { field: "startDateGreater", kind: "date-time", collection: false },
    { field: "startDateGreaterEq", kind: "date-time", collection: false },
    { field: "expirationDateExact", kind: "date-time", collection: false },
    { field: "expirationDateAnyOf", kind: "date-time", collection: true },
    { field: "expirationDateLess", kind: "date-time", collection: false },
    { field: "expirationDateLessEq", kind: "date-time", collection: false },
    { field: "expirationDateGreater", kind: "date-time", collection: false },
    { field: "expirationDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DamageWaiverStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "expirationDate", kind: "date-time", collection: false },
    { field: "damageWaiverTypeId", kind: "dto", dto: "generated.dto.DamageWaiverTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "damageWaiverTypeIdTargetIds", kind: "dto", dto: "generated.dto.DamageWaiverTypeRef", collection: false },
  ],
  "generated.dto.DamageWaiverType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DamageWaiverTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DamageWaiverTypeMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DamageWaiverTypeSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DamageWaiverTypeStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DatetimeRangeDTOBase": [
    { field: "startDatetime", kind: "date-time", collection: false },
    { field: "endDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.DatetimeRangeStaff": [
    { field: "startDatetime", kind: "date-time", collection: false },
    { field: "endDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.DeleteApClassWlResultStaff": [
    { field: "signupId", kind: "dto", dto: "generated.dto.DeleteApClassSignupStaff", collection: false },
  ],
  "generated.dto.DeleteJpClassWlResultStaff": [
    { field: "signupId", kind: "dto", dto: "generated.dto.DeleteJpClassSignupStaff", collection: false },
  ],
  "generated.dto.DiscountCandidate": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "generated.dto.DiscountOnLines": [
    { field: "discount", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
    { field: "lineItems", kind: "dto", dto: "generated.dto.LineItemRef", collection: true },
  ],
  "generated.dto.DiscountVersionChangeRequest": [
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.DonationDTOBase": [
    { field: "donationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "fundIdTargetIds", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "initiativeIdTargetIds", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
  ],
  "generated.dto.DonationFundDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationFundMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationFundSearchParamsDTOBase": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationFundStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationFundStaffSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationInitiativeDTOBase": [
    { field: "targetFund", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationInitiativeMember": [
    { field: "targetFund", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationInitiativeSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationInitiativeStaff": [
    { field: "targetFund", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationMember": [
    { field: "donationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "fundIdTargetIds", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "initiativeIdTargetIds", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
  ],
  "generated.dto.DonationMemberSearchParams": [
    { field: "donationDateExact", kind: "date-time", collection: false },
    { field: "donationDateAnyOf", kind: "date-time", collection: true },
    { field: "donationDateLess", kind: "date-time", collection: false },
    { field: "donationDateLessEq", kind: "date-time", collection: false },
    { field: "donationDateGreater", kind: "date-time", collection: false },
    { field: "donationDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationPurchaseDetails": [
    { field: "fund", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "initiative", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
  ],
  "generated.dto.DonationSearchParams": [
    { field: "purchaseDateExact", kind: "date-time", collection: false },
    { field: "purchaseDateAnyOf", kind: "date-time", collection: true },
    { field: "purchaseDateLess", kind: "date-time", collection: false },
    { field: "purchaseDateLessEq", kind: "date-time", collection: false },
    { field: "purchaseDateGreater", kind: "date-time", collection: false },
    { field: "purchaseDateGreaterEq", kind: "date-time", collection: false },
    { field: "donationDateExact", kind: "date-time", collection: false },
    { field: "donationDateAnyOf", kind: "date-time", collection: true },
    { field: "donationDateLess", kind: "date-time", collection: false },
    { field: "donationDateLessEq", kind: "date-time", collection: false },
    { field: "donationDateGreater", kind: "date-time", collection: false },
    { field: "donationDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationSearchParamsDTOBase": [
    { field: "donationDateExact", kind: "date-time", collection: false },
    { field: "donationDateAnyOf", kind: "date-time", collection: true },
    { field: "donationDateLess", kind: "date-time", collection: false },
    { field: "donationDateLessEq", kind: "date-time", collection: false },
    { field: "donationDateGreater", kind: "date-time", collection: false },
    { field: "donationDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.DonationStaff": [
    { field: "fundId", kind: "dto", dto: "generated.dto.DonationFundStaff", collection: false },
    { field: "initiativeId", kind: "dto", dto: "generated.dto.DonationInitiativeStaff", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "donationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "fundIdTargetIds", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "initiativeIdTargetIds", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
  ],
  "generated.dto.EiiApplicationStatus": [
    { field: "application", kind: "dto", dto: "org.communityboating.services.orders.EiiApplication", collection: false },
  ],
  "generated.dto.EiiCreateResponseRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.EiiStaffResponseRequest", collection: false },
  ],
  "generated.dto.EiiOverrideDTOBase": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.EiiOverrideSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.EiiOverrideStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.EiiResponseDTOBase": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.EiiResponseSearchParamsDTOBase": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.EiiResponseStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.EiiResponseStaffSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.EiiUpdateResponseRequest": [
    { field: "response", kind: "dto", dto: "generated.dto.EiiResponseRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.EiiStaffResponseRequest", collection: false },
  ],
  "generated.dto.EmailDeliveryResult": [
    { field: "email", kind: "dto", dto: "generated.dto.EmailTrackingRef", collection: false },
  ],
  "generated.dto.GuestPrivilege": [
    { field: "membershipId", kind: "dto", dto: "generated.dto.Membership", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.GuestPrivilegeDTOBase": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.GuestPrivilegeStaff": [
    { field: "membershipId", kind: "dto", dto: "generated.dto.MembershipStaff", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.GuidedSailDay": [
    { field: "date", kind: "date", collection: false },
    { field: "slots", kind: "dto", dto: "org.communityboating.services.classes.GuidedSailSlot", collection: true },
  ],
  "generated.dto.GuidedSailSlot": [
    { field: "start", kind: "date-time", collection: false },
    { field: "end", kind: "date-time", collection: false },
  ],
  "generated.dto.InvalidOrderDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "generated.dto.InvalidOrderRangeRun": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.reporting.InvalidOrderRequest", collection: false },
    { field: "requestedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.InvalidOrderReasonDTOBase": [
    { field: "reportId", kind: "dto", dto: "generated.dto.InvalidOrderReportRef", collection: false },
  ],
  "generated.dto.InvalidOrderReasonStaff": [
    { field: "reportId", kind: "dto", dto: "generated.dto.InvalidOrderReportRef", collection: false },
  ],
  "generated.dto.InvalidOrderReportDTOBase": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "orderId", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "checkedAt", kind: "date-time", collection: false },
    { field: "checkoutAt", kind: "date-time", collection: false },
    { field: "paidOn", kind: "date", collection: false },
  ],
  "generated.dto.InvalidOrderReportSearchParams": [
    { field: "checkedAtExact", kind: "date-time", collection: false },
    { field: "checkedAtAnyOf", kind: "date-time", collection: true },
    { field: "checkedAtLess", kind: "date-time", collection: false },
    { field: "checkedAtLessEq", kind: "date-time", collection: false },
    { field: "checkedAtGreater", kind: "date-time", collection: false },
    { field: "checkedAtGreaterEq", kind: "date-time", collection: false },
    { field: "checkoutAtExact", kind: "date-time", collection: false },
    { field: "checkoutAtAnyOf", kind: "date-time", collection: true },
    { field: "checkoutAtLess", kind: "date-time", collection: false },
    { field: "checkoutAtLessEq", kind: "date-time", collection: false },
    { field: "checkoutAtGreater", kind: "date-time", collection: false },
    { field: "checkoutAtGreaterEq", kind: "date-time", collection: false },
    { field: "paidOnExact", kind: "date", collection: false },
    { field: "paidOnAnyOf", kind: "date", collection: true },
    { field: "paidOnLess", kind: "date", collection: false },
    { field: "paidOnLessEq", kind: "date", collection: false },
    { field: "paidOnGreater", kind: "date", collection: false },
    { field: "paidOnGreaterEq", kind: "date", collection: false },
  ],
  "generated.dto.InvalidOrderReportStaff": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "orderId", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "checkedAt", kind: "date-time", collection: false },
    { field: "checkoutAt", kind: "date-time", collection: false },
    { field: "paidOn", kind: "date", collection: false },
    { field: "reasons", kind: "dto", dto: "generated.dto.InvalidOrderReasonStaff", collection: true },
  ],
  "generated.dto.InvalidOrderRequest": [
    { field: "paidOnStart", kind: "date", collection: false },
    { field: "paidOnEnd", kind: "date", collection: false },
  ],
  "generated.dto.InvalidOrderStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.InvalidOrderDataset", collection: false },
  ],
  "generated.dto.InvalidSignupReasonDTOBase": [
    { field: "firstDetectedAt", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.InvalidSignupReasonSearchParams": [
    { field: "firstDetectedAtExact", kind: "date-time", collection: false },
    { field: "firstDetectedAtAnyOf", kind: "date-time", collection: true },
    { field: "firstDetectedAtLess", kind: "date-time", collection: false },
    { field: "firstDetectedAtLessEq", kind: "date-time", collection: false },
    { field: "firstDetectedAtGreater", kind: "date-time", collection: false },
    { field: "firstDetectedAtGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.InvalidSignupReasonStaff": [
    { field: "reportId", kind: "dto", dto: "generated.dto.InvalidSignupReportStaff", collection: false },
    { field: "firstDetectedAt", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.InvalidSignupReconcileStatus": [
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
    { field: "lastResult", kind: "dto", dto: "org.communityboating.services.reporting.InvalidSignupReconcileResult", collection: false },
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
  ],
  "generated.dto.InvalidSignupReportDTOBase": [
    { field: "firstDetectedAt", kind: "date-time", collection: false },
    { field: "lastCheckedAt", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "apSignupDate", kind: "date-time", collection: false },
    { field: "jpSignupDate", kind: "date-time", collection: false },
  ],
  "generated.dto.InvalidSignupReportSearchParams": [
    { field: "firstDetectedAtExact", kind: "date-time", collection: false },
    { field: "firstDetectedAtAnyOf", kind: "date-time", collection: true },
    { field: "firstDetectedAtLess", kind: "date-time", collection: false },
    { field: "firstDetectedAtLessEq", kind: "date-time", collection: false },
    { field: "firstDetectedAtGreater", kind: "date-time", collection: false },
    { field: "firstDetectedAtGreaterEq", kind: "date-time", collection: false },
    { field: "lastCheckedAtExact", kind: "date-time", collection: false },
    { field: "lastCheckedAtAnyOf", kind: "date-time", collection: true },
    { field: "lastCheckedAtLess", kind: "date-time", collection: false },
    { field: "lastCheckedAtLessEq", kind: "date-time", collection: false },
    { field: "lastCheckedAtGreater", kind: "date-time", collection: false },
    { field: "lastCheckedAtGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.InvalidSignupReportStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "apSignupId", kind: "dto", dto: "generated.dto.ApClassSignupStaff", collection: false },
    { field: "jpSignupId", kind: "dto", dto: "generated.dto.JpClassSignupStaff", collection: false },
    { field: "reasons", kind: "dto", dto: "generated.dto.InvalidSignupReasonStaff", collection: true },
    { field: "firstDetectedAt", kind: "date-time", collection: false },
    { field: "lastCheckedAt", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "apSignupDate", kind: "date-time", collection: false },
    { field: "jpSignupDate", kind: "date-time", collection: false },
  ],
  "generated.dto.ItemSalesDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.reporting.ItemSalesRequest", collection: false },
    { field: "totals", kind: "dto", dto: "org.communityboating.services.reporting.ItemSalesAmounts", collection: false },
    { field: "sourceRuns", kind: "dto", dto: "generated.dto.ReportRunRef", collection: true },
  ],
  "generated.dto.ItemSalesDetailDTOBase": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "generated.dto.ItemSalesDetailStaff": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "generated.dto.ItemSalesReportDTOBase": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "generated.dto.ItemSalesReportStaff": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "generated.dto.ItemSalesRequest": [
    { field: "startDate", kind: "date", collection: false },
    { field: "endDate", kind: "date", collection: false },
  ],
  "generated.dto.ItemSalesStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.ItemSalesDataset", collection: false },
  ],
  "generated.dto.JobHealthHistoryRequest": [
    { field: "schedule", kind: "dto", dto: "generated.dto.JobScheduleRef", collection: false },
  ],
  "generated.dto.JobHealthRow": [
    { field: "machine", kind: "dto", dto: "generated.dto.JobMachineStaff", collection: false },
    { field: "schedule", kind: "dto", dto: "generated.dto.JobScheduleStaff", collection: false },
    { field: "latestRun", kind: "dto", dto: "generated.dto.JobRunStaff", collection: false },
  ],
  "generated.dto.JobHealthSnapshot": [
    { field: "checkedAt", kind: "date-time", collection: false },
    { field: "machines", kind: "dto", dto: "generated.dto.JobMachineStaff", collection: true },
    { field: "jobs", kind: "dto", dto: "org.communityboating.services.JobHealthRow", collection: true },
  ],
  "generated.dto.JobMachineDTOBase": [
    { field: "heartbeatAt", kind: "date-time", collection: false },
  ],
  "generated.dto.JobMachineStaff": [
    { field: "heartbeatAt", kind: "date-time", collection: false },
  ],
  "generated.dto.JobRunDTOBase": [
    { field: "scheduledAt", kind: "date-time", collection: false },
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.JobRunStaff": [
    { field: "scheduledAt", kind: "date-time", collection: false },
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.JobScheduleDTOBase": [
    { field: "registeredAt", kind: "date-time", collection: false },
    { field: "nextFireAt", kind: "date-time", collection: false },
    { field: "missedFireAt", kind: "date-time", collection: false },
  ],
  "generated.dto.JobScheduleStaff": [
    { field: "registeredAt", kind: "date-time", collection: false },
    { field: "nextFireAt", kind: "date-time", collection: false },
    { field: "missedFireAt", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClass": [
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassType", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocation", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "sessions", kind: "dto", dto: "generated.dto.JpClassSession", collection: true },
    { field: "signups", kind: "dto", dto: "generated.dto.JpClassSignup", collection: true },
    { field: "staggers", kind: "dto", dto: "generated.dto.JpClassStagger", collection: true },
  ],
  "generated.dto.JpClassAttendance": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.JpClassSession", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignup", collection: false },
  ],
  "generated.dto.JpClassAttendanceDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassAttendanceMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassAttendanceStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.JpClassSessionStaff", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupStaff", collection: false },
  ],
  "generated.dto.JpClassDTOBase": [
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassMember": [
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassSession": [
    { field: "sessionDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClass", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.JpClassAttendance", collection: true },
  ],
  "generated.dto.JpClassSessionDTOBase": [
    { field: "sessionDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassSessionMember": [
    { field: "sessionDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassSessionStaff": [
    { field: "sessionDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassStaff", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.JpClassAttendanceStaff", collection: true },
  ],
  "generated.dto.JpClassSignup": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "wlResult", kind: "dto", dto: "generated.dto.JpClassWlResult", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClass", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.JpClassAttendance", collection: true },
  ],
  "generated.dto.JpClassSignupDTOBase": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassSignupMember": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassSignupStaff": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "wlResult", kind: "dto", dto: "generated.dto.JpClassWlResultStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassStaff", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "attendance", kind: "dto", dto: "generated.dto.JpClassAttendanceStaff", collection: true },
  ],
  "generated.dto.JpClassStaff": [
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocationStaff", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "sessions", kind: "dto", dto: "generated.dto.JpClassSessionStaff", collection: true },
    { field: "signups", kind: "dto", dto: "generated.dto.JpClassSignupStaff", collection: true },
    { field: "staggers", kind: "dto", dto: "generated.dto.JpClassStaggerStaff", collection: true },
  ],
  "generated.dto.JpClassStagger": [
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClass", collection: false },
    { field: "staggerDate", kind: "date-time", collection: false },
    { field: "reserveRelease", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassStaggerDTOBase": [
    { field: "staggerDate", kind: "date-time", collection: false },
    { field: "reserveRelease", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassStaggerStaff": [
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassStaff", collection: false },
    { field: "staggerDate", kind: "date-time", collection: false },
    { field: "reserveRelease", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassType": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.JpClassType", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.JpClassType", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "classes", kind: "dto", dto: "generated.dto.JpClass", collection: true },
    { field: "typesRequiringThisAsPrereq", kind: "dto", dto: "generated.dto.JpClassType", collection: true },
    { field: "typesRequiringThisAsOverkill", kind: "dto", dto: "generated.dto.JpClassType", collection: true },
    { field: "overrides", kind: "dto", dto: "generated.dto.JpClassTypeOverride", collection: true },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.JpClassTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.JpClassTypeMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.JpClassTypeOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassType", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassTypeOverrideDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassTypeOverrideStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassTypeSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassTypeStaff": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "classes", kind: "dto", dto: "generated.dto.JpClassStaff", collection: true },
    { field: "typesRequiringThisAsPrereq", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: true },
    { field: "typesRequiringThisAsOverkill", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: true },
    { field: "overrides", kind: "dto", dto: "generated.dto.JpClassTypeOverrideStaff", collection: true },
    { field: "ratingPrereqIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "teachRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.JpClassWlResult": [
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignup", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "preapprovedExp", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassWlResultDTOBase": [
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "preapprovedExp", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassWlResultMember": [
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupMember", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "preapprovedExp", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JpClassWlResultRef": [
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupRef", collection: false },
  ],
  "generated.dto.JpClassWlResultStaff": [
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupStaff", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "preapprovedExp", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.JwtToken": [
    { field: "expiration", kind: "date-time", collection: false },
    { field: "issuedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.LineItemDTOBase": [
    { field: "expiresOn", kind: "date-time", collection: false },
    { field: "classSignup", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.LineItemDiscountInstanceDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountInstanceRef", collection: false },
  ],
  "generated.dto.LineItemDiscountInstanceMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountInstanceRef", collection: false },
  ],
  "generated.dto.LineItemDiscountInstanceStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "lineItemId", kind: "dto", dto: "generated.dto.LineItemStaff", collection: false },
    { field: "discountInstanceId", kind: "dto", dto: "generated.dto.CatalogDiscountInstanceStaff", collection: false },
    { field: "discountInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogDiscountInstanceRef", collection: false },
  ],
  "generated.dto.LineItemMember": [
    { field: "expiresOn", kind: "date-time", collection: false },
    { field: "classSignup", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "childItems", kind: "dto", dto: "generated.dto.LineItemMember", collection: true },
    { field: "itemInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.LineItemRefundDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.LineItemRefundStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "lineItemId", kind: "dto", dto: "generated.dto.LineItemStaff", collection: false },
    { field: "taxes", kind: "dto", dto: "generated.dto.LineItemRefundTaxStaff", collection: true },
    { field: "orderRefundId", kind: "dto", dto: "generated.dto.OrderRefundStaff", collection: false },
  ],
  "generated.dto.LineItemRefundTaxDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.LineItemRefundTaxStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "lineItemRefundId", kind: "dto", dto: "generated.dto.LineItemRefundStaff", collection: false },
    { field: "taxId", kind: "dto", dto: "generated.dto.LineItemTaxStaff", collection: false },
  ],
  "generated.dto.LineItemStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "expiresOn", kind: "date-time", collection: false },
    { field: "donation", kind: "dto", dto: "generated.dto.DonationStaff", collection: false },
    { field: "membership", kind: "dto", dto: "generated.dto.MembershipStaff", collection: false },
    { field: "balanceTransaction", kind: "dto", dto: "generated.dto.BalanceTransactionStaff", collection: false },
    { field: "stockChange", kind: "dto", dto: "generated.dto.StockChangeStaff", collection: false },
    { field: "card", kind: "dto", dto: "generated.dto.CardStaff", collection: false },
    { field: "guestPrivs", kind: "dto", dto: "generated.dto.GuestPrivilegeStaff", collection: false },
    { field: "damageWaiver", kind: "dto", dto: "generated.dto.DamageWaiverStaff", collection: false },
    { field: "classSignup", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
    { field: "purchaseDelivery", kind: "dto", dto: "generated.dto.PurchaseDeliveryStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "orderId", kind: "dto", dto: "generated.dto.OrderStaff", collection: false },
    { field: "itemInstanceId", kind: "dto", dto: "generated.dto.CatalogItemInstanceStaff", collection: false },
    { field: "parentItemId", kind: "dto", dto: "generated.dto.LineItemStaff", collection: false },
    { field: "childItems", kind: "dto", dto: "generated.dto.LineItemStaff", collection: true },
    { field: "discountInstances", kind: "dto", dto: "generated.dto.LineItemDiscountInstanceStaff", collection: true },
    { field: "taxes", kind: "dto", dto: "generated.dto.LineItemTaxStaff", collection: true },
    { field: "refunds", kind: "dto", dto: "generated.dto.LineItemRefundStaff", collection: true },
    { field: "itemInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.LineItemTaxDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "taxIdTargetIds", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
  ],
  "generated.dto.LineItemTaxStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "lineItemId", kind: "dto", dto: "generated.dto.LineItemStaff", collection: false },
    { field: "taxId", kind: "dto", dto: "generated.dto.CatalogTaxStaff", collection: false },
    { field: "taxIdTargetIds", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
  ],
  "generated.dto.ManualCaptureFailure": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.ManualCaptureResult": [
    { field: "capturedOrders", kind: "dto", dto: "generated.dto.OrderRef", collection: true },
    { field: "normalizedOrders", kind: "dto", dto: "generated.dto.OrderRef", collection: true },
    { field: "failures", kind: "dto", dto: "org.communityboating.services.orders.ManualCaptureFailure", collection: true },
  ],
  "generated.dto.MemberAgreementStatus": [
    { field: "agreement", kind: "dto", dto: "generated.dto.AgreementMember", collection: false },
    { field: "latestInstance", kind: "dto", dto: "generated.dto.AgreementInstanceMember", collection: false },
    { field: "latestActionOn", kind: "date-time", collection: false },
  ],
  "generated.dto.MemberAgreementStatuses": [
    { field: "items", kind: "dto", dto: "org.communityboating.services.people.MemberAgreementStatus", collection: true },
  ],
  "generated.dto.MemberDonationOptions": [
    { field: "funds", kind: "dto", dto: "generated.dto.DonationFundMember", collection: true },
    { field: "initiatives", kind: "dto", dto: "generated.dto.DonationInitiativeMember", collection: true },
    { field: "progress", kind: "dto", dto: "org.communityboating.services.orders.purchasables.DonationInitiativeProgress", collection: true },
    { field: "defaultInitiative", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
  ],
  "generated.dto.MemberEmergencyContact": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhone", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddress", collection: true },
  ],
  "generated.dto.MemberEmergencyContactCreate": [
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
  ],
  "generated.dto.MemberEmergencyContactUpdate": [
    { field: "contact", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
  ],
  "generated.dto.MemberProfile": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhone", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddress", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonMember", collection: true },
    { field: "emergencyContactDetails", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContact", collection: true },
  ],
  "generated.dto.MemberProfileAddress": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
    { field: "address", kind: "dto", dto: "generated.dto.AddressMember", collection: false },
  ],
  "generated.dto.MemberProfileAddressChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
  ],
  "generated.dto.MemberProfileCreate": [
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
    { field: "newEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactCreate", collection: true },
    { field: "updatedEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactUpdate", collection: true },
  ],
  "generated.dto.MemberProfilePhone": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
    { field: "phone", kind: "dto", dto: "generated.dto.PhoneMember", collection: false },
  ],
  "generated.dto.MemberProfilePhoneChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
  ],
  "generated.dto.MemberProfileUpdate": [
    { field: "person", kind: "dto", dto: "generated.dto.UpdatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
    { field: "newEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactCreate", collection: true },
    { field: "updatedEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactUpdate", collection: true },
  ],
  "generated.dto.MemberRequiredAgreementsRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "agreements", kind: "dto", dto: "generated.dto.AgreementRef", collection: true },
  ],
  "generated.dto.MemberSignAgreementRequest": [
    { field: "agreement", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.Membership": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "membershipTypeId", kind: "dto", dto: "generated.dto.MembershipType", collection: false },
    { field: "purchaseDate", kind: "date", collection: false },
    { field: "startDate", kind: "date", collection: false },
    { field: "expirationDate", kind: "date", collection: false },
    { field: "guestPrivilegeRows", kind: "dto", dto: "generated.dto.GuestPrivilege", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "membershipTypeIdTargetIds", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
  ],
  "generated.dto.MembershipDTOBase": [
    { field: "purchaseDate", kind: "date", collection: false },
    { field: "startDate", kind: "date", collection: false },
    { field: "expirationDate", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "membershipTypeIdTargetIds", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
  ],
  "generated.dto.MembershipMember": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonMember", collection: false },
    { field: "membershipTypeId", kind: "dto", dto: "generated.dto.MembershipTypeMember", collection: false },
    { field: "purchaseDate", kind: "date", collection: false },
    { field: "startDate", kind: "date", collection: false },
    { field: "expirationDate", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "membershipTypeIdTargetIds", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
  ],
  "generated.dto.MembershipSearchParams": [
    { field: "purchaseDateExact", kind: "date", collection: false },
    { field: "purchaseDateAnyOf", kind: "date", collection: true },
    { field: "purchaseDateLess", kind: "date", collection: false },
    { field: "purchaseDateLessEq", kind: "date", collection: false },
    { field: "purchaseDateGreater", kind: "date", collection: false },
    { field: "purchaseDateGreaterEq", kind: "date", collection: false },
    { field: "startDateExact", kind: "date", collection: false },
    { field: "startDateAnyOf", kind: "date", collection: true },
    { field: "startDateLess", kind: "date", collection: false },
    { field: "startDateLessEq", kind: "date", collection: false },
    { field: "startDateGreater", kind: "date", collection: false },
    { field: "startDateGreaterEq", kind: "date", collection: false },
    { field: "expirationDateExact", kind: "date", collection: false },
    { field: "expirationDateAnyOf", kind: "date", collection: true },
    { field: "expirationDateLess", kind: "date", collection: false },
    { field: "expirationDateLessEq", kind: "date", collection: false },
    { field: "expirationDateGreater", kind: "date", collection: false },
    { field: "expirationDateGreaterEq", kind: "date", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.MembershipStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "membershipTypeId", kind: "dto", dto: "generated.dto.MembershipTypeStaff", collection: false },
    { field: "purchaseDate", kind: "date", collection: false },
    { field: "startDate", kind: "date", collection: false },
    { field: "expirationDate", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "membershipTypeIdTargetIds", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
  ],
  "generated.dto.MembershipType": [
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramType", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.MembershipTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.MembershipTypeDiscountDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "membershipTypeIdTargetIds", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
  ],
  "generated.dto.MembershipTypeDiscountMember": [
    { field: "membershipTypeId", kind: "dto", dto: "generated.dto.MembershipTypeMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "membershipTypeIdTargetIds", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
  ],
  "generated.dto.MembershipTypeDiscountStaff": [
    { field: "membershipTypeId", kind: "dto", dto: "generated.dto.MembershipTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "membershipTypeIdTargetIds", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
  ],
  "generated.dto.MembershipTypeMember": [
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.MembershipTypeSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.MembershipTypeStaff": [
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.OptOutGroup": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.OptOutGroupStatus": [
    { field: "group", kind: "dto", dto: "generated.dto.OptOutGroup", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.OptOutSetMemberOptOutRequest": [
    { field: "group", kind: "dto", dto: "generated.dto.OptOutGroupRef", collection: false },
  ],
  "generated.dto.OptOutStatus": [
    { field: "groups", kind: "dto", dto: "org.communityboating.services.people.OptOutGroupStatus", collection: true },
  ],
  "generated.dto.OrderAddPurchaseRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.AddToCart", collection: false },
    { field: "delivery", kind: "dto", dto: "org.communityboating.services.orders.ConfigureDelivery", collection: false },
  ],
  "generated.dto.OrderAddToCartRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.AddToCart", collection: false },
  ],
  "generated.dto.OrderApplyDiscountFromCodeRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.OrderApplyDiscountToLineItemsRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.DiscountOnLines", collection: false },
  ],
  "generated.dto.OrderChangeBuyerRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.OrderConfigureDeliveryRequest": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.ConfigureDelivery", collection: false },
  ],
  "generated.dto.OrderConfigureReceiptDeliveryRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "printer", kind: "dto", dto: "generated.dto.PrinterRef", collection: false },
  ],
  "generated.dto.OrderDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderLineAdjustment": [
    { field: "discount", kind: "dto", dto: "generated.dto.LineItemDiscountInstanceRef", collection: false },
  ],
  "generated.dto.OrderLineDetail": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "discounts", kind: "dto", dto: "org.communityboating.services.orders.OrderLineAdjustment", collection: true },
    { field: "taxes", kind: "dto", dto: "org.communityboating.services.orders.OrderLineAdjustment", collection: true },
    { field: "donation", kind: "dto", dto: "org.communityboating.services.orders.purchasables.DonationPurchaseDetails", collection: false },
    { field: "guestMembership", kind: "dto", dto: "generated.dto.MembershipRef", collection: false },
  ],
  "generated.dto.OrderMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "lineItems", kind: "dto", dto: "generated.dto.LineItemMember", collection: true },
  ],
  "generated.dto.OrderMemberSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderMismatchDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "generated.dto.OrderMismatchReportDTOBase": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "orderId", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.OrderMismatchReportStaff": [
    { field: "runId", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "orderId", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.OrderMismatchStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.OrderMismatchDataset", collection: false },
  ],
  "generated.dto.OrderOpenOrderRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.OrderPaymentDTOBase": [
    { field: "paymentDueDate", kind: "date-time", collection: false },
    { field: "paymentPaidDate", kind: "date-time", collection: false },
    { field: "paymentCapturableDate", kind: "date-time", collection: false },
    { field: "expiresOn", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderPaymentSearchParamsDTOBase": [
    { field: "paymentDueDateExact", kind: "date-time", collection: false },
    { field: "paymentDueDateAnyOf", kind: "date-time", collection: true },
    { field: "paymentDueDateLess", kind: "date-time", collection: false },
    { field: "paymentDueDateLessEq", kind: "date-time", collection: false },
    { field: "paymentDueDateGreater", kind: "date-time", collection: false },
    { field: "paymentDueDateGreaterEq", kind: "date-time", collection: false },
    { field: "paymentPaidDateExact", kind: "date-time", collection: false },
    { field: "paymentPaidDateAnyOf", kind: "date-time", collection: true },
    { field: "paymentPaidDateLess", kind: "date-time", collection: false },
    { field: "paymentPaidDateLessEq", kind: "date-time", collection: false },
    { field: "paymentPaidDateGreater", kind: "date-time", collection: false },
    { field: "paymentPaidDateGreaterEq", kind: "date-time", collection: false },
    { field: "paymentCapturableDateExact", kind: "date-time", collection: false },
    { field: "paymentCapturableDateAnyOf", kind: "date-time", collection: true },
    { field: "paymentCapturableDateLess", kind: "date-time", collection: false },
    { field: "paymentCapturableDateLessEq", kind: "date-time", collection: false },
    { field: "paymentCapturableDateGreater", kind: "date-time", collection: false },
    { field: "paymentCapturableDateGreaterEq", kind: "date-time", collection: false },
    { field: "expiresOnExact", kind: "date-time", collection: false },
    { field: "expiresOnAnyOf", kind: "date-time", collection: true },
    { field: "expiresOnLess", kind: "date-time", collection: false },
    { field: "expiresOnLessEq", kind: "date-time", collection: false },
    { field: "expiresOnGreater", kind: "date-time", collection: false },
    { field: "expiresOnGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderPaymentStaff": [
    { field: "orderId", kind: "dto", dto: "generated.dto.OrderStaff", collection: false },
    { field: "stripeTransaction", kind: "dto", dto: "generated.dto.StripeTransactionStaff", collection: false },
    { field: "paymentDueDate", kind: "date-time", collection: false },
    { field: "paymentPaidDate", kind: "date-time", collection: false },
    { field: "paymentCapturableDate", kind: "date-time", collection: false },
    { field: "expiresOn", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "refunds", kind: "dto", dto: "generated.dto.PaymentRefundStaff", collection: true },
    { field: "cashTransaction", kind: "dto", dto: "generated.dto.CashTransactionStaff", collection: false },
    { field: "balanceTransaction", kind: "dto", dto: "generated.dto.BalanceTransactionStaff", collection: false },
    { field: "transactionOther", kind: "dto", dto: "generated.dto.TransactionOtherStaff", collection: false },
  ],
  "generated.dto.OrderPaymentStaffSearchParams": [
    { field: "paymentDueDateExact", kind: "date-time", collection: false },
    { field: "paymentDueDateAnyOf", kind: "date-time", collection: true },
    { field: "paymentDueDateLess", kind: "date-time", collection: false },
    { field: "paymentDueDateLessEq", kind: "date-time", collection: false },
    { field: "paymentDueDateGreater", kind: "date-time", collection: false },
    { field: "paymentDueDateGreaterEq", kind: "date-time", collection: false },
    { field: "paymentPaidDateExact", kind: "date-time", collection: false },
    { field: "paymentPaidDateAnyOf", kind: "date-time", collection: true },
    { field: "paymentPaidDateLess", kind: "date-time", collection: false },
    { field: "paymentPaidDateLessEq", kind: "date-time", collection: false },
    { field: "paymentPaidDateGreater", kind: "date-time", collection: false },
    { field: "paymentPaidDateGreaterEq", kind: "date-time", collection: false },
    { field: "paymentCapturableDateExact", kind: "date-time", collection: false },
    { field: "paymentCapturableDateAnyOf", kind: "date-time", collection: true },
    { field: "paymentCapturableDateLess", kind: "date-time", collection: false },
    { field: "paymentCapturableDateLessEq", kind: "date-time", collection: false },
    { field: "paymentCapturableDateGreater", kind: "date-time", collection: false },
    { field: "paymentCapturableDateGreaterEq", kind: "date-time", collection: false },
    { field: "expiresOnExact", kind: "date-time", collection: false },
    { field: "expiresOnAnyOf", kind: "date-time", collection: true },
    { field: "expiresOnLess", kind: "date-time", collection: false },
    { field: "expiresOnLessEq", kind: "date-time", collection: false },
    { field: "expiresOnGreater", kind: "date-time", collection: false },
    { field: "expiresOnGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderRefundDTOBase": [
    { field: "refundDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderRefundPreview": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "lines", kind: "dto", dto: "org.communityboating.services.orders.RefundLinePreview", collection: true },
    { field: "payments", kind: "dto", dto: "org.communityboating.services.orders.RefundPaymentPreview", collection: true },
    { field: "revocationEffects", kind: "dto", dto: "org.communityboating.services.orders.RefundRevocationEffect", collection: true },
  ],
  "generated.dto.OrderRefundPreviewRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "lines", kind: "dto", dto: "org.communityboating.services.orders.RefundLineRequest", collection: true },
  ],
  "generated.dto.OrderRefundReconciliation": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.OrderRefundRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "lines", kind: "dto", dto: "org.communityboating.services.orders.RefundLineRequest", collection: true },
    { field: "destinations", kind: "dto", dto: "org.communityboating.services.orders.RefundDestinationRequest", collection: true },
  ],
  "generated.dto.OrderRefundResult": [
    { field: "refund", kind: "dto", dto: "generated.dto.OrderRefundRef", collection: false },
  ],
  "generated.dto.OrderRefundStaff": [
    { field: "refundDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "orderId", kind: "dto", dto: "generated.dto.OrderStaff", collection: false },
    { field: "lineItemRefunds", kind: "dto", dto: "generated.dto.LineItemRefundStaff", collection: true },
    { field: "paymentRefunds", kind: "dto", dto: "generated.dto.PaymentRefundStaff", collection: true },
  ],
  "generated.dto.OrderSearchParams": [
    { field: "receiptPrintQueuedOnExact", kind: "date-time", collection: false },
    { field: "receiptPrintQueuedOnAnyOf", kind: "date-time", collection: true },
    { field: "receiptPrintQueuedOnLess", kind: "date-time", collection: false },
    { field: "receiptPrintQueuedOnLessEq", kind: "date-time", collection: false },
    { field: "receiptPrintQueuedOnGreater", kind: "date-time", collection: false },
    { field: "receiptPrintQueuedOnGreaterEq", kind: "date-time", collection: false },
    { field: "receiptEmailSentOnExact", kind: "date-time", collection: false },
    { field: "receiptEmailSentOnAnyOf", kind: "date-time", collection: true },
    { field: "receiptEmailSentOnLess", kind: "date-time", collection: false },
    { field: "receiptEmailSentOnLessEq", kind: "date-time", collection: false },
    { field: "receiptEmailSentOnGreater", kind: "date-time", collection: false },
    { field: "receiptEmailSentOnGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderSearchParamsDTOBase": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.OrderSettlementTransferDTOBase": [
    { field: "settlementDay", kind: "date", collection: false },
  ],
  "generated.dto.OrderSettlementTransferStaff": [
    { field: "settlementDay", kind: "date", collection: false },
  ],
  "generated.dto.OrderStaff": [
    { field: "receiptPrinter", kind: "dto", dto: "generated.dto.PrinterRef", collection: false },
    { field: "receiptPrintQueuedOn", kind: "date-time", collection: false },
    { field: "receiptEmailSentOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "lineItems", kind: "dto", dto: "generated.dto.LineItemStaff", collection: true },
    { field: "orderRefunds", kind: "dto", dto: "generated.dto.OrderRefundStaff", collection: true },
    { field: "payments", kind: "dto", dto: "generated.dto.OrderPaymentStaff", collection: true },
  ],
  "generated.dto.OrderSwitchOrderSourceRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.OrderUnapplyDiscountFromLineItemsRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.DiscountOnLines", collection: false },
  ],
  "generated.dto.OrderUnapplyLineItemDiscountRequest": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "discount", kind: "dto", dto: "generated.dto.LineItemDiscountInstanceRef", collection: false },
  ],
  "generated.dto.PaymentAttempt": [
    { field: "payment", kind: "dto", dto: "generated.dto.OrderPaymentRef", collection: false },
  ],
  "generated.dto.PaymentRefundDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PaymentRefundStaff": [
    { field: "cashDrawerChange", kind: "dto", dto: "generated.dto.CashDrawerChangeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "orderRefundId", kind: "dto", dto: "generated.dto.OrderRefundStaff", collection: false },
    { field: "paymentId", kind: "dto", dto: "generated.dto.OrderPaymentStaff", collection: false },
  ],
  "generated.dto.PaymentSendPaymentToReaderRequest": [
    { field: "payment", kind: "dto", dto: "generated.dto.OrderPaymentRef", collection: false },
  ],
  "generated.dto.PaymentSourceDTOBase": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PaymentSourceStaff": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PaymentStartPaymentRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.orders.StartPayment", collection: false },
  ],
  "generated.dto.Person": [
    { field: "personType", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
    { field: "dob", kind: "date", collection: false },
    { field: "referrals", kind: "dto", dto: "generated.dto.PersonReferral", collection: true },
    { field: "damageWaivers", kind: "dto", dto: "generated.dto.DamageWaiver", collection: true },
    { field: "phones", kind: "dto", dto: "generated.dto.PersonPhone", collection: true },
    { field: "personRatings", kind: "dto", dto: "generated.dto.PersonRating", collection: true },
    { field: "memberships", kind: "dto", dto: "generated.dto.Membership", collection: true },
    { field: "primaryAddressId", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
    { field: "primaryPhoneId", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
    { field: "addresses", kind: "dto", dto: "generated.dto.PersonAddress", collection: true },
    { field: "cards", kind: "dto", dto: "generated.dto.Card", collection: true },
    { field: "personTypes", kind: "dto", dto: "generated.dto.PersonPersonType", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "apClassesInstructing", kind: "dto", dto: "generated.dto.ApClass", collection: true },
    { field: "jpClassesInstructing", kind: "dto", dto: "generated.dto.JpClass", collection: true },
    { field: "apClassSignups", kind: "dto", dto: "generated.dto.ApClassSignup", collection: true },
    { field: "jpClassSignups", kind: "dto", dto: "generated.dto.JpClassSignup", collection: true },
    { field: "apClassTypeOverrides", kind: "dto", dto: "generated.dto.ApClassTypeOverride", collection: true },
    { field: "jpClassTypeOverrides", kind: "dto", dto: "generated.dto.JpClassTypeOverride", collection: true },
    { field: "relationsA", kind: "dto", dto: "generated.dto.PersonRelation", collection: true },
    { field: "relationsB", kind: "dto", dto: "generated.dto.PersonRelation", collection: true },
    { field: "checkIns", kind: "dto", dto: "generated.dto.PersonCheckIn", collection: true },
    { field: "activeMembershipExpiration", kind: "date", collection: false },
  ],
  "generated.dto.PersonAddress": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "addressId", kind: "dto", dto: "generated.dto.Address", collection: false },
  ],
  "generated.dto.PersonAddressMember": [
    { field: "addressId", kind: "dto", dto: "generated.dto.AddressMember", collection: false },
  ],
  "generated.dto.PersonAddressStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "addressId", kind: "dto", dto: "generated.dto.AddressStaff", collection: false },
  ],
  "generated.dto.PersonAgreementInstanceDTOBase": [
    { field: "agreedOn", kind: "date-time", collection: false },
    { field: "agreementExpiration", kind: "date-time", collection: false },
    { field: "agreementInstanceIdTargetIds", kind: "dto", dto: "generated.dto.AgreementInstanceRef", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.PersonAgreementInstanceSearchParams": [
    { field: "agreedOnExact", kind: "date-time", collection: false },
    { field: "agreedOnAnyOf", kind: "date-time", collection: true },
    { field: "agreedOnLess", kind: "date-time", collection: false },
    { field: "agreedOnLessEq", kind: "date-time", collection: false },
    { field: "agreedOnGreater", kind: "date-time", collection: false },
    { field: "agreedOnGreaterEq", kind: "date-time", collection: false },
    { field: "agreementExpirationExact", kind: "date-time", collection: false },
    { field: "agreementExpirationAnyOf", kind: "date-time", collection: true },
    { field: "agreementExpirationLess", kind: "date-time", collection: false },
    { field: "agreementExpirationLessEq", kind: "date-time", collection: false },
    { field: "agreementExpirationGreater", kind: "date-time", collection: false },
    { field: "agreementExpirationGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonAgreementInstanceStaff": [
    { field: "agreementInstanceId", kind: "dto", dto: "generated.dto.AgreementInstanceStaff", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementStaff", collection: false },
    { field: "agreedOn", kind: "date-time", collection: false },
    { field: "agreementExpiration", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "agreementInstanceIdTargetIds", kind: "dto", dto: "generated.dto.AgreementInstanceRef", collection: false },
    { field: "agreementIdTargetIds", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.PersonAgreementsPage": [
    { field: "items", kind: "dto", dto: "org.communityboating.services.people.PersonApplicableAgreement", collection: true },
  ],
  "generated.dto.PersonApplicableAgreement": [
    { field: "agreement", kind: "dto", dto: "generated.dto.AgreementStaff", collection: false },
    { field: "latestInstance", kind: "dto", dto: "generated.dto.AgreementInstanceStaff", collection: false },
    { field: "latestAction", kind: "dto", dto: "generated.dto.PersonAgreementInstanceStaff", collection: false },
  ],
  "generated.dto.PersonBalanceDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonBalanceStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "balanceId", kind: "dto", dto: "generated.dto.BalanceStaff", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
  ],
  "generated.dto.PersonCheckIn": [
    { field: "checkInTime", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "cardId", kind: "dto", dto: "generated.dto.Card", collection: false },
  ],
  "generated.dto.PersonCheckInCreatePersonCheckInWithLookupRequest": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.PersonCheckInDTOBase": [
    { field: "checkInTime", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonCheckInSearchParams": [
    { field: "checkInTimeExact", kind: "date-time", collection: false },
    { field: "checkInTimeAnyOf", kind: "date-time", collection: true },
    { field: "checkInTimeLess", kind: "date-time", collection: false },
    { field: "checkInTimeLessEq", kind: "date-time", collection: false },
    { field: "checkInTimeGreater", kind: "date-time", collection: false },
    { field: "checkInTimeGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonCheckInStaff": [
    { field: "checkInTime", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "cardId", kind: "dto", dto: "generated.dto.CardStaff", collection: false },
  ],
  "generated.dto.PersonClassEnrollment": [
    { field: "firstSession", kind: "date-time", collection: false },
    { field: "lastSession", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonClassesPage": [
    { field: "items", kind: "dto", dto: "generated.dto.ClassUnifiedStaff", collection: true },
  ],
  "generated.dto.PersonCommentDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonCommentSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonCommentStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
  ],
  "generated.dto.PersonCreateEmergencyContactRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactCreate", collection: false },
  ],
  "generated.dto.PersonDTOBase": [
    { field: "dob", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "activeMembershipExpiration", kind: "date", collection: false },
  ],
  "generated.dto.PersonGetPersonNameRequest": [
    { field: "ref", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "options", kind: "dto", dto: "org.communityboating.services.people.GetNameOptions", collection: false },
  ],
  "generated.dto.PersonGrantRatingRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "rating", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "program", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.PersonMember": [
    { field: "dob", kind: "date", collection: false },
    { field: "phones", kind: "dto", dto: "generated.dto.PersonPhoneMember", collection: true },
    { field: "personRatings", kind: "dto", dto: "generated.dto.PersonRatingMember", collection: true },
    { field: "memberships", kind: "dto", dto: "generated.dto.MembershipMember", collection: true },
    { field: "addresses", kind: "dto", dto: "generated.dto.PersonAddressMember", collection: true },
    { field: "personTypes", kind: "dto", dto: "generated.dto.PersonPersonTypeMember", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "activeMembershipExpiration", kind: "date", collection: false },
  ],
  "generated.dto.PersonMemberSearchParams": [
    { field: "dobExact", kind: "date", collection: false },
    { field: "dobAnyOf", kind: "date", collection: true },
    { field: "dobLess", kind: "date", collection: false },
    { field: "dobLessEq", kind: "date", collection: false },
    { field: "dobGreater", kind: "date", collection: false },
    { field: "dobGreaterEq", kind: "date", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonPersonType": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.PersonType", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeIdTargetIds", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
  ],
  "generated.dto.PersonPersonTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeIdTargetIds", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
  ],
  "generated.dto.PersonPersonTypeMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeIdTargetIds", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
  ],
  "generated.dto.PersonPersonTypeStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.PersonTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeIdTargetIds", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
  ],
  "generated.dto.PersonPhone": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "phoneId", kind: "dto", dto: "generated.dto.Phone", collection: false },
  ],
  "generated.dto.PersonPhoneStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "phoneId", kind: "dto", dto: "generated.dto.PhoneStaff", collection: false },
  ],
  "generated.dto.PersonRating": [
    { field: "personId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "ratingId", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramType", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.PersonRatingDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.PersonRatingGrid": [
    { field: "sections", kind: "dto", dto: "org.communityboating.services.PersonRatingGridSection", collection: true },
  ],
  "generated.dto.PersonRatingGridRow": [
    { field: "cells", kind: "dto", dto: "org.communityboating.services.PersonRatingGridCell", collection: true },
  ],
  "generated.dto.PersonRatingGridSection": [
    { field: "rows", kind: "dto", dto: "org.communityboating.services.PersonRatingGridRow", collection: true },
  ],
  "generated.dto.PersonRatingMember": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonMember", collection: false },
    { field: "ratingId", kind: "dto", dto: "generated.dto.RatingMember", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.PersonRatingSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonRatingStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "ratingId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.PersonReferral": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonReferralDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonReferralMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonReferralSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonReferralStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonRelation": [
    { field: "aPersonId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "bPersonId", kind: "dto", dto: "generated.dto.Person", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonRelationDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonRelationSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonRelationStaff": [
    { field: "aPersonId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "bPersonId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonRemoveCommentRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "comment", kind: "dto", dto: "generated.dto.PersonCommentRef", collection: false },
  ],
  "generated.dto.PersonRemovePersonAddressRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
  ],
  "generated.dto.PersonRemovePersonPhoneRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
  ],
  "generated.dto.PersonRemoveSkillRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "assignment", kind: "dto", dto: "generated.dto.PersonSkillRef", collection: false },
  ],
  "generated.dto.PersonRescindRatingRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "rating", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "program", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.PersonSaveCommentRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "comment", kind: "dto", dto: "generated.dto.PersonCommentRef", collection: false },
  ],
  "generated.dto.PersonSaveSkillRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "assignment", kind: "dto", dto: "generated.dto.PersonSkillRef", collection: false },
    { field: "skill", kind: "dto", dto: "generated.dto.SkillRef", collection: false },
    { field: "assessment", kind: "dto", dto: "generated.dto.AssessmentRef", collection: false },
  ],
  "generated.dto.PersonSearchParamsDTOBase": [
    { field: "dobExact", kind: "date", collection: false },
    { field: "dobAnyOf", kind: "date", collection: true },
    { field: "dobLess", kind: "date", collection: false },
    { field: "dobLessEq", kind: "date", collection: false },
    { field: "dobGreater", kind: "date", collection: false },
    { field: "dobGreaterEq", kind: "date", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonSearchPersonAgreementsRequest": [
    { field: "itemIds", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: true },
    { field: "agreements", kind: "dto", dto: "generated.dto.AgreementRef", collection: true },
  ],
  "generated.dto.PersonSetAdminHoldRequest": [
    { field: "ref", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.PersonSetTagsRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "tags", kind: "dto", dto: "generated.dto.TagRef", collection: true },
  ],
  "generated.dto.PersonSignAgreementRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "agreement", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.PersonSkillChangeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "assessmentIdTargetIds", kind: "dto", dto: "generated.dto.AssessmentRef", collection: false },
    { field: "skillIdTargetIds", kind: "dto", dto: "generated.dto.SkillRef", collection: false },
  ],
  "generated.dto.PersonSkillChangeSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonSkillChangeStaff": [
    { field: "assignId", kind: "dto", dto: "generated.dto.PersonSkillStaff", collection: false },
    { field: "assessmentId", kind: "dto", dto: "generated.dto.AssessmentStaff", collection: false },
    { field: "skillId", kind: "dto", dto: "generated.dto.SkillStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "assessmentIdTargetIds", kind: "dto", dto: "generated.dto.AssessmentRef", collection: false },
    { field: "skillIdTargetIds", kind: "dto", dto: "generated.dto.SkillRef", collection: false },
  ],
  "generated.dto.PersonSkillDTOBase": [
    { field: "dateChanged", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "skillIdTargetIds", kind: "dto", dto: "generated.dto.SkillRef", collection: false },
    { field: "assessmentIdTargetIds", kind: "dto", dto: "generated.dto.AssessmentRef", collection: false },
  ],
  "generated.dto.PersonSkillSearchParams": [
    { field: "dateChangedExact", kind: "date-time", collection: false },
    { field: "dateChangedAnyOf", kind: "date-time", collection: true },
    { field: "dateChangedLess", kind: "date-time", collection: false },
    { field: "dateChangedLessEq", kind: "date-time", collection: false },
    { field: "dateChangedGreater", kind: "date-time", collection: false },
    { field: "dateChangedGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonSkillStaff": [
    { field: "skillId", kind: "dto", dto: "generated.dto.SkillStaff", collection: false },
    { field: "assessmentId", kind: "dto", dto: "generated.dto.AssessmentStaff", collection: false },
    { field: "dateChanged", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "skillIdTargetIds", kind: "dto", dto: "generated.dto.SkillRef", collection: false },
    { field: "assessmentIdTargetIds", kind: "dto", dto: "generated.dto.AssessmentRef", collection: false },
  ],
  "generated.dto.PersonStaff": [
    { field: "personType", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
    { field: "dob", kind: "date", collection: false },
    { field: "referrals", kind: "dto", dto: "generated.dto.PersonReferralStaff", collection: true },
    { field: "damageWaivers", kind: "dto", dto: "generated.dto.DamageWaiverStaff", collection: true },
    { field: "phones", kind: "dto", dto: "generated.dto.PersonPhoneStaff", collection: true },
    { field: "personRatings", kind: "dto", dto: "generated.dto.PersonRatingStaff", collection: true },
    { field: "memberships", kind: "dto", dto: "generated.dto.MembershipStaff", collection: true },
    { field: "primaryAddressId", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
    { field: "primaryPhoneId", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
    { field: "addresses", kind: "dto", dto: "generated.dto.PersonAddressStaff", collection: true },
    { field: "cards", kind: "dto", dto: "generated.dto.CardStaff", collection: true },
    { field: "personTypes", kind: "dto", dto: "generated.dto.PersonPersonTypeStaff", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "apClassesInstructing", kind: "dto", dto: "generated.dto.ApClassStaff", collection: true },
    { field: "jpClassesInstructing", kind: "dto", dto: "generated.dto.JpClassStaff", collection: true },
    { field: "apClassSignups", kind: "dto", dto: "generated.dto.ApClassSignupStaff", collection: true },
    { field: "jpClassSignups", kind: "dto", dto: "generated.dto.JpClassSignupStaff", collection: true },
    { field: "apClassTypeOverrides", kind: "dto", dto: "generated.dto.ApClassTypeOverrideStaff", collection: true },
    { field: "jpClassTypeOverrides", kind: "dto", dto: "generated.dto.JpClassTypeOverrideStaff", collection: true },
    { field: "relationsA", kind: "dto", dto: "generated.dto.PersonRelationStaff", collection: true },
    { field: "relationsB", kind: "dto", dto: "generated.dto.PersonRelationStaff", collection: true },
    { field: "checkIns", kind: "dto", dto: "generated.dto.PersonCheckInStaff", collection: true },
    { field: "activeMembershipExpiration", kind: "date", collection: false },
  ],
  "generated.dto.PersonStaffSearchParams": [
    { field: "dobExact", kind: "date", collection: false },
    { field: "dobAnyOf", kind: "date", collection: true },
    { field: "dobLess", kind: "date", collection: false },
    { field: "dobLessEq", kind: "date", collection: false },
    { field: "dobGreater", kind: "date", collection: false },
    { field: "dobGreaterEq", kind: "date", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonTagDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "tagIdTargetIds", kind: "dto", dto: "generated.dto.TagRef", collection: false },
  ],
  "generated.dto.PersonTagSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonTagStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "tagId", kind: "dto", dto: "generated.dto.TagStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "tagIdTargetIds", kind: "dto", dto: "generated.dto.TagRef", collection: false },
  ],
  "generated.dto.PersonType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonTypeMask": [
    { field: "personTypeId", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
  ],
  "generated.dto.PersonTypeMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PersonTypeRulesValidatePersonRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.PersonTypeStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PrinterDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PrinterPrintReceiptRequest": [
    { field: "printer", kind: "dto", dto: "generated.dto.PrinterRef", collection: false },
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.PrinterSearchParamsDTOBase": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.PrinterSetCredentialsRequest": [
    { field: "printer", kind: "dto", dto: "generated.dto.PrinterRef", collection: false },
  ],
  "generated.dto.PrinterStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "cashDrawers", kind: "dto", dto: "generated.dto.CashDrawerStaff", collection: true },
  ],
  "generated.dto.PrinterStaffSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.Product": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.Catalog", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItem", collection: true },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.ProductDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.ProductMember": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.ProductSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.ProductStaff": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "items", kind: "dto", dto: "generated.dto.CatalogItemStaff", collection: true },
    { field: "catalogIdTargetIds", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.ProgramType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ProgramTypeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ProgramTypeMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ProgramTypeSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.ProgramTypeStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ProtoLoginResult": [
    { field: "tokens", kind: "dto", dto: "org.communityboating.services.auth.AuthTokens", collection: false },
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "generated.dto.ProvisionOptions": [
    { field: "membership", kind: "dto", dto: "generated.dto.MembershipRef", collection: false },
    { field: "donation", kind: "dto", dto: "org.communityboating.services.orders.purchasables.DonationPurchaseDetails", collection: false },
  ],
  "generated.dto.PurchaseDeliveryDTOBase": [
    { field: "deliveredOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PurchaseDeliveryMember": [
    { field: "deliveredOn", kind: "date-time", collection: false },
  ],
  "generated.dto.PurchaseDeliveryStaff": [
    { field: "deliveredOn", kind: "date-time", collection: false },
    { field: "targetPerson", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "targetAddress", kind: "dto", dto: "generated.dto.AddressStaff", collection: false },
  ],
  "generated.dto.Rating": [
    { field: "overriddenBy", kind: "dto", dto: "generated.dto.Rating", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typesRequiringThisRatingAsPrereq", kind: "dto", dto: "generated.dto.ApClassType", collection: true },
    { field: "typesRequiringThisRatingAsOverkill", kind: "dto", dto: "generated.dto.ApClassType", collection: true },
    { field: "typesTeachableWithThisRating", kind: "dto", dto: "generated.dto.ApClassType", collection: true },
    { field: "jpTypesRequiringThisRatingAsPrereq", kind: "dto", dto: "generated.dto.JpClassType", collection: true },
    { field: "jpTypesRequiringThisRatingAsOverkill", kind: "dto", dto: "generated.dto.JpClassType", collection: true },
    { field: "jpTypesTeachableWithThisRating", kind: "dto", dto: "generated.dto.JpClassType", collection: true },
    { field: "overriddenByTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.RatingChangeDTOBase": [
    { field: "changedDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.RatingChangeSearchParams": [
    { field: "changedDateExact", kind: "date-time", collection: false },
    { field: "changedDateAnyOf", kind: "date-time", collection: true },
    { field: "changedDateLess", kind: "date-time", collection: false },
    { field: "changedDateLessEq", kind: "date-time", collection: false },
    { field: "changedDateGreater", kind: "date-time", collection: false },
    { field: "changedDateGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.RatingChangeStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "ratingId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeStaff", collection: false },
    { field: "changedDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.RatingDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "overriddenByTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.RatingMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "overriddenByTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.RatingProgramDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.RatingProgramMember": [
    { field: "ratingId", kind: "dto", dto: "generated.dto.RatingMember", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeMember", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.RatingProgramStaff": [
    { field: "ratingId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "ratingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
  ],
  "generated.dto.RatingSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.RatingStaff": [
    { field: "overriddenBy", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typesRequiringThisRatingAsPrereq", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: true },
    { field: "typesRequiringThisRatingAsOverkill", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: true },
    { field: "typesTeachableWithThisRating", kind: "dto", dto: "generated.dto.ApClassTypeStaff", collection: true },
    { field: "jpTypesRequiringThisRatingAsPrereq", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: true },
    { field: "jpTypesRequiringThisRatingAsOverkill", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: true },
    { field: "jpTypesTeachableWithThisRating", kind: "dto", dto: "generated.dto.JpClassTypeStaff", collection: true },
    { field: "overriddenByTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.RecipientLookupResult": [
    { field: "lookup", kind: "dto", dto: "generated.dto.PersonLookupRef", collection: false },
  ],
  "generated.dto.RefundDestinationRequest": [
    { field: "payment", kind: "dto", dto: "generated.dto.OrderPaymentRef", collection: false },
    { field: "balance", kind: "dto", dto: "generated.dto.BalanceRef", collection: false },
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "generated.dto.RefundLinePreview": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "parentLineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "taxes", kind: "dto", dto: "org.communityboating.services.orders.RefundTaxPreview", collection: true },
  ],
  "generated.dto.RefundLineRequest": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "generated.dto.RefundPaymentPreview": [
    { field: "payment", kind: "dto", dto: "generated.dto.OrderPaymentRef", collection: false },
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "generated.dto.RefundRevocationEffect": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "generated.dto.RefundTaxPreview": [
    { field: "tax", kind: "dto", dto: "generated.dto.LineItemTaxRef", collection: false },
  ],
  "generated.dto.ReportExportDailySalesRequest": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "options", kind: "dto", dto: "generated.dto.CsvExportOptions", collection: false },
  ],
  "generated.dto.ReportGenerationStatus": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "requestedAt", kind: "date-time", collection: false },
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
    { field: "lastSucceededAt", kind: "date-time", collection: false },
    { field: "publishedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.ReportRunDTOBase": [
    { field: "requestedAt", kind: "date-time", collection: false },
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "heartbeatAt", kind: "date-time", collection: false },
    { field: "leaseExpiresAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
    { field: "publishedAt", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ReportRunStaff": [
    { field: "scopeId", kind: "dto", dto: "generated.dto.ReportScopeStaff", collection: false },
    { field: "requestedAt", kind: "date-time", collection: false },
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "heartbeatAt", kind: "date-time", collection: false },
    { field: "leaseExpiresAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
    { field: "publishedAt", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ReportScopeDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ReportScopeStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.ReportStartInvalidOrdersRequest": [
    { field: "request", kind: "dto", dto: "org.communityboating.services.reporting.InvalidOrderRequest", collection: false },
  ],
  "generated.dto.RoleAssignmentDTOBase": [
    { field: "assignedOn", kind: "date", collection: false },
    { field: "roleIdTargetIds", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
  ],
  "generated.dto.RoleAssignmentStaff": [
    { field: "userId", kind: "dto", dto: "generated.dto.UserStaff", collection: false },
    { field: "roleId", kind: "dto", dto: "generated.dto.RoleStaff", collection: false },
    { field: "assignedBy", kind: "dto", dto: "generated.dto.UserStaff", collection: false },
    { field: "assignedOn", kind: "date", collection: false },
    { field: "roleIdTargetIds", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
  ],
  "generated.dto.RolePermissionDTOBase": [
    { field: "roleIdTargetIds", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
    { field: "scopeIdTargetIds", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
  ],
  "generated.dto.RolePermissionStaff": [
    { field: "roleId", kind: "dto", dto: "generated.dto.RoleStaff", collection: false },
    { field: "scopeId", kind: "dto", dto: "generated.dto.ScopesStaff", collection: false },
    { field: "roleIdTargetIds", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
    { field: "scopeIdTargetIds", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
  ],
  "generated.dto.RoleStaff": [
    { field: "permissions", kind: "dto", dto: "generated.dto.RolePermissionStaff", collection: true },
    { field: "assignments", kind: "dto", dto: "generated.dto.RoleAssignmentStaff", collection: true },
  ],
  "generated.dto.SaveCatalogItemRequest": [
    { field: "create", kind: "dto", dto: "generated.dto.CreateCatalogItemStaff", collection: false },
    { field: "update", kind: "dto", dto: "generated.dto.UpdateCatalogItemStaff", collection: false },
    { field: "price", kind: "dto", dto: "org.communityboating.services.orders.CatalogItemPriceDraft", collection: false },
  ],
  "generated.dto.SavePersonAddress": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
  ],
  "generated.dto.SavePersonPhone": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
  ],
  "generated.dto.ScopesStaff": [
    { field: "rolePermissions", kind: "dto", dto: "generated.dto.RolePermissionStaff", collection: true },
    { field: "userPermissions", kind: "dto", dto: "generated.dto.UserPermissionStaff", collection: true },
  ],
  "generated.dto.SettlementNormalizationPreview": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "settlementDays", kind: "date", collection: true },
  ],
  "generated.dto.SettlementNormalizationResult": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "fundingOrders", kind: "dto", dto: "generated.dto.OrderRef", collection: true },
    { field: "balance", kind: "dto", dto: "generated.dto.BalanceRef", collection: false },
  ],
  "generated.dto.SignoutCrewDTOBase": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.SignoutCrewSearchParams": [
    { field: "startActiveExact", kind: "date-time", collection: false },
    { field: "startActiveAnyOf", kind: "date-time", collection: true },
    { field: "startActiveLess", kind: "date-time", collection: false },
    { field: "startActiveLessEq", kind: "date-time", collection: false },
    { field: "startActiveGreater", kind: "date-time", collection: false },
    { field: "startActiveGreaterEq", kind: "date-time", collection: false },
    { field: "endActiveExact", kind: "date-time", collection: false },
    { field: "endActiveAnyOf", kind: "date-time", collection: true },
    { field: "endActiveLess", kind: "date-time", collection: false },
    { field: "endActiveLessEq", kind: "date-time", collection: false },
    { field: "endActiveGreater", kind: "date-time", collection: false },
    { field: "endActiveGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.SignoutCrewStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "signoutId", kind: "dto", dto: "generated.dto.SignoutStaff", collection: false },
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.SignoutDTOBase": [
    { field: "signoutDatetime", kind: "date-time", collection: false },
    { field: "signinDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
    { field: "boatIdTargetIds", kind: "dto", dto: "generated.dto.BoatTypeRef", collection: false },
    { field: "testRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.SignoutMember": [
    { field: "signoutDatetime", kind: "date-time", collection: false },
    { field: "signinDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
    { field: "boatIdTargetIds", kind: "dto", dto: "generated.dto.BoatTypeRef", collection: false },
    { field: "testRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.SignoutMemberSearchParams": [
    { field: "signoutDatetimeExact", kind: "date-time", collection: false },
    { field: "signoutDatetimeAnyOf", kind: "date-time", collection: true },
    { field: "signoutDatetimeLess", kind: "date-time", collection: false },
    { field: "signoutDatetimeLessEq", kind: "date-time", collection: false },
    { field: "signoutDatetimeGreater", kind: "date-time", collection: false },
    { field: "signoutDatetimeGreaterEq", kind: "date-time", collection: false },
    { field: "signinDatetimeExact", kind: "date-time", collection: false },
    { field: "signinDatetimeAnyOf", kind: "date-time", collection: true },
    { field: "signinDatetimeLess", kind: "date-time", collection: false },
    { field: "signinDatetimeLessEq", kind: "date-time", collection: false },
    { field: "signinDatetimeGreater", kind: "date-time", collection: false },
    { field: "signinDatetimeGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.SignoutSearchParams": [
    { field: "signoutDatetimeExact", kind: "date-time", collection: false },
    { field: "signoutDatetimeAnyOf", kind: "date-time", collection: true },
    { field: "signoutDatetimeLess", kind: "date-time", collection: false },
    { field: "signoutDatetimeLessEq", kind: "date-time", collection: false },
    { field: "signoutDatetimeGreater", kind: "date-time", collection: false },
    { field: "signoutDatetimeGreaterEq", kind: "date-time", collection: false },
    { field: "signinDatetimeExact", kind: "date-time", collection: false },
    { field: "signinDatetimeAnyOf", kind: "date-time", collection: true },
    { field: "signinDatetimeLess", kind: "date-time", collection: false },
    { field: "signinDatetimeLessEq", kind: "date-time", collection: false },
    { field: "signinDatetimeGreater", kind: "date-time", collection: false },
    { field: "signinDatetimeGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.SignoutSearchParamsDTOBase": [
    { field: "signoutDatetimeExact", kind: "date-time", collection: false },
    { field: "signoutDatetimeAnyOf", kind: "date-time", collection: true },
    { field: "signoutDatetimeLess", kind: "date-time", collection: false },
    { field: "signoutDatetimeLessEq", kind: "date-time", collection: false },
    { field: "signoutDatetimeGreater", kind: "date-time", collection: false },
    { field: "signoutDatetimeGreaterEq", kind: "date-time", collection: false },
    { field: "signinDatetimeExact", kind: "date-time", collection: false },
    { field: "signinDatetimeAnyOf", kind: "date-time", collection: true },
    { field: "signinDatetimeLess", kind: "date-time", collection: false },
    { field: "signinDatetimeLessEq", kind: "date-time", collection: false },
    { field: "signinDatetimeGreater", kind: "date-time", collection: false },
    { field: "signinDatetimeGreaterEq", kind: "date-time", collection: false },
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.SignoutStaff": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonStaff", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeStaff", collection: false },
    { field: "boatId", kind: "dto", dto: "generated.dto.BoatTypeStaff", collection: false },
    { field: "signoutDatetime", kind: "date-time", collection: false },
    { field: "signinDatetime", kind: "date-time", collection: false },
    { field: "testRatingId", kind: "dto", dto: "generated.dto.RatingStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "programIdTargetIds", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
    { field: "boatIdTargetIds", kind: "dto", dto: "generated.dto.BoatTypeRef", collection: false },
    { field: "testRatingIdTargetIds", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
  ],
  "generated.dto.SkillAssessmentDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "skillIdTargetIds", kind: "dto", dto: "generated.dto.SkillRef", collection: false },
    { field: "assessmentIdTargetIds", kind: "dto", dto: "generated.dto.AssessmentRef", collection: false },
  ],
  "generated.dto.SkillAssessmentStaff": [
    { field: "skillId", kind: "dto", dto: "generated.dto.SkillStaff", collection: false },
    { field: "assessmentId", kind: "dto", dto: "generated.dto.AssessmentStaff", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "skillIdTargetIds", kind: "dto", dto: "generated.dto.SkillRef", collection: false },
    { field: "assessmentIdTargetIds", kind: "dto", dto: "generated.dto.AssessmentRef", collection: false },
  ],
  "generated.dto.SkillDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.SkillSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.SkillStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.StaffProfileAddressChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
  ],
  "generated.dto.StaffProfileCreateRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonStaff", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.StaffProfilePhone", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.StaffProfileAddress", collection: true },
    { field: "referrals", kind: "dto", dto: "org.communityboating.services.people.StaffProfileReferral", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
  ],
  "generated.dto.StaffProfilePhoneChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
  ],
  "generated.dto.StaffProfileReferralChange": [
    { field: "referral", kind: "dto", dto: "generated.dto.PersonReferralRef", collection: false },
  ],
  "generated.dto.StaffProfileUpdateRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.UpdatePersonStaff", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.StaffProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.StaffProfileAddressChange", collection: true },
    { field: "referrals", kind: "dto", dto: "org.communityboating.services.people.StaffProfileReferralChange", collection: true },
  ],
  "generated.dto.StaffStockSummary": [
    { field: "itemInstance", kind: "dto", dto: "generated.dto.CatalogItemInstanceStaff", collection: false },
  ],
  "generated.dto.StartPayment": [
    { field: "balance", kind: "dto", dto: "generated.dto.BalanceRef", collection: false },
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "generated.dto.StockChange": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemInstanceId", kind: "dto", dto: "generated.dto.CatalogItemInstance", collection: false },
    { field: "itemInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.StockChangeDTOBase": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.StockChangeMember": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.StockChangeStaff": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemInstanceId", kind: "dto", dto: "generated.dto.CatalogItemInstanceStaff", collection: false },
    { field: "itemInstanceIdTargetIds", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.StripeCachedBalanceTransactionDTOBase": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedBalanceTransactionSearchParams": [
    { field: "observedAtExact", kind: "date-time", collection: false },
    { field: "observedAtAnyOf", kind: "date-time", collection: true },
    { field: "observedAtLess", kind: "date-time", collection: false },
    { field: "observedAtLessEq", kind: "date-time", collection: false },
    { field: "observedAtGreater", kind: "date-time", collection: false },
    { field: "observedAtGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedBalanceTransactionStaff": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedChargeDTOBase": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedChargeSearchParams": [
    { field: "observedAtExact", kind: "date-time", collection: false },
    { field: "observedAtAnyOf", kind: "date-time", collection: true },
    { field: "observedAtLess", kind: "date-time", collection: false },
    { field: "observedAtLessEq", kind: "date-time", collection: false },
    { field: "observedAtGreater", kind: "date-time", collection: false },
    { field: "observedAtGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedChargeStaff": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedDisputeDTOBase": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedDisputeSearchParams": [
    { field: "observedAtExact", kind: "date-time", collection: false },
    { field: "observedAtAnyOf", kind: "date-time", collection: true },
    { field: "observedAtLess", kind: "date-time", collection: false },
    { field: "observedAtLessEq", kind: "date-time", collection: false },
    { field: "observedAtGreater", kind: "date-time", collection: false },
    { field: "observedAtGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedDisputeStaff": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedPayoutDTOBase": [
    { field: "observedAt", kind: "date-time", collection: false },
    { field: "membershipObservedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedPayoutSearchParams": [
    { field: "observedAtExact", kind: "date-time", collection: false },
    { field: "observedAtAnyOf", kind: "date-time", collection: true },
    { field: "observedAtLess", kind: "date-time", collection: false },
    { field: "observedAtLessEq", kind: "date-time", collection: false },
    { field: "observedAtGreater", kind: "date-time", collection: false },
    { field: "observedAtGreaterEq", kind: "date-time", collection: false },
    { field: "membershipObservedAtExact", kind: "date-time", collection: false },
    { field: "membershipObservedAtAnyOf", kind: "date-time", collection: true },
    { field: "membershipObservedAtLess", kind: "date-time", collection: false },
    { field: "membershipObservedAtLessEq", kind: "date-time", collection: false },
    { field: "membershipObservedAtGreater", kind: "date-time", collection: false },
    { field: "membershipObservedAtGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedPayoutStaff": [
    { field: "observedAt", kind: "date-time", collection: false },
    { field: "membershipObservedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedRefundDTOBase": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedRefundSearchParams": [
    { field: "observedAtExact", kind: "date-time", collection: false },
    { field: "observedAtAnyOf", kind: "date-time", collection: true },
    { field: "observedAtLess", kind: "date-time", collection: false },
    { field: "observedAtLessEq", kind: "date-time", collection: false },
    { field: "observedAtGreater", kind: "date-time", collection: false },
    { field: "observedAtGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeCachedRefundStaff": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeIntentSyncRequest": [
    { field: "startDate", kind: "date", collection: false },
    { field: "endDate", kind: "date", collection: false },
  ],
  "generated.dto.StripeIntentSyncStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
  ],
  "generated.dto.StripeLedgerSyncRequest": [
    { field: "startDate", kind: "date", collection: false },
    { field: "endDate", kind: "date", collection: false },
  ],
  "generated.dto.StripePaymentIntentDTOBase": [
    { field: "providerCreatedAt", kind: "date-time", collection: false },
    { field: "canceledAt", kind: "date-time", collection: false },
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripePaymentIntentSearchParams": [
    { field: "providerCreatedAtExact", kind: "date-time", collection: false },
    { field: "providerCreatedAtAnyOf", kind: "date-time", collection: true },
    { field: "providerCreatedAtLess", kind: "date-time", collection: false },
    { field: "providerCreatedAtLessEq", kind: "date-time", collection: false },
    { field: "providerCreatedAtGreater", kind: "date-time", collection: false },
    { field: "providerCreatedAtGreaterEq", kind: "date-time", collection: false },
    { field: "canceledAtExact", kind: "date-time", collection: false },
    { field: "canceledAtAnyOf", kind: "date-time", collection: true },
    { field: "canceledAtLess", kind: "date-time", collection: false },
    { field: "canceledAtLessEq", kind: "date-time", collection: false },
    { field: "canceledAtGreater", kind: "date-time", collection: false },
    { field: "canceledAtGreaterEq", kind: "date-time", collection: false },
    { field: "observedAtExact", kind: "date-time", collection: false },
    { field: "observedAtAnyOf", kind: "date-time", collection: true },
    { field: "observedAtLess", kind: "date-time", collection: false },
    { field: "observedAtLessEq", kind: "date-time", collection: false },
    { field: "observedAtGreater", kind: "date-time", collection: false },
    { field: "observedAtGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.StripePaymentIntentStaff": [
    { field: "providerCreatedAt", kind: "date-time", collection: false },
    { field: "canceledAt", kind: "date-time", collection: false },
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripePayoutEntryDTOBase": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripePayoutEntrySearchParams": [
    { field: "observedAtExact", kind: "date-time", collection: false },
    { field: "observedAtAnyOf", kind: "date-time", collection: true },
    { field: "observedAtLess", kind: "date-time", collection: false },
    { field: "observedAtLessEq", kind: "date-time", collection: false },
    { field: "observedAtGreater", kind: "date-time", collection: false },
    { field: "observedAtGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.StripePayoutEntryStaff": [
    { field: "observedAt", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeTransactionDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.StripeTransactionStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.SunsetTimeDTOBase": [
    { field: "forDate", kind: "date-time", collection: false },
    { field: "sunset", kind: "date-time", collection: false },
  ],
  "generated.dto.SunsetTimeStaff": [
    { field: "forDate", kind: "date-time", collection: false },
    { field: "sunset", kind: "date-time", collection: false },
  ],
  "generated.dto.SwimProofMethodDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.SwimProofMethodMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.SwimProofMethodStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.TagDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.TagMember": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.TagSearchParams": [
    { field: "createdOnExact", kind: "date-time", collection: false },
    { field: "createdOnAnyOf", kind: "date-time", collection: true },
    { field: "createdOnLess", kind: "date-time", collection: false },
    { field: "createdOnLessEq", kind: "date-time", collection: false },
    { field: "createdOnGreater", kind: "date-time", collection: false },
    { field: "createdOnGreaterEq", kind: "date-time", collection: false },
    { field: "updatedOnExact", kind: "date-time", collection: false },
    { field: "updatedOnAnyOf", kind: "date-time", collection: true },
    { field: "updatedOnLess", kind: "date-time", collection: false },
    { field: "updatedOnLessEq", kind: "date-time", collection: false },
    { field: "updatedOnGreater", kind: "date-time", collection: false },
    { field: "updatedOnGreaterEq", kind: "date-time", collection: false },
  ],
  "generated.dto.TagStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.TestChildResource": [
    { field: "testResource", kind: "dto", dto: "generated.dto.TestResource", collection: false },
  ],
  "generated.dto.TestResource": [
    { field: "testFieldDate", kind: "date", collection: false },
    { field: "testFieldDateTime", kind: "date-time", collection: false },
    { field: "testChildren", kind: "dto", dto: "generated.dto.TestChildResource", collection: true },
  ],
  "generated.dto.TestResourceDescribeChildRequest": [
    { field: "dto", kind: "dto", dto: "generated.dto.TestChildResourceRef", collection: false },
  ],
  "generated.dto.TestResourceFormatChildLabelsRequest": [
    { field: "dto", kind: "dto", dto: "generated.dto.TestChildResourceRef", collection: false },
  ],
  "generated.dto.TestResourceLoadBoundResourceChildrenRequest": [
    { field: "resource", kind: "dto", dto: "generated.dto.TestResource", collection: false },
  ],
  "generated.dto.TestResourceReturnBoundResourceEnvelopeRequest": [
    { field: "resource", kind: "dto", dto: "generated.dto.TestResource", collection: false },
  ],
  "generated.dto.TestResourceTransportEnvelope": [
    { field: "resource", kind: "dto", dto: "generated.dto.TestResource", collection: false },
  ],
  "generated.dto.TransactionOtherDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.TransactionOtherStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UnifiedClassComparisonReport": [
    { field: "differences", kind: "dto", dto: "org.communityboating.services.classes.UnifiedClassComparisonDifference", collection: true },
  ],
  "generated.dto.UnifiedClassSearchOptions": [
    { field: "startDate", kind: "date-time", collection: false },
    { field: "endDate", kind: "date-time", collection: false },
    { field: "people", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
  ],
  "generated.dto.UnifiedStaffClassesResponse": [
    { field: "classes", kind: "dto", dto: "generated.dto.ClassUnifiedStaff", collection: true },
  ],
  "generated.dto.UpdateAgreement": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
  ],
  "generated.dto.UpdateAgreementCategory": [
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
  ],
  "generated.dto.UpdateAgreementInstance": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.UpdateApClass": [
    { field: "cancelByOverride", kind: "date-time", collection: false },
    { field: "signupsStartOverride", kind: "date-time", collection: false },
    { field: "cancelledDatetime", kind: "date-time", collection: false },
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "formatId", kind: "dto", dto: "generated.dto.ApClassFormatRef", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocationRef", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
  ],
  "generated.dto.UpdateApClassAttendance": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.ApClassSessionRef", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
  ],
  "generated.dto.UpdateApClassFormat": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
  ],
  "generated.dto.UpdateApClassSession": [
    { field: "sessionDateTime", kind: "date-time", collection: false },
    { field: "cancelledDateTime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClassRef", collection: false },
  ],
  "generated.dto.UpdateApClassSignup": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.ApClassRef", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.UpdateApClassType": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateApClassTypeOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.ApClassTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateApClassWlResult": [
    { field: "signupId", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateBoatType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateCashDrawer": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "printer", kind: "dto", dto: "generated.dto.PrinterRef", collection: false },
  ],
  "generated.dto.UpdateCatalog": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateCatalogDiscount": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CatalogDiscountCategoryRef", collection: false },
  ],
  "generated.dto.UpdateCatalogDiscountCategory": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateCatalogDiscountInstance": [
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "generated.dto.UpdateCatalogItemAgreement": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "generated.dto.UpdateCatalogItemCategory": [
    { field: "item", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "categoryId", kind: "dto", dto: "generated.dto.CategoryRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateCatalogItemDTOBase": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "productId", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
  ],
  "generated.dto.UpdateCatalogItemDiscount": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateCatalogItemInstance": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "startActive", kind: "date-time", collection: false },
    { field: "endActive", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateCatalogItemStaff": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "productId", kind: "dto", dto: "generated.dto.ProductRef", collection: false },
    { field: "categoriesAssignments", kind: "dto", dto: "generated.dto.CatalogItemCategoriesStaffAssignmentInput", collection: true },
    { field: "agreementsAssignments", kind: "dto", dto: "generated.dto.CatalogItemAgreementsStaffAssignmentInput", collection: true },
    { field: "taxesAssignments", kind: "dto", dto: "generated.dto.CatalogItemTaxesStaffAssignmentInput", collection: true },
    { field: "itemDiscountsAssignments", kind: "dto", dto: "generated.dto.CatalogItemItemDiscountsStaffAssignmentInput", collection: true },
  ],
  "generated.dto.UpdateCatalogItemTax": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
    { field: "taxId", kind: "dto", dto: "generated.dto.CatalogTaxRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateCatalogTax": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateClassLocation": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateDamageWaiverType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateDatetimeRange": [
    { field: "startDatetime", kind: "date-time", collection: false },
    { field: "endDatetime", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateDonation": [
    { field: "fundId", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "initiativeId", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "donationDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.UpdateDonationFundDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateDonationFundStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateDonationInitiative": [
    { field: "targetFund", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateEiiOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateJpClass": [
    { field: "availability", kind: "dto", dto: "generated.dto.ClassAvailability", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "locationId", kind: "dto", dto: "generated.dto.ClassLocationRef", collection: false },
    { field: "instructorId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.UpdateJpClassAttendance": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "sessionId", kind: "dto", dto: "generated.dto.JpClassSessionRef", collection: false },
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupRef", collection: false },
  ],
  "generated.dto.UpdateJpClassSession": [
    { field: "sessionDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassRef", collection: false },
  ],
  "generated.dto.UpdateJpClassSignup": [
    { field: "signupDatetime", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassRef", collection: false },
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "generated.dto.UpdateJpClassStagger": [
    { field: "instanceId", kind: "dto", dto: "generated.dto.JpClassRef", collection: false },
    { field: "staggerDate", kind: "date-time", collection: false },
    { field: "reserveRelease", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateJpClassType": [
    { field: "ratingPrereqId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "ratingOverkillId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "classPrereqId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "classOverkillId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "teachRatingId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateJpClassTypeOverride": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.JpClassTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateJpClassWlResult": [
    { field: "signupId", kind: "dto", dto: "generated.dto.JpClassSignupRef", collection: false },
    { field: "foVmDatetime", kind: "date-time", collection: false },
    { field: "foAlertDatetime", kind: "date-time", collection: false },
    { field: "offerExpDatetime", kind: "date-time", collection: false },
    { field: "preapprovedExp", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateMembershipType": [
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateMembershipTypeDiscount": [
    { field: "membershipTypeId", kind: "dto", dto: "generated.dto.MembershipTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePersonAddress": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "addressId", kind: "dto", dto: "generated.dto.AddressRef", collection: false },
  ],
  "generated.dto.UpdatePersonDTOBase": [
    { field: "dob", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePersonMember": [
    { field: "dob", kind: "date", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePersonPersonType": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "typeId", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePersonPhone": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "phoneId", kind: "dto", dto: "generated.dto.PhoneRef", collection: false },
  ],
  "generated.dto.UpdatePersonReferral": [
    { field: "personId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePersonRelation": [
    { field: "aPersonId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "bPersonId", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePersonStaff": [
    { field: "personType", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
    { field: "dob", kind: "date", collection: false },
    { field: "primaryAddressId", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
    { field: "primaryPhoneId", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePersonType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePrinterDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdatePrinterStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateProduct": [
    { field: "catalogId", kind: "dto", dto: "generated.dto.CatalogRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateProgramType": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateRating": [
    { field: "overriddenBy", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateRatingProgram": [
    { field: "ratingId", kind: "dto", dto: "generated.dto.RatingRef", collection: false },
    { field: "programId", kind: "dto", dto: "generated.dto.ProgramTypeRef", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateRoleAssignment": [
    { field: "userId", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "roleId", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
    { field: "assignedBy", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "assignedOn", kind: "date", collection: false },
  ],
  "generated.dto.UpdateRolePermission": [
    { field: "roleId", kind: "dto", dto: "generated.dto.RoleRef", collection: false },
    { field: "scopeId", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
  ],
  "generated.dto.UpdateStockChange": [
    { field: "purchaseDate", kind: "date-time", collection: false },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
    { field: "itemInstanceId", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
  ],
  "generated.dto.UpdateSunsetTime": [
    { field: "forDate", kind: "date-time", collection: false },
    { field: "sunset", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateSwimProofMethod": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateTag": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateTestChildResource": [
    { field: "testResource", kind: "dto", dto: "generated.dto.TestResourceRef", collection: false },
  ],
  "generated.dto.UpdateTestResource": [
    { field: "testFieldDate", kind: "date", collection: false },
    { field: "testFieldDateTime", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateUserDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateUserPermission": [
    { field: "userId", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "scopeId", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
    { field: "assignedBy", kind: "dto", dto: "generated.dto.UserRef", collection: false },
    { field: "assignedOn", kind: "date", collection: false },
  ],
  "generated.dto.UpdateUserStaff": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UpdateYearlyDate": [
    { field: "itemId", kind: "dto", dto: "generated.dto.YearlyDateItemRef", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "endDate", kind: "date-time", collection: false },
  ],
  "generated.dto.UserDTOBase": [
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.UserPermissionDTOBase": [
    { field: "assignedOn", kind: "date", collection: false },
    { field: "scopeIdTargetIds", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
  ],
  "generated.dto.UserPermissionStaff": [
    { field: "userId", kind: "dto", dto: "generated.dto.UserStaff", collection: false },
    { field: "scopeId", kind: "dto", dto: "generated.dto.ScopesStaff", collection: false },
    { field: "assignedBy", kind: "dto", dto: "generated.dto.UserStaff", collection: false },
    { field: "assignedOn", kind: "date", collection: false },
    { field: "scopeIdTargetIds", kind: "dto", dto: "generated.dto.ScopesRef", collection: false },
  ],
  "generated.dto.UserStaff": [
    { field: "roleAssignments", kind: "dto", dto: "generated.dto.RoleAssignmentStaff", collection: true },
    { field: "permissions", kind: "dto", dto: "generated.dto.UserPermissionStaff", collection: true },
    { field: "createdOn", kind: "date-time", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "generated.dto.YearlyDateDTOBase": [
    { field: "startDate", kind: "date-time", collection: false },
    { field: "endDate", kind: "date-time", collection: false },
  ],
  "generated.dto.YearlyDateStaff": [
    { field: "itemId", kind: "dto", dto: "generated.dto.YearlyDateItemStaff", collection: false },
    { field: "startDate", kind: "date-time", collection: false },
    { field: "endDate", kind: "date-time", collection: false },
  ],
  "org.communityboating.models.data.JwtToken": [
    { field: "expiration", kind: "date-time", collection: false },
    { field: "issuedAt", kind: "date-time", collection: false },
  ],
  "org.communityboating.services.EmailDeliveryResult": [
    { field: "email", kind: "dto", dto: "generated.dto.EmailTrackingRef", collection: false },
  ],
  "org.communityboating.services.JobHealthRow": [
    { field: "machine", kind: "dto", dto: "generated.dto.JobMachineStaff", collection: false },
    { field: "schedule", kind: "dto", dto: "generated.dto.JobScheduleStaff", collection: false },
    { field: "latestRun", kind: "dto", dto: "generated.dto.JobRunStaff", collection: false },
  ],
  "org.communityboating.services.JobHealthSnapshot": [
    { field: "checkedAt", kind: "date-time", collection: false },
    { field: "machines", kind: "dto", dto: "generated.dto.JobMachineStaff", collection: true },
    { field: "jobs", kind: "dto", dto: "org.communityboating.services.JobHealthRow", collection: true },
  ],
  "org.communityboating.services.PersonRatingGrid": [
    { field: "sections", kind: "dto", dto: "org.communityboating.services.PersonRatingGridSection", collection: true },
  ],
  "org.communityboating.services.PersonRatingGridRow": [
    { field: "cells", kind: "dto", dto: "org.communityboating.services.PersonRatingGridCell", collection: true },
  ],
  "org.communityboating.services.PersonRatingGridSection": [
    { field: "rows", kind: "dto", dto: "org.communityboating.services.PersonRatingGridRow", collection: true },
  ],
  "org.communityboating.services.TestResourceTransportEnvelope": [
    { field: "resource", kind: "dto", dto: "generated.dto.TestResource", collection: false },
  ],
  "org.communityboating.services.auth.AuthTokens": [
    { field: "accessToken", kind: "dto", dto: "org.communityboating.models.data.JwtToken", collection: false },
    { field: "refreshToken", kind: "dto", dto: "org.communityboating.models.data.JwtToken", collection: false },
  ],
  "org.communityboating.services.auth.ProtoLoginResult": [
    { field: "tokens", kind: "dto", dto: "org.communityboating.services.auth.AuthTokens", collection: false },
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "org.communityboating.services.classes.ClassEnrollmentResult": [
    { field: "signup", kind: "dto", dto: "generated.dto.ApClassSignupRef", collection: false },
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "org.communityboating.services.classes.GuidedSailDay": [
    { field: "date", kind: "date", collection: false },
    { field: "slots", kind: "dto", dto: "org.communityboating.services.classes.GuidedSailSlot", collection: true },
  ],
  "org.communityboating.services.classes.GuidedSailSlot": [
    { field: "start", kind: "date-time", collection: false },
    { field: "end", kind: "date-time", collection: false },
  ],
  "org.communityboating.services.classes.PersonClassEnrollment": [
    { field: "firstSession", kind: "date-time", collection: false },
    { field: "lastSession", kind: "date-time", collection: false },
  ],
  "org.communityboating.services.classes.PersonClassesPage": [
    { field: "items", kind: "dto", dto: "generated.dto.ClassUnifiedStaff", collection: true },
  ],
  "org.communityboating.services.classes.UnifiedClassComparisonReport": [
    { field: "differences", kind: "dto", dto: "org.communityboating.services.classes.UnifiedClassComparisonDifference", collection: true },
  ],
  "org.communityboating.services.classes.UnifiedClassSearchOptions": [
    { field: "startDate", kind: "date-time", collection: false },
    { field: "endDate", kind: "date-time", collection: false },
    { field: "people", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
  ],
  "org.communityboating.services.classes.UnifiedStaffClassesResponse": [
    { field: "classes", kind: "dto", dto: "generated.dto.ClassUnifiedStaff", collection: true },
  ],
  "org.communityboating.services.orders.AddToCart": [
    { field: "itemInstance", kind: "dto", dto: "generated.dto.CatalogItemInstanceRef", collection: false },
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "parent", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "options", kind: "dto", dto: "org.communityboating.services.orders.purchasables.ProvisionOptions", collection: false },
    { field: "updateLine", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "org.communityboating.services.orders.AgreementVersionChangeRequest": [
    { field: "agreementId", kind: "dto", dto: "generated.dto.AgreementRef", collection: false },
  ],
  "org.communityboating.services.orders.BalanceMemberPage": [
    { field: "items", kind: "dto", dto: "generated.dto.BalanceMember", collection: true },
  ],
  "org.communityboating.services.orders.BalanceSaveRequest": [
    { field: "balanceExpirationDate", kind: "date-time", collection: false },
    { field: "people", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
  ],
  "org.communityboating.services.orders.BalanceSearchOptions": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
  ],
  "org.communityboating.services.orders.BalanceStaffPage": [
    { field: "items", kind: "dto", dto: "generated.dto.BalanceStaff", collection: true },
  ],
  "org.communityboating.services.orders.CatalogPriceChangeRequest": [
    { field: "itemId", kind: "dto", dto: "generated.dto.CatalogItemRef", collection: false },
  ],
  "org.communityboating.services.orders.CheckoutReadiness": [
    { field: "problems", kind: "dto", dto: "org.communityboating.services.orders.CheckoutProblem", collection: true },
  ],
  "org.communityboating.services.orders.ConfigureDelivery": [
    { field: "personLookup", kind: "dto", dto: "generated.dto.PersonLookupRef", collection: false },
    { field: "targetPerson", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "targetAddress", kind: "dto", dto: "generated.dto.AddressRef", collection: false },
  ],
  "org.communityboating.services.orders.DiscountCandidate": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "org.communityboating.services.orders.DiscountOnLines": [
    { field: "discount", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
    { field: "lineItems", kind: "dto", dto: "generated.dto.LineItemRef", collection: true },
  ],
  "org.communityboating.services.orders.DiscountVersionChangeRequest": [
    { field: "discountId", kind: "dto", dto: "generated.dto.CatalogDiscountRef", collection: false },
  ],
  "org.communityboating.services.orders.EiiApplicationStatus": [
    { field: "application", kind: "dto", dto: "org.communityboating.services.orders.EiiApplication", collection: false },
  ],
  "org.communityboating.services.orders.ManualCaptureFailure": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "org.communityboating.services.orders.ManualCaptureResult": [
    { field: "capturedOrders", kind: "dto", dto: "generated.dto.OrderRef", collection: true },
    { field: "normalizedOrders", kind: "dto", dto: "generated.dto.OrderRef", collection: true },
    { field: "failures", kind: "dto", dto: "org.communityboating.services.orders.ManualCaptureFailure", collection: true },
  ],
  "org.communityboating.services.orders.OrderLineAdjustment": [
    { field: "discount", kind: "dto", dto: "generated.dto.LineItemDiscountInstanceRef", collection: false },
  ],
  "org.communityboating.services.orders.OrderLineDetail": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "discounts", kind: "dto", dto: "org.communityboating.services.orders.OrderLineAdjustment", collection: true },
    { field: "taxes", kind: "dto", dto: "org.communityboating.services.orders.OrderLineAdjustment", collection: true },
    { field: "donation", kind: "dto", dto: "org.communityboating.services.orders.purchasables.DonationPurchaseDetails", collection: false },
    { field: "guestMembership", kind: "dto", dto: "generated.dto.MembershipRef", collection: false },
  ],
  "org.communityboating.services.orders.OrderRefundPreview": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "lines", kind: "dto", dto: "org.communityboating.services.orders.RefundLinePreview", collection: true },
    { field: "payments", kind: "dto", dto: "org.communityboating.services.orders.RefundPaymentPreview", collection: true },
    { field: "revocationEffects", kind: "dto", dto: "org.communityboating.services.orders.RefundRevocationEffect", collection: true },
  ],
  "org.communityboating.services.orders.OrderRefundPreviewRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "lines", kind: "dto", dto: "org.communityboating.services.orders.RefundLineRequest", collection: true },
  ],
  "org.communityboating.services.orders.OrderRefundReconciliation": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
  ],
  "org.communityboating.services.orders.OrderRefundRequest": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "lines", kind: "dto", dto: "org.communityboating.services.orders.RefundLineRequest", collection: true },
    { field: "destinations", kind: "dto", dto: "org.communityboating.services.orders.RefundDestinationRequest", collection: true },
  ],
  "org.communityboating.services.orders.OrderRefundResult": [
    { field: "refund", kind: "dto", dto: "generated.dto.OrderRefundRef", collection: false },
  ],
  "org.communityboating.services.orders.PaymentAttempt": [
    { field: "payment", kind: "dto", dto: "generated.dto.OrderPaymentRef", collection: false },
  ],
  "org.communityboating.services.orders.RefundDestinationRequest": [
    { field: "payment", kind: "dto", dto: "generated.dto.OrderPaymentRef", collection: false },
    { field: "balance", kind: "dto", dto: "generated.dto.BalanceRef", collection: false },
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "org.communityboating.services.orders.RefundLinePreview": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "parentLineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
    { field: "taxes", kind: "dto", dto: "org.communityboating.services.orders.RefundTaxPreview", collection: true },
  ],
  "org.communityboating.services.orders.RefundLineRequest": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "org.communityboating.services.orders.RefundPaymentPreview": [
    { field: "payment", kind: "dto", dto: "generated.dto.OrderPaymentRef", collection: false },
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "org.communityboating.services.orders.RefundRevocationEffect": [
    { field: "lineItem", kind: "dto", dto: "generated.dto.LineItemRef", collection: false },
  ],
  "org.communityboating.services.orders.RefundTaxPreview": [
    { field: "tax", kind: "dto", dto: "generated.dto.LineItemTaxRef", collection: false },
  ],
  "org.communityboating.services.orders.SaveCatalogItemRequest": [
    { field: "create", kind: "dto", dto: "generated.dto.CreateCatalogItemStaff", collection: false },
    { field: "update", kind: "dto", dto: "generated.dto.UpdateCatalogItemStaff", collection: false },
    { field: "price", kind: "dto", dto: "org.communityboating.services.orders.CatalogItemPriceDraft", collection: false },
  ],
  "org.communityboating.services.orders.SettlementNormalizationPreview": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "settlementDays", kind: "date", collection: true },
  ],
  "org.communityboating.services.orders.SettlementNormalizationResult": [
    { field: "order", kind: "dto", dto: "generated.dto.OrderRef", collection: false },
    { field: "fundingOrders", kind: "dto", dto: "generated.dto.OrderRef", collection: true },
    { field: "balance", kind: "dto", dto: "generated.dto.BalanceRef", collection: false },
  ],
  "org.communityboating.services.orders.StartPayment": [
    { field: "balance", kind: "dto", dto: "generated.dto.BalanceRef", collection: false },
    { field: "cashDrawer", kind: "dto", dto: "generated.dto.CashDrawerRef", collection: false },
  ],
  "org.communityboating.services.orders.purchasables.DonationPurchaseDetails": [
    { field: "fund", kind: "dto", dto: "generated.dto.DonationFundRef", collection: false },
    { field: "initiative", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
  ],
  "org.communityboating.services.orders.purchasables.MemberDonationOptions": [
    { field: "funds", kind: "dto", dto: "generated.dto.DonationFundMember", collection: true },
    { field: "initiatives", kind: "dto", dto: "generated.dto.DonationInitiativeMember", collection: true },
    { field: "progress", kind: "dto", dto: "org.communityboating.services.orders.purchasables.DonationInitiativeProgress", collection: true },
    { field: "defaultInitiative", kind: "dto", dto: "generated.dto.DonationInitiativeRef", collection: false },
  ],
  "org.communityboating.services.orders.purchasables.ProvisionOptions": [
    { field: "membership", kind: "dto", dto: "generated.dto.MembershipRef", collection: false },
    { field: "donation", kind: "dto", dto: "org.communityboating.services.orders.purchasables.DonationPurchaseDetails", collection: false },
  ],
  "org.communityboating.services.orders.purchasables.StaffStockSummary": [
    { field: "itemInstance", kind: "dto", dto: "generated.dto.CatalogItemInstanceStaff", collection: false },
  ],
  "org.communityboating.services.people.CompleteMemberRegistration": [
    { field: "identity", kind: "dto", dto: "org.communityboating.services.people.CompleteMemberProfile", collection: false },
    { field: "profile", kind: "dto", dto: "org.communityboating.services.people.MemberProfileUpdate", collection: false },
  ],
  "org.communityboating.services.people.MemberAgreementStatus": [
    { field: "agreement", kind: "dto", dto: "generated.dto.AgreementMember", collection: false },
    { field: "latestInstance", kind: "dto", dto: "generated.dto.AgreementInstanceMember", collection: false },
    { field: "latestActionOn", kind: "date-time", collection: false },
  ],
  "org.communityboating.services.people.MemberAgreementStatuses": [
    { field: "items", kind: "dto", dto: "org.communityboating.services.people.MemberAgreementStatus", collection: true },
  ],
  "org.communityboating.services.people.MemberEmergencyContact": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhone", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddress", collection: true },
  ],
  "org.communityboating.services.people.MemberEmergencyContactCreate": [
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
  ],
  "org.communityboating.services.people.MemberEmergencyContactUpdate": [
    { field: "contact", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
  ],
  "org.communityboating.services.people.MemberProfile": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhone", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddress", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonMember", collection: true },
    { field: "emergencyContactDetails", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContact", collection: true },
  ],
  "org.communityboating.services.people.MemberProfileAddress": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
    { field: "address", kind: "dto", dto: "generated.dto.AddressMember", collection: false },
  ],
  "org.communityboating.services.people.MemberProfileAddressChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
  ],
  "org.communityboating.services.people.MemberProfileCreate": [
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
    { field: "newEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactCreate", collection: true },
    { field: "updatedEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactUpdate", collection: true },
  ],
  "org.communityboating.services.people.MemberProfilePhone": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
    { field: "phone", kind: "dto", dto: "generated.dto.PhoneMember", collection: false },
  ],
  "org.communityboating.services.people.MemberProfilePhoneChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
  ],
  "org.communityboating.services.people.MemberProfileUpdate": [
    { field: "person", kind: "dto", dto: "generated.dto.UpdatePersonMember", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.MemberProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.MemberProfileAddressChange", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
    { field: "newEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactCreate", collection: true },
    { field: "updatedEmergencyContacts", kind: "dto", dto: "org.communityboating.services.people.MemberEmergencyContactUpdate", collection: true },
  ],
  "org.communityboating.services.people.OptOutGroupStatus": [
    { field: "group", kind: "dto", dto: "generated.dto.OptOutGroup", collection: false },
    { field: "updatedOn", kind: "date-time", collection: false },
  ],
  "org.communityboating.services.people.OptOutStatus": [
    { field: "groups", kind: "dto", dto: "org.communityboating.services.people.OptOutGroupStatus", collection: true },
  ],
  "org.communityboating.services.people.PersonAgreementsPage": [
    { field: "items", kind: "dto", dto: "org.communityboating.services.people.PersonApplicableAgreement", collection: true },
  ],
  "org.communityboating.services.people.PersonApplicableAgreement": [
    { field: "agreement", kind: "dto", dto: "generated.dto.AgreementStaff", collection: false },
    { field: "latestInstance", kind: "dto", dto: "generated.dto.AgreementInstanceStaff", collection: false },
    { field: "latestAction", kind: "dto", dto: "generated.dto.PersonAgreementInstanceStaff", collection: false },
  ],
  "org.communityboating.services.people.PersonTypeMask": [
    { field: "personTypeId", kind: "dto", dto: "generated.dto.PersonTypeRef", collection: false },
  ],
  "org.communityboating.services.people.RecipientLookupResult": [
    { field: "lookup", kind: "dto", dto: "generated.dto.PersonLookupRef", collection: false },
  ],
  "org.communityboating.services.people.SavePersonAddress": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
  ],
  "org.communityboating.services.people.SavePersonPhone": [
    { field: "person", kind: "dto", dto: "generated.dto.PersonRef", collection: false },
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
  ],
  "org.communityboating.services.people.StaffProfileAddressChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonAddressRef", collection: false },
  ],
  "org.communityboating.services.people.StaffProfileCreateRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.CreatePersonStaff", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.StaffProfilePhone", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.StaffProfileAddress", collection: true },
    { field: "referrals", kind: "dto", dto: "org.communityboating.services.people.StaffProfileReferral", collection: true },
    { field: "emergencyContacts", kind: "dto", dto: "generated.dto.PersonRef", collection: true },
  ],
  "org.communityboating.services.people.StaffProfilePhoneChange": [
    { field: "association", kind: "dto", dto: "generated.dto.PersonPhoneRef", collection: false },
  ],
  "org.communityboating.services.people.StaffProfileReferralChange": [
    { field: "referral", kind: "dto", dto: "generated.dto.PersonReferralRef", collection: false },
  ],
  "org.communityboating.services.people.StaffProfileUpdateRequest": [
    { field: "person", kind: "dto", dto: "generated.dto.UpdatePersonStaff", collection: false },
    { field: "phones", kind: "dto", dto: "org.communityboating.services.people.StaffProfilePhoneChange", collection: true },
    { field: "addresses", kind: "dto", dto: "org.communityboating.services.people.StaffProfileAddressChange", collection: true },
    { field: "referrals", kind: "dto", dto: "org.communityboating.services.people.StaffProfileReferralChange", collection: true },
  ],
  "org.communityboating.services.reporting.DailySalesDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "categories", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesCategory", collection: true },
    { field: "summary", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesSummary", collection: false },
  ],
  "org.communityboating.services.reporting.DailySalesRequest": [
    { field: "createdOnStart", kind: "date", collection: false },
    { field: "createdOnEnd", kind: "date", collection: false },
    { field: "capturableOnStart", kind: "date", collection: false },
    { field: "capturableOnEnd", kind: "date", collection: false },
    { field: "dateStart", kind: "date", collection: false },
    { field: "dateEnd", kind: "date", collection: false },
  ],
  "org.communityboating.services.reporting.DailySalesStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesDataset", collection: false },
  ],
  "org.communityboating.services.reporting.DailySalesSummary": [
    { field: "categoryAmounts", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesCategoryTotal", collection: true },
    { field: "paymentTypeAmounts", kind: "dto", dto: "org.communityboating.services.reporting.DailySalesPaymentTotal", collection: true },
  ],
  "org.communityboating.services.reporting.InvalidOrderDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "org.communityboating.services.reporting.InvalidOrderRangeRun": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.reporting.InvalidOrderRequest", collection: false },
    { field: "requestedAt", kind: "date-time", collection: false },
  ],
  "org.communityboating.services.reporting.InvalidOrderRequest": [
    { field: "paidOnStart", kind: "date", collection: false },
    { field: "paidOnEnd", kind: "date", collection: false },
  ],
  "org.communityboating.services.reporting.InvalidOrderStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.InvalidOrderDataset", collection: false },
  ],
  "org.communityboating.services.reporting.InvalidSignupReconcileStatus": [
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
    { field: "lastResult", kind: "dto", dto: "org.communityboating.services.reporting.InvalidSignupReconcileResult", collection: false },
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
  ],
  "org.communityboating.services.reporting.ItemSalesDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "request", kind: "dto", dto: "org.communityboating.services.reporting.ItemSalesRequest", collection: false },
    { field: "totals", kind: "dto", dto: "org.communityboating.services.reporting.ItemSalesAmounts", collection: false },
    { field: "sourceRuns", kind: "dto", dto: "generated.dto.ReportRunRef", collection: true },
  ],
  "org.communityboating.services.reporting.ItemSalesRequest": [
    { field: "startDate", kind: "date", collection: false },
    { field: "endDate", kind: "date", collection: false },
  ],
  "org.communityboating.services.reporting.ItemSalesStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.ItemSalesDataset", collection: false },
  ],
  "org.communityboating.services.reporting.OrderMismatchDataset": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
  ],
  "org.communityboating.services.reporting.OrderMismatchStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
    { field: "dataset", kind: "dto", dto: "org.communityboating.services.reporting.OrderMismatchDataset", collection: false },
  ],
  "org.communityboating.services.reporting.ReportGenerationStatus": [
    { field: "runRef", kind: "dto", dto: "generated.dto.ReportRunRef", collection: false },
    { field: "requestedAt", kind: "date-time", collection: false },
    { field: "startedAt", kind: "date-time", collection: false },
    { field: "finishedAt", kind: "date-time", collection: false },
    { field: "lastSucceededAt", kind: "date-time", collection: false },
    { field: "publishedAt", kind: "date-time", collection: false },
  ],
  "org.communityboating.services.reporting.StripeIntentSyncRequest": [
    { field: "startDate", kind: "date", collection: false },
    { field: "endDate", kind: "date", collection: false },
  ],
  "org.communityboating.services.reporting.StripeIntentSyncStatus": [
    { field: "generation", kind: "dto", dto: "org.communityboating.services.reporting.ReportGenerationStatus", collection: false },
  ],
  "org.communityboating.services.reporting.StripeLedgerSyncRequest": [
    { field: "startDate", kind: "date", collection: false },
    { field: "endDate", kind: "date", collection: false },
  ],
};

const cbiDtoConstructors: Readonly<Record<string, new (...args: never[]) => object>> = {
  "generated.dto.AgreementCategoryStaff": AgreementCategoryStaff,
  "generated.dto.AgreementInstanceStaff": AgreementInstanceStaff,
  "generated.dto.AgreementStaff": AgreementStaff,
  "generated.dto.ApClassAttendanceStaff": ApClassAttendanceStaff,
  "generated.dto.ApClassFormatStaff": ApClassFormatStaff,
  "generated.dto.ApClassMember": ApClassMember,
  "generated.dto.ApClassSessionStaff": ApClassSessionStaff,
  "generated.dto.ApClassSignupStaff": ApClassSignupStaff,
  "generated.dto.ApClassStaff": ApClassStaff,
  "generated.dto.ApClassTypeOverrideStaff": ApClassTypeOverrideStaff,
  "generated.dto.ApClassTypeStaff": ApClassTypeStaff,
  "generated.dto.BalanceLookupCooldownStaff": BalanceLookupCooldownStaff,
  "generated.dto.BalanceStaff": BalanceStaff,
  "generated.dto.BalanceTransactionStaff": BalanceTransactionStaff,
  "generated.dto.CardStaff": CardStaff,
  "generated.dto.CashDrawerChangeStaff": CashDrawerChangeStaff,
  "generated.dto.CashDrawerStaff": CashDrawerStaff,
  "generated.dto.CashDrawerTotalStaff": CashDrawerTotalStaff,
  "generated.dto.CatalogDiscountCategoryStaff": CatalogDiscountCategoryStaff,
  "generated.dto.CatalogDiscountInstanceStaff": CatalogDiscountInstanceStaff,
  "generated.dto.CatalogDiscountStaff": CatalogDiscountStaff,
  "generated.dto.CatalogItemAgreementStaff": CatalogItemAgreementStaff,
  "generated.dto.CatalogItemCategoryStaff": CatalogItemCategoryStaff,
  "generated.dto.CatalogItemDiscountStaff": CatalogItemDiscountStaff,
  "generated.dto.CatalogItemInstanceStaff": CatalogItemInstanceStaff,
  "generated.dto.CatalogItemStaff": CatalogItemStaff,
  "generated.dto.CatalogItemTaxStaff": CatalogItemTaxStaff,
  "generated.dto.CatalogStaff": CatalogStaff,
  "generated.dto.CatalogTaxStaff": CatalogTaxStaff,
  "generated.dto.CategoryStaff": CategoryStaff,
  "generated.dto.ClassLocationStaff": ClassLocationStaff,
  "generated.dto.DailySalesReportStaff": DailySalesReportStaff,
  "generated.dto.DamageWaiverStaff": DamageWaiverStaff,
  "generated.dto.DonationStaff": DonationStaff,
  "generated.dto.GuestPrivilegeStaff": GuestPrivilegeStaff,
  "generated.dto.InvalidOrderReportStaff": InvalidOrderReportStaff,
  "generated.dto.InvalidSignupReasonStaff": InvalidSignupReasonStaff,
  "generated.dto.InvalidSignupReportStaff": InvalidSignupReportStaff,
  "generated.dto.JpClassAttendanceStaff": JpClassAttendanceStaff,
  "generated.dto.JpClassMember": JpClassMember,
  "generated.dto.JpClassSessionStaff": JpClassSessionStaff,
  "generated.dto.JpClassSignupStaff": JpClassSignupStaff,
  "generated.dto.JpClassStaff": JpClassStaff,
  "generated.dto.JpClassStaggerStaff": JpClassStaggerStaff,
  "generated.dto.JpClassTypeOverrideStaff": JpClassTypeOverrideStaff,
  "generated.dto.JpClassTypeStaff": JpClassTypeStaff,
  "generated.dto.LineItemDiscountInstanceStaff": LineItemDiscountInstanceStaff,
  "generated.dto.LineItemMember": LineItemMember,
  "generated.dto.LineItemRefundStaff": LineItemRefundStaff,
  "generated.dto.LineItemRefundTaxStaff": LineItemRefundTaxStaff,
  "generated.dto.LineItemStaff": LineItemStaff,
  "generated.dto.LineItemTaxStaff": LineItemTaxStaff,
  "generated.dto.MembershipMember": MembershipMember,
  "generated.dto.MembershipStaff": MembershipStaff,
  "generated.dto.MembershipTypeDiscountStaff": MembershipTypeDiscountStaff,
  "generated.dto.MembershipTypeStaff": MembershipTypeStaff,
  "generated.dto.OrderMember": OrderMember,
  "generated.dto.OrderPaymentStaff": OrderPaymentStaff,
  "generated.dto.OrderRefundStaff": OrderRefundStaff,
  "generated.dto.OrderStaff": OrderStaff,
  "generated.dto.PaymentRefundStaff": PaymentRefundStaff,
  "generated.dto.PersonAddressStaff": PersonAddressStaff,
  "generated.dto.PersonAgreementInstanceStaff": PersonAgreementInstanceStaff,
  "generated.dto.PersonBalanceStaff": PersonBalanceStaff,
  "generated.dto.PersonCheckInStaff": PersonCheckInStaff,
  "generated.dto.PersonCommentStaff": PersonCommentStaff,
  "generated.dto.PersonMember": PersonMember,
  "generated.dto.PersonPersonTypeStaff": PersonPersonTypeStaff,
  "generated.dto.PersonPhoneStaff": PersonPhoneStaff,
  "generated.dto.PersonRatingStaff": PersonRatingStaff,
  "generated.dto.PersonRelationStaff": PersonRelationStaff,
  "generated.dto.PersonSkillChangeStaff": PersonSkillChangeStaff,
  "generated.dto.PersonSkillStaff": PersonSkillStaff,
  "generated.dto.PersonStaff": PersonStaff,
  "generated.dto.PersonTagStaff": PersonTagStaff,
  "generated.dto.PrinterStaff": PrinterStaff,
  "generated.dto.ProductStaff": ProductStaff,
  "generated.dto.PurchaseDeliveryStaff": PurchaseDeliveryStaff,
  "generated.dto.RatingChangeStaff": RatingChangeStaff,
  "generated.dto.RatingProgramStaff": RatingProgramStaff,
  "generated.dto.RatingStaff": RatingStaff,
  "generated.dto.ReportRunStaff": ReportRunStaff,
  "generated.dto.RoleAssignmentStaff": RoleAssignmentStaff,
  "generated.dto.RolePermissionStaff": RolePermissionStaff,
  "generated.dto.RoleStaff": RoleStaff,
  "generated.dto.ScopesStaff": ScopesStaff,
  "generated.dto.SignoutCrewStaff": SignoutCrewStaff,
  "generated.dto.SignoutStaff": SignoutStaff,
  "generated.dto.SkillAssessmentStaff": SkillAssessmentStaff,
  "generated.dto.StockChangeStaff": StockChangeStaff,
  "generated.dto.TestChildResource": TestChildResource,
  "generated.dto.TestResource": TestResource,
  "generated.dto.UserPermissionStaff": UserPermissionStaff,
  "generated.dto.UserStaff": UserStaff,
  "generated.dto.YearlyDateStaff": YearlyDateStaff,
};

const cbiDtoAliases: Readonly<Record<string, string>> = {
  "generated.dto.AddressMemberSearchParams": "generated.dto.AddressSearchParams",
  "generated.dto.AddressMemberSearchResult": "generated.dto.AddressMember",
  "generated.dto.AddressSearchResult": "generated.dto.Address",
  "generated.dto.AddressStaffSearchParams": "generated.dto.AddressSearchParams",
  "generated.dto.AddressStaffSearchResult": "generated.dto.AddressStaff",
  "generated.dto.AgreementCategoryStaffFetchOptions": "generated.dto.AgreementCategoryFetchOptions",
  "generated.dto.AgreementInstanceSearchResult": "generated.dto.AgreementInstance",
  "generated.dto.AgreementInstanceStaffFetchOptions": "generated.dto.AgreementInstanceFetchOptions",
  "generated.dto.AgreementInstanceStaffSearchParams": "generated.dto.AgreementInstanceSearchParams",
  "generated.dto.AgreementInstanceStaffSearchResult": "generated.dto.AgreementInstanceStaff",
  "generated.dto.AgreementSearchResult": "generated.dto.Agreement",
  "generated.dto.AgreementStaffFetchOptions": "generated.dto.AgreementFetchOptions",
  "generated.dto.AgreementStaffSearchParams": "generated.dto.AgreementSearchParams",
  "generated.dto.AgreementStaffSearchResult": "generated.dto.AgreementStaff",
  "generated.dto.ApClassAttendanceStaffFetchOptions": "generated.dto.ApClassAttendanceFetchOptions",
  "generated.dto.ApClassFormatSearchResult": "generated.dto.ApClassFormat",
  "generated.dto.ApClassFormatStaffFetchOptions": "generated.dto.ApClassFormatFetchOptions",
  "generated.dto.ApClassFormatStaffSearchResult": "generated.dto.ApClassFormatStaff",
  "generated.dto.ApClassSearchResult": "generated.dto.ApClass",
  "generated.dto.ApClassSessionSearchResult": "generated.dto.ApClassSession",
  "generated.dto.ApClassSessionStaffFetchOptions": "generated.dto.ApClassSessionFetchOptions",
  "generated.dto.ApClassSessionStaffSearchParams": "generated.dto.ApClassSessionSearchParams",
  "generated.dto.ApClassSessionStaffSearchResult": "generated.dto.ApClassSessionStaff",
  "generated.dto.ApClassSignupSearchResult": "generated.dto.ApClassSignup",
  "generated.dto.ApClassSignupStaffSearchResult": "generated.dto.ApClassSignupStaff",
  "generated.dto.ApClassStaffFetchOptions": "generated.dto.ApClassFetchOptions",
  "generated.dto.ApClassStaffSearchParams": "generated.dto.ApClassSearchParams",
  "generated.dto.ApClassStaffSearchResult": "generated.dto.ApClassStaff",
  "generated.dto.ApClassTypeMemberSearchParams": "generated.dto.ApClassTypeSearchParams",
  "generated.dto.ApClassTypeMemberSearchResult": "generated.dto.ApClassTypeMember",
  "generated.dto.ApClassTypeOverrideStaffFetchOptions": "generated.dto.ApClassTypeOverrideFetchOptions",
  "generated.dto.ApClassTypeSearchResult": "generated.dto.ApClassType",
  "generated.dto.ApClassTypeStaffFetchOptions": "generated.dto.ApClassTypeFetchOptions",
  "generated.dto.ApClassTypeStaffSearchParams": "generated.dto.ApClassTypeSearchParams",
  "generated.dto.ApClassTypeStaffSearchResult": "generated.dto.ApClassTypeStaff",
  "generated.dto.ApClassWlResultMemberFetchOptions": "generated.dto.ApClassWlResultFetchOptions",
  "generated.dto.ApClassWlResultStaffFetchOptions": "generated.dto.ApClassWlResultFetchOptions",
  "generated.dto.AssessmentStaffSearchResult": "generated.dto.AssessmentStaff",
  "generated.dto.BalanceLookupCooldownStaffFetchOptions": "generated.dto.BalanceLookupCooldownFetchOptions",
  "generated.dto.BalanceStaffFetchOptions": "generated.dto.BalanceFetchOptions",
  "generated.dto.BalanceStaffSearchParams": "generated.dto.BalanceSearchParams",
  "generated.dto.BalanceStaffSearchResult": "generated.dto.BalanceStaff",
  "generated.dto.BalanceTransactionStaffFetchOptions": "generated.dto.BalanceTransactionFetchOptions",
  "generated.dto.BalanceTransactionStaffSearchParams": "generated.dto.BalanceTransactionSearchParams",
  "generated.dto.BalanceTransactionStaffSearchResult": "generated.dto.BalanceTransactionStaff",
  "generated.dto.BoatTypeStaffSearchResult": "generated.dto.BoatTypeStaff",
  "generated.dto.CardMemberSearchParams": "generated.dto.CardSearchParams",
  "generated.dto.CardMemberSearchResult": "generated.dto.CardMember",
  "generated.dto.CardSearchResult": "generated.dto.Card",
  "generated.dto.CardStaffFetchOptions": "generated.dto.CardFetchOptions",
  "generated.dto.CardStaffSearchParams": "generated.dto.CardSearchParams",
  "generated.dto.CardStaffSearchResult": "generated.dto.CardStaff",
  "generated.dto.CashDrawerChangeStaffFetchOptions": "generated.dto.CashDrawerChangeFetchOptions",
  "generated.dto.CashDrawerStaffFetchOptions": "generated.dto.CashDrawerFetchOptions",
  "generated.dto.CashDrawerStaffSearchParams": "generated.dto.CashDrawerSearchParams",
  "generated.dto.CashDrawerStaffSearchResult": "generated.dto.CashDrawerStaff",
  "generated.dto.CashDrawerTotalStaffFetchOptions": "generated.dto.CashDrawerTotalFetchOptions",
  "generated.dto.CatalogDiscountCategorySearchResult": "generated.dto.CatalogDiscountCategory",
  "generated.dto.CatalogDiscountCategoryStaffFetchOptions": "generated.dto.CatalogDiscountCategoryFetchOptions",
  "generated.dto.CatalogDiscountCategoryStaffSearchResult": "generated.dto.CatalogDiscountCategoryStaff",
  "generated.dto.CatalogDiscountInstanceStaffFetchOptions": "generated.dto.CatalogDiscountInstanceFetchOptions",
  "generated.dto.CatalogDiscountSearchResult": "generated.dto.CatalogDiscount",
  "generated.dto.CatalogDiscountStaffFetchOptions": "generated.dto.CatalogDiscountFetchOptions",
  "generated.dto.CatalogDiscountStaffSearchParams": "generated.dto.CatalogDiscountSearchParams",
  "generated.dto.CatalogDiscountStaffSearchResult": "generated.dto.CatalogDiscountStaff",
  "generated.dto.CatalogItemAgreementMemberFetchOptions": "generated.dto.CatalogItemAgreementFetchOptions",
  "generated.dto.CatalogItemAgreementStaffFetchOptions": "generated.dto.CatalogItemAgreementFetchOptions",
  "generated.dto.CatalogItemCategoryMemberFetchOptions": "generated.dto.CatalogItemCategoryFetchOptions",
  "generated.dto.CatalogItemCategoryStaffFetchOptions": "generated.dto.CatalogItemCategoryFetchOptions",
  "generated.dto.CatalogItemDiscountMemberFetchOptions": "generated.dto.CatalogItemDiscountFetchOptions",
  "generated.dto.CatalogItemDiscountStaffFetchOptions": "generated.dto.CatalogItemDiscountFetchOptions",
  "generated.dto.CatalogItemInstanceStaffFetchOptions": "generated.dto.CatalogItemInstanceFetchOptions",
  "generated.dto.CatalogItemSearchResult": "generated.dto.CatalogItem",
  "generated.dto.CatalogItemStaffFetchOptions": "generated.dto.CatalogItemFetchOptions",
  "generated.dto.CatalogItemStaffSearchParams": "generated.dto.CatalogItemSearchParams",
  "generated.dto.CatalogItemStaffSearchResult": "generated.dto.CatalogItemStaff",
  "generated.dto.CatalogItemTaxMemberFetchOptions": "generated.dto.CatalogItemTaxFetchOptions",
  "generated.dto.CatalogItemTaxStaffFetchOptions": "generated.dto.CatalogItemTaxFetchOptions",
  "generated.dto.CatalogMemberFetchOptions": "generated.dto.CatalogFetchOptions",
  "generated.dto.CatalogSearchResult": "generated.dto.Catalog",
  "generated.dto.CatalogStaffFetchOptions": "generated.dto.CatalogFetchOptions",
  "generated.dto.CatalogStaffSearchParams": "generated.dto.CatalogSearchParams",
  "generated.dto.CatalogStaffSearchResult": "generated.dto.CatalogStaff",
  "generated.dto.CatalogTaxMemberFetchOptions": "generated.dto.CatalogTaxFetchOptions",
  "generated.dto.CatalogTaxSearchResult": "generated.dto.CatalogTax",
  "generated.dto.CatalogTaxStaffFetchOptions": "generated.dto.CatalogTaxFetchOptions",
  "generated.dto.CatalogTaxStaffSearchParams": "generated.dto.CatalogTaxSearchParams",
  "generated.dto.CatalogTaxStaffSearchResult": "generated.dto.CatalogTaxStaff",
  "generated.dto.CategorySearchResult": "generated.dto.Category",
  "generated.dto.CategoryStaffFetchOptions": "generated.dto.CategoryFetchOptions",
  "generated.dto.CategoryStaffSearchParams": "generated.dto.CategorySearchParams",
  "generated.dto.CategoryStaffSearchResult": "generated.dto.CategoryStaff",
  "generated.dto.ClassLocationSearchResult": "generated.dto.ClassLocation",
  "generated.dto.ClassLocationStaffFetchOptions": "generated.dto.ClassLocationFetchOptions",
  "generated.dto.ClassLocationStaffSearchResult": "generated.dto.ClassLocationStaff",
  "generated.dto.ClassUnifiedStaffFetchOptions": "generated.dto.ClassUnifiedFetchOptions",
  "generated.dto.CreateAddressMember": "generated.dto.CreateAddress",
  "generated.dto.CreateAddressStaff": "generated.dto.CreateAddress",
  "generated.dto.CreateAgreementCategoryStaff": "generated.dto.CreateAgreementCategory",
  "generated.dto.CreateAgreementInstanceStaff": "generated.dto.CreateAgreementInstance",
  "generated.dto.CreateAgreementStaff": "generated.dto.CreateAgreement",
  "generated.dto.CreateAmericanStateStaff": "generated.dto.CreateAmericanState",
  "generated.dto.CreateApClassAttendanceStaff": "generated.dto.CreateApClassAttendance",
  "generated.dto.CreateApClassFormatStaff": "generated.dto.CreateApClassFormat",
  "generated.dto.CreateApClassSessionStaff": "generated.dto.CreateApClassSession",
  "generated.dto.CreateApClassSignupStaff": "generated.dto.CreateApClassSignup",
  "generated.dto.CreateApClassStaff": "generated.dto.CreateApClass",
  "generated.dto.CreateApClassTypeOverrideStaff": "generated.dto.CreateApClassTypeOverride",
  "generated.dto.CreateApClassTypeStaff": "generated.dto.CreateApClassType",
  "generated.dto.CreateApClassWlResultStaff": "generated.dto.CreateApClassWlResult",
  "generated.dto.CreateBoatTypeStaff": "generated.dto.CreateBoatType",
  "generated.dto.CreateCashDrawerStaff": "generated.dto.CreateCashDrawer",
  "generated.dto.CreateCatalogDiscountCategoryStaff": "generated.dto.CreateCatalogDiscountCategory",
  "generated.dto.CreateCatalogDiscountInstanceStaff": "generated.dto.CreateCatalogDiscountInstance",
  "generated.dto.CreateCatalogDiscountStaff": "generated.dto.CreateCatalogDiscount",
  "generated.dto.CreateCatalogItemAgreementStaff": "generated.dto.CreateCatalogItemAgreement",
  "generated.dto.CreateCatalogItemCategoryStaff": "generated.dto.CreateCatalogItemCategory",
  "generated.dto.CreateCatalogItemDiscountStaff": "generated.dto.CreateCatalogItemDiscount",
  "generated.dto.CreateCatalogItemInstanceStaff": "generated.dto.CreateCatalogItemInstance",
  "generated.dto.CreateCatalogItemTaxStaff": "generated.dto.CreateCatalogItemTax",
  "generated.dto.CreateCatalogStaff": "generated.dto.CreateCatalog",
  "generated.dto.CreateCatalogTaxStaff": "generated.dto.CreateCatalogTax",
  "generated.dto.CreateCategoryStaff": "generated.dto.CreateCategory",
  "generated.dto.CreateClassLocationStaff": "generated.dto.CreateClassLocation",
  "generated.dto.CreateCountryStaff": "generated.dto.CreateCountry",
  "generated.dto.CreateDamageWaiverTypeStaff": "generated.dto.CreateDamageWaiverType",
  "generated.dto.CreateDatetimeRangeStaff": "generated.dto.CreateDatetimeRange",
  "generated.dto.CreateDonationInitiativeStaff": "generated.dto.CreateDonationInitiative",
  "generated.dto.CreateDonationStaff": "generated.dto.CreateDonation",
  "generated.dto.CreateEiiOverrideStaff": "generated.dto.CreateEiiOverride",
  "generated.dto.CreateJpClassAttendanceStaff": "generated.dto.CreateJpClassAttendance",
  "generated.dto.CreateJpClassSessionStaff": "generated.dto.CreateJpClassSession",
  "generated.dto.CreateJpClassSignupStaff": "generated.dto.CreateJpClassSignup",
  "generated.dto.CreateJpClassStaff": "generated.dto.CreateJpClass",
  "generated.dto.CreateJpClassStaggerStaff": "generated.dto.CreateJpClassStagger",
  "generated.dto.CreateJpClassTypeOverrideStaff": "generated.dto.CreateJpClassTypeOverride",
  "generated.dto.CreateJpClassTypeStaff": "generated.dto.CreateJpClassType",
  "generated.dto.CreateJpClassWlResultStaff": "generated.dto.CreateJpClassWlResult",
  "generated.dto.CreateMembershipTypeDiscountStaff": "generated.dto.CreateMembershipTypeDiscount",
  "generated.dto.CreateMembershipTypeStaff": "generated.dto.CreateMembershipType",
  "generated.dto.CreatePersonAddressStaff": "generated.dto.CreatePersonAddress",
  "generated.dto.CreatePersonPersonTypeStaff": "generated.dto.CreatePersonPersonType",
  "generated.dto.CreatePersonPhoneStaff": "generated.dto.CreatePersonPhone",
  "generated.dto.CreatePersonReferralStaff": "generated.dto.CreatePersonReferral",
  "generated.dto.CreatePersonRelationStaff": "generated.dto.CreatePersonRelation",
  "generated.dto.CreatePersonTypeStaff": "generated.dto.CreatePersonType",
  "generated.dto.CreatePhoneMember": "generated.dto.CreatePhone",
  "generated.dto.CreatePhoneStaff": "generated.dto.CreatePhone",
  "generated.dto.CreateProductStaff": "generated.dto.CreateProduct",
  "generated.dto.CreateRatingProgramStaff": "generated.dto.CreateRatingProgram",
  "generated.dto.CreateRatingStaff": "generated.dto.CreateRating",
  "generated.dto.CreateRecurringDonationStaff": "generated.dto.CreateRecurringDonation",
  "generated.dto.CreateRoleAssignmentStaff": "generated.dto.CreateRoleAssignment",
  "generated.dto.CreateRolePermissionStaff": "generated.dto.CreateRolePermission",
  "generated.dto.CreateRoleStaff": "generated.dto.CreateRole",
  "generated.dto.CreateScopesStaff": "generated.dto.CreateScopes",
  "generated.dto.CreateStockChangeStaff": "generated.dto.CreateStockChange",
  "generated.dto.CreateSunsetTimeStaff": "generated.dto.CreateSunsetTime",
  "generated.dto.CreateSwimProofMethodStaff": "generated.dto.CreateSwimProofMethod",
  "generated.dto.CreateTagStaff": "generated.dto.CreateTag",
  "generated.dto.CreateUserPermissionStaff": "generated.dto.CreateUserPermission",
  "generated.dto.CreateYearlyDateItemStaff": "generated.dto.CreateYearlyDateItem",
  "generated.dto.CreateYearlyDateStaff": "generated.dto.CreateYearlyDate",
  "generated.dto.DailySalesCategoryAmountStaffSearchParams": "generated.dto.DailySalesCategoryAmountSearchParams",
  "generated.dto.DailySalesCategoryAmountStaffSearchResult": "generated.dto.DailySalesCategoryAmountStaff",
  "generated.dto.DailySalesPaymentTypeAmountStaffSearchParams": "generated.dto.DailySalesPaymentTypeAmountSearchParams",
  "generated.dto.DailySalesPaymentTypeAmountStaffSearchResult": "generated.dto.DailySalesPaymentTypeAmountStaff",
  "generated.dto.DailySalesReportStaffFetchOptions": "generated.dto.DailySalesReportFetchOptions",
  "generated.dto.DailySalesReportStaffSearchParams": "generated.dto.DailySalesReportSearchParams",
  "generated.dto.DailySalesReportStaffSearchResult": "generated.dto.DailySalesReportStaff",
  "generated.dto.DamageWaiverMemberSearchParams": "generated.dto.DamageWaiverSearchParams",
  "generated.dto.DamageWaiverMemberSearchResult": "generated.dto.DamageWaiverMember",
  "generated.dto.DamageWaiverSearchResult": "generated.dto.DamageWaiver",
  "generated.dto.DamageWaiverStaffFetchOptions": "generated.dto.DamageWaiverFetchOptions",
  "generated.dto.DamageWaiverStaffSearchParams": "generated.dto.DamageWaiverSearchParams",
  "generated.dto.DamageWaiverStaffSearchResult": "generated.dto.DamageWaiverStaff",
  "generated.dto.DamageWaiverTypeSearchResult": "generated.dto.DamageWaiverType",
  "generated.dto.DamageWaiverTypeStaffSearchParams": "generated.dto.DamageWaiverTypeSearchParams",
  "generated.dto.DamageWaiverTypeStaffSearchResult": "generated.dto.DamageWaiverTypeStaff",
  "generated.dto.DonationFundStaffSearchResult": "generated.dto.DonationFundStaff",
  "generated.dto.DonationInitiativeStaffSearchParams": "generated.dto.DonationInitiativeSearchParams",
  "generated.dto.DonationInitiativeStaffSearchResult": "generated.dto.DonationInitiativeStaff",
  "generated.dto.DonationMemberSearchResult": "generated.dto.DonationMember",
  "generated.dto.DonationStaffFetchOptions": "generated.dto.DonationFetchOptions",
  "generated.dto.DonationStaffSearchParams": "generated.dto.DonationSearchParams",
  "generated.dto.DonationStaffSearchResult": "generated.dto.DonationStaff",
  "generated.dto.EiiOverrideStaffSearchParams": "generated.dto.EiiOverrideSearchParams",
  "generated.dto.EiiOverrideStaffSearchResult": "generated.dto.EiiOverrideStaff",
  "generated.dto.EiiResponseStaffSearchResult": "generated.dto.EiiResponseStaff",
  "generated.dto.GuestPrivilegeStaffFetchOptions": "generated.dto.GuestPrivilegeFetchOptions",
  "generated.dto.InvalidOrderReasonStaffSearchParams": "generated.dto.InvalidOrderReasonSearchParams",
  "generated.dto.InvalidOrderReasonStaffSearchResult": "generated.dto.InvalidOrderReasonStaff",
  "generated.dto.InvalidOrderReportStaffFetchOptions": "generated.dto.InvalidOrderReportFetchOptions",
  "generated.dto.InvalidOrderReportStaffSearchParams": "generated.dto.InvalidOrderReportSearchParams",
  "generated.dto.InvalidOrderReportStaffSearchResult": "generated.dto.InvalidOrderReportStaff",
  "generated.dto.InvalidSignupReasonStaffFetchOptions": "generated.dto.InvalidSignupReasonFetchOptions",
  "generated.dto.InvalidSignupReasonStaffSearchParams": "generated.dto.InvalidSignupReasonSearchParams",
  "generated.dto.InvalidSignupReasonStaffSearchResult": "generated.dto.InvalidSignupReasonStaff",
  "generated.dto.InvalidSignupReportStaffFetchOptions": "generated.dto.InvalidSignupReportFetchOptions",
  "generated.dto.InvalidSignupReportStaffSearchParams": "generated.dto.InvalidSignupReportSearchParams",
  "generated.dto.InvalidSignupReportStaffSearchResult": "generated.dto.InvalidSignupReportStaff",
  "generated.dto.ItemSalesDetailStaffSearchResult": "generated.dto.ItemSalesDetailStaff",
  "generated.dto.ItemSalesReportStaffSearchParams": "generated.dto.ItemSalesReportSearchParams",
  "generated.dto.ItemSalesReportStaffSearchResult": "generated.dto.ItemSalesReportStaff",
  "generated.dto.JpClassAttendanceStaffFetchOptions": "generated.dto.JpClassAttendanceFetchOptions",
  "generated.dto.JpClassSearchResult": "generated.dto.JpClass",
  "generated.dto.JpClassSessionStaffFetchOptions": "generated.dto.JpClassSessionFetchOptions",
  "generated.dto.JpClassSignupSearchResult": "generated.dto.JpClassSignup",
  "generated.dto.JpClassSignupStaffFetchOptions": "generated.dto.JpClassSignupFetchOptions",
  "generated.dto.JpClassSignupStaffSearchResult": "generated.dto.JpClassSignupStaff",
  "generated.dto.JpClassStaffFetchOptions": "generated.dto.JpClassFetchOptions",
  "generated.dto.JpClassStaffSearchParams": "generated.dto.JpClassSearchParams",
  "generated.dto.JpClassStaffSearchResult": "generated.dto.JpClassStaff",
  "generated.dto.JpClassStaggerStaffFetchOptions": "generated.dto.JpClassStaggerFetchOptions",
  "generated.dto.JpClassTypeMemberSearchParams": "generated.dto.JpClassTypeSearchParams",
  "generated.dto.JpClassTypeMemberSearchResult": "generated.dto.JpClassTypeMember",
  "generated.dto.JpClassTypeOverrideStaffFetchOptions": "generated.dto.JpClassTypeOverrideFetchOptions",
  "generated.dto.JpClassTypeSearchResult": "generated.dto.JpClassType",
  "generated.dto.JpClassTypeStaffFetchOptions": "generated.dto.JpClassTypeFetchOptions",
  "generated.dto.JpClassTypeStaffSearchParams": "generated.dto.JpClassTypeSearchParams",
  "generated.dto.JpClassTypeStaffSearchResult": "generated.dto.JpClassTypeStaff",
  "generated.dto.JpClassWlResultMemberFetchOptions": "generated.dto.JpClassWlResultFetchOptions",
  "generated.dto.JpClassWlResultStaffFetchOptions": "generated.dto.JpClassWlResultFetchOptions",
  "generated.dto.LineItemDiscountInstanceStaffFetchOptions": "generated.dto.LineItemDiscountInstanceFetchOptions",
  "generated.dto.LineItemRefundStaffFetchOptions": "generated.dto.LineItemRefundFetchOptions",
  "generated.dto.LineItemRefundTaxStaffFetchOptions": "generated.dto.LineItemRefundTaxFetchOptions",
  "generated.dto.LineItemStaffFetchOptions": "generated.dto.LineItemFetchOptions",
  "generated.dto.LineItemTaxStaffFetchOptions": "generated.dto.LineItemTaxFetchOptions",
  "generated.dto.MembershipMemberSearchParams": "generated.dto.MembershipSearchParams",
  "generated.dto.MembershipMemberSearchResult": "generated.dto.MembershipMember",
  "generated.dto.MembershipSearchResult": "generated.dto.Membership",
  "generated.dto.MembershipStaffSearchParams": "generated.dto.MembershipSearchParams",
  "generated.dto.MembershipStaffSearchResult": "generated.dto.MembershipStaff",
  "generated.dto.MembershipTypeDiscountMemberFetchOptions": "generated.dto.MembershipTypeDiscountFetchOptions",
  "generated.dto.MembershipTypeDiscountStaffFetchOptions": "generated.dto.MembershipTypeDiscountFetchOptions",
  "generated.dto.MembershipTypeMemberFetchOptions": "generated.dto.MembershipTypeFetchOptions",
  "generated.dto.MembershipTypeMemberSearchResult": "generated.dto.MembershipTypeMember",
  "generated.dto.MembershipTypeSearchResult": "generated.dto.MembershipType",
  "generated.dto.MembershipTypeStaffFetchOptions": "generated.dto.MembershipTypeFetchOptions",
  "generated.dto.MembershipTypeStaffSearchParams": "generated.dto.MembershipTypeSearchParams",
  "generated.dto.MembershipTypeStaffSearchResult": "generated.dto.MembershipTypeStaff",
  "generated.dto.OrderMemberSearchResult": "generated.dto.OrderMember",
  "generated.dto.OrderMismatchReportStaffSearchParams": "generated.dto.OrderMismatchReportSearchParams",
  "generated.dto.OrderMismatchReportStaffSearchResult": "generated.dto.OrderMismatchReportStaff",
  "generated.dto.OrderPaymentStaffFetchOptions": "generated.dto.OrderPaymentFetchOptions",
  "generated.dto.OrderPaymentStaffSearchResult": "generated.dto.OrderPaymentStaff",
  "generated.dto.OrderRefundStaffFetchOptions": "generated.dto.OrderRefundFetchOptions",
  "generated.dto.OrderStaffFetchOptions": "generated.dto.OrderFetchOptions",
  "generated.dto.OrderStaffSearchParams": "generated.dto.OrderSearchParams",
  "generated.dto.OrderStaffSearchResult": "generated.dto.OrderStaff",
  "generated.dto.PaymentRefundStaffFetchOptions": "generated.dto.PaymentRefundFetchOptions",
  "generated.dto.PersonAddressSearchResult": "generated.dto.PersonAddress",
  "generated.dto.PersonAddressStaffFetchOptions": "generated.dto.PersonAddressFetchOptions",
  "generated.dto.PersonAddressStaffSearchParams": "generated.dto.PersonAddressSearchParams",
  "generated.dto.PersonAddressStaffSearchResult": "generated.dto.PersonAddressStaff",
  "generated.dto.PersonAgreementInstanceStaffFetchOptions": "generated.dto.PersonAgreementInstanceFetchOptions",
  "generated.dto.PersonAgreementInstanceStaffSearchParams": "generated.dto.PersonAgreementInstanceSearchParams",
  "generated.dto.PersonAgreementInstanceStaffSearchResult": "generated.dto.PersonAgreementInstanceStaff",
  "generated.dto.PersonBalanceStaffFetchOptions": "generated.dto.PersonBalanceFetchOptions",
  "generated.dto.PersonCheckInSearchResult": "generated.dto.PersonCheckIn",
  "generated.dto.PersonCheckInStaffFetchOptions": "generated.dto.PersonCheckInFetchOptions",
  "generated.dto.PersonCheckInStaffSearchParams": "generated.dto.PersonCheckInSearchParams",
  "generated.dto.PersonCheckInStaffSearchResult": "generated.dto.PersonCheckInStaff",
  "generated.dto.PersonCommentStaffFetchOptions": "generated.dto.PersonCommentFetchOptions",
  "generated.dto.PersonCommentStaffSearchParams": "generated.dto.PersonCommentSearchParams",
  "generated.dto.PersonCommentStaffSearchResult": "generated.dto.PersonCommentStaff",
  "generated.dto.PersonMemberSearchResult": "generated.dto.PersonMember",
  "generated.dto.PersonPersonTypeMemberSearchResult": "generated.dto.PersonPersonTypeMember",
  "generated.dto.PersonPersonTypeSearchResult": "generated.dto.PersonPersonType",
  "generated.dto.PersonPersonTypeStaffFetchOptions": "generated.dto.PersonPersonTypeFetchOptions",
  "generated.dto.PersonPersonTypeStaffSearchResult": "generated.dto.PersonPersonTypeStaff",
  "generated.dto.PersonPhoneMemberSearchResult": "generated.dto.PersonPhoneMember",
  "generated.dto.PersonPhoneSearchResult": "generated.dto.PersonPhone",
  "generated.dto.PersonPhoneStaffFetchOptions": "generated.dto.PersonPhoneFetchOptions",
  "generated.dto.PersonPhoneStaffSearchParams": "generated.dto.PersonPhoneSearchParams",
  "generated.dto.PersonPhoneStaffSearchResult": "generated.dto.PersonPhoneStaff",
  "generated.dto.PersonRatingMemberFetchOptions": "generated.dto.PersonRatingFetchOptions",
  "generated.dto.PersonRatingSearchResult": "generated.dto.PersonRating",
  "generated.dto.PersonRatingStaffFetchOptions": "generated.dto.PersonRatingFetchOptions",
  "generated.dto.PersonRatingStaffSearchParams": "generated.dto.PersonRatingSearchParams",
  "generated.dto.PersonRatingStaffSearchResult": "generated.dto.PersonRatingStaff",
  "generated.dto.PersonReferralSearchResult": "generated.dto.PersonReferral",
  "generated.dto.PersonReferralStaffSearchParams": "generated.dto.PersonReferralSearchParams",
  "generated.dto.PersonReferralStaffSearchResult": "generated.dto.PersonReferralStaff",
  "generated.dto.PersonRelationSearchResult": "generated.dto.PersonRelation",
  "generated.dto.PersonRelationStaffFetchOptions": "generated.dto.PersonRelationFetchOptions",
  "generated.dto.PersonRelationStaffSearchParams": "generated.dto.PersonRelationSearchParams",
  "generated.dto.PersonRelationStaffSearchResult": "generated.dto.PersonRelationStaff",
  "generated.dto.PersonSearchResult": "generated.dto.Person",
  "generated.dto.PersonSkillChangeStaffFetchOptions": "generated.dto.PersonSkillChangeFetchOptions",
  "generated.dto.PersonSkillChangeStaffSearchParams": "generated.dto.PersonSkillChangeSearchParams",
  "generated.dto.PersonSkillChangeStaffSearchResult": "generated.dto.PersonSkillChangeStaff",
  "generated.dto.PersonSkillStaffFetchOptions": "generated.dto.PersonSkillFetchOptions",
  "generated.dto.PersonSkillStaffSearchParams": "generated.dto.PersonSkillSearchParams",
  "generated.dto.PersonSkillStaffSearchResult": "generated.dto.PersonSkillStaff",
  "generated.dto.PersonStaffFetchOptions": "generated.dto.PersonFetchOptions",
  "generated.dto.PersonStaffSearchResult": "generated.dto.PersonStaff",
  "generated.dto.PersonTagStaffFetchOptions": "generated.dto.PersonTagFetchOptions",
  "generated.dto.PersonTagStaffSearchParams": "generated.dto.PersonTagSearchParams",
  "generated.dto.PersonTagStaffSearchResult": "generated.dto.PersonTagStaff",
  "generated.dto.PersonTypeSearchResult": "generated.dto.PersonType",
  "generated.dto.PersonTypeStaffSearchResult": "generated.dto.PersonTypeStaff",
  "generated.dto.PhoneMemberSearchParams": "generated.dto.PhoneSearchParams",
  "generated.dto.PhoneMemberSearchResult": "generated.dto.PhoneMember",
  "generated.dto.PhoneSearchResult": "generated.dto.Phone",
  "generated.dto.PhoneStaffSearchParams": "generated.dto.PhoneSearchParams",
  "generated.dto.PhoneStaffSearchResult": "generated.dto.PhoneStaff",
  "generated.dto.PrinterStaffFetchOptions": "generated.dto.PrinterFetchOptions",
  "generated.dto.PrinterStaffSearchResult": "generated.dto.PrinterStaff",
  "generated.dto.ProductSearchResult": "generated.dto.Product",
  "generated.dto.ProductStaffFetchOptions": "generated.dto.ProductFetchOptions",
  "generated.dto.ProductStaffSearchParams": "generated.dto.ProductSearchParams",
  "generated.dto.ProductStaffSearchResult": "generated.dto.ProductStaff",
  "generated.dto.ProgramTypeMemberSearchResult": "generated.dto.ProgramTypeMember",
  "generated.dto.ProgramTypeSearchResult": "generated.dto.ProgramType",
  "generated.dto.ProgramTypeStaffSearchParams": "generated.dto.ProgramTypeSearchParams",
  "generated.dto.ProgramTypeStaffSearchResult": "generated.dto.ProgramTypeStaff",
  "generated.dto.PurchaseDeliveryStaffFetchOptions": "generated.dto.PurchaseDeliveryFetchOptions",
  "generated.dto.RatingChangeStaffFetchOptions": "generated.dto.RatingChangeFetchOptions",
  "generated.dto.RatingChangeStaffSearchParams": "generated.dto.RatingChangeSearchParams",
  "generated.dto.RatingChangeStaffSearchResult": "generated.dto.RatingChangeStaff",
  "generated.dto.RatingMemberSearchParams": "generated.dto.RatingSearchParams",
  "generated.dto.RatingMemberSearchResult": "generated.dto.RatingMember",
  "generated.dto.RatingProgramMemberFetchOptions": "generated.dto.RatingProgramFetchOptions",
  "generated.dto.RatingProgramStaffFetchOptions": "generated.dto.RatingProgramFetchOptions",
  "generated.dto.RatingSearchResult": "generated.dto.Rating",
  "generated.dto.RatingStaffFetchOptions": "generated.dto.RatingFetchOptions",
  "generated.dto.RatingStaffSearchParams": "generated.dto.RatingSearchParams",
  "generated.dto.RatingStaffSearchResult": "generated.dto.RatingStaff",
  "generated.dto.ReportRunStaffFetchOptions": "generated.dto.ReportRunFetchOptions",
  "generated.dto.RoleAssignmentStaffFetchOptions": "generated.dto.RoleAssignmentFetchOptions",
  "generated.dto.RolePermissionStaffFetchOptions": "generated.dto.RolePermissionFetchOptions",
  "generated.dto.RoleStaffFetchOptions": "generated.dto.RoleFetchOptions",
  "generated.dto.ScopesStaffFetchOptions": "generated.dto.ScopesFetchOptions",
  "generated.dto.SignoutCrewStaffFetchOptions": "generated.dto.SignoutCrewFetchOptions",
  "generated.dto.SignoutCrewStaffSearchParams": "generated.dto.SignoutCrewSearchParams",
  "generated.dto.SignoutCrewStaffSearchResult": "generated.dto.SignoutCrewStaff",
  "generated.dto.SignoutMemberSearchResult": "generated.dto.SignoutMember",
  "generated.dto.SignoutStaffFetchOptions": "generated.dto.SignoutFetchOptions",
  "generated.dto.SignoutStaffSearchParams": "generated.dto.SignoutSearchParams",
  "generated.dto.SignoutStaffSearchResult": "generated.dto.SignoutStaff",
  "generated.dto.SkillAssessmentStaffFetchOptions": "generated.dto.SkillAssessmentFetchOptions",
  "generated.dto.SkillStaffSearchParams": "generated.dto.SkillSearchParams",
  "generated.dto.SkillStaffSearchResult": "generated.dto.SkillStaff",
  "generated.dto.StockChangeStaffFetchOptions": "generated.dto.StockChangeFetchOptions",
  "generated.dto.StripeCachedBalanceTransactionStaffFetchOptions": "generated.dto.StripeCachedBalanceTransactionFetchOptions",
  "generated.dto.StripeCachedBalanceTransactionStaffSearchParams": "generated.dto.StripeCachedBalanceTransactionSearchParams",
  "generated.dto.StripeCachedBalanceTransactionStaffSearchResult": "generated.dto.StripeCachedBalanceTransactionStaff",
  "generated.dto.StripeCachedChargeStaffFetchOptions": "generated.dto.StripeCachedChargeFetchOptions",
  "generated.dto.StripeCachedChargeStaffSearchParams": "generated.dto.StripeCachedChargeSearchParams",
  "generated.dto.StripeCachedChargeStaffSearchResult": "generated.dto.StripeCachedChargeStaff",
  "generated.dto.StripeCachedDisputeStaffFetchOptions": "generated.dto.StripeCachedDisputeFetchOptions",
  "generated.dto.StripeCachedDisputeStaffSearchParams": "generated.dto.StripeCachedDisputeSearchParams",
  "generated.dto.StripeCachedDisputeStaffSearchResult": "generated.dto.StripeCachedDisputeStaff",
  "generated.dto.StripeCachedPayoutStaffFetchOptions": "generated.dto.StripeCachedPayoutFetchOptions",
  "generated.dto.StripeCachedPayoutStaffSearchParams": "generated.dto.StripeCachedPayoutSearchParams",
  "generated.dto.StripeCachedPayoutStaffSearchResult": "generated.dto.StripeCachedPayoutStaff",
  "generated.dto.StripeCachedRefundStaffFetchOptions": "generated.dto.StripeCachedRefundFetchOptions",
  "generated.dto.StripeCachedRefundStaffSearchParams": "generated.dto.StripeCachedRefundSearchParams",
  "generated.dto.StripeCachedRefundStaffSearchResult": "generated.dto.StripeCachedRefundStaff",
  "generated.dto.StripePaymentIntentStaffFetchOptions": "generated.dto.StripePaymentIntentFetchOptions",
  "generated.dto.StripePaymentIntentStaffSearchParams": "generated.dto.StripePaymentIntentSearchParams",
  "generated.dto.StripePaymentIntentStaffSearchResult": "generated.dto.StripePaymentIntentStaff",
  "generated.dto.StripePayoutEntryStaffFetchOptions": "generated.dto.StripePayoutEntryFetchOptions",
  "generated.dto.StripePayoutEntryStaffSearchParams": "generated.dto.StripePayoutEntrySearchParams",
  "generated.dto.StripePayoutEntryStaffSearchResult": "generated.dto.StripePayoutEntryStaff",
  "generated.dto.TagStaffSearchParams": "generated.dto.TagSearchParams",
  "generated.dto.TagStaffSearchResult": "generated.dto.TagStaff",
  "generated.dto.UpdateAddressStaff": "generated.dto.UpdateAddress",
  "generated.dto.UpdateAgreementCategoryStaff": "generated.dto.UpdateAgreementCategory",
  "generated.dto.UpdateAgreementInstanceStaff": "generated.dto.UpdateAgreementInstance",
  "generated.dto.UpdateAgreementStaff": "generated.dto.UpdateAgreement",
  "generated.dto.UpdateAmericanStateStaff": "generated.dto.UpdateAmericanState",
  "generated.dto.UpdateApClassAttendanceStaff": "generated.dto.UpdateApClassAttendance",
  "generated.dto.UpdateApClassFormatStaff": "generated.dto.UpdateApClassFormat",
  "generated.dto.UpdateApClassSessionStaff": "generated.dto.UpdateApClassSession",
  "generated.dto.UpdateApClassSignupStaff": "generated.dto.UpdateApClassSignup",
  "generated.dto.UpdateApClassStaff": "generated.dto.UpdateApClass",
  "generated.dto.UpdateApClassTypeOverrideStaff": "generated.dto.UpdateApClassTypeOverride",
  "generated.dto.UpdateApClassTypeStaff": "generated.dto.UpdateApClassType",
  "generated.dto.UpdateApClassWlResultStaff": "generated.dto.UpdateApClassWlResult",
  "generated.dto.UpdateBoatTypeStaff": "generated.dto.UpdateBoatType",
  "generated.dto.UpdateCashDrawerStaff": "generated.dto.UpdateCashDrawer",
  "generated.dto.UpdateCatalogDiscountCategoryStaff": "generated.dto.UpdateCatalogDiscountCategory",
  "generated.dto.UpdateCatalogDiscountInstanceStaff": "generated.dto.UpdateCatalogDiscountInstance",
  "generated.dto.UpdateCatalogDiscountStaff": "generated.dto.UpdateCatalogDiscount",
  "generated.dto.UpdateCatalogItemAgreementStaff": "generated.dto.UpdateCatalogItemAgreement",
  "generated.dto.UpdateCatalogItemCategoryStaff": "generated.dto.UpdateCatalogItemCategory",
  "generated.dto.UpdateCatalogItemDiscountStaff": "generated.dto.UpdateCatalogItemDiscount",
  "generated.dto.UpdateCatalogItemInstanceStaff": "generated.dto.UpdateCatalogItemInstance",
  "generated.dto.UpdateCatalogItemTaxStaff": "generated.dto.UpdateCatalogItemTax",
  "generated.dto.UpdateCatalogStaff": "generated.dto.UpdateCatalog",
  "generated.dto.UpdateCatalogTaxStaff": "generated.dto.UpdateCatalogTax",
  "generated.dto.UpdateCategoryStaff": "generated.dto.UpdateCategory",
  "generated.dto.UpdateClassLocationStaff": "generated.dto.UpdateClassLocation",
  "generated.dto.UpdateCountryStaff": "generated.dto.UpdateCountry",
  "generated.dto.UpdateDamageWaiverTypeStaff": "generated.dto.UpdateDamageWaiverType",
  "generated.dto.UpdateDatetimeRangeStaff": "generated.dto.UpdateDatetimeRange",
  "generated.dto.UpdateDonationInitiativeStaff": "generated.dto.UpdateDonationInitiative",
  "generated.dto.UpdateDonationStaff": "generated.dto.UpdateDonation",
  "generated.dto.UpdateEiiOverrideStaff": "generated.dto.UpdateEiiOverride",
  "generated.dto.UpdateJpClassAttendanceStaff": "generated.dto.UpdateJpClassAttendance",
  "generated.dto.UpdateJpClassSessionStaff": "generated.dto.UpdateJpClassSession",
  "generated.dto.UpdateJpClassSignupStaff": "generated.dto.UpdateJpClassSignup",
  "generated.dto.UpdateJpClassStaff": "generated.dto.UpdateJpClass",
  "generated.dto.UpdateJpClassStaggerStaff": "generated.dto.UpdateJpClassStagger",
  "generated.dto.UpdateJpClassTypeOverrideStaff": "generated.dto.UpdateJpClassTypeOverride",
  "generated.dto.UpdateJpClassTypeStaff": "generated.dto.UpdateJpClassType",
  "generated.dto.UpdateJpClassWlResultStaff": "generated.dto.UpdateJpClassWlResult",
  "generated.dto.UpdateMembershipTypeDiscountStaff": "generated.dto.UpdateMembershipTypeDiscount",
  "generated.dto.UpdateMembershipTypeStaff": "generated.dto.UpdateMembershipType",
  "generated.dto.UpdatePersonAddressStaff": "generated.dto.UpdatePersonAddress",
  "generated.dto.UpdatePersonPersonTypeStaff": "generated.dto.UpdatePersonPersonType",
  "generated.dto.UpdatePersonPhoneStaff": "generated.dto.UpdatePersonPhone",
  "generated.dto.UpdatePersonReferralStaff": "generated.dto.UpdatePersonReferral",
  "generated.dto.UpdatePersonRelationStaff": "generated.dto.UpdatePersonRelation",
  "generated.dto.UpdatePersonTypeStaff": "generated.dto.UpdatePersonType",
  "generated.dto.UpdatePhoneStaff": "generated.dto.UpdatePhone",
  "generated.dto.UpdateProductStaff": "generated.dto.UpdateProduct",
  "generated.dto.UpdateProgramTypeStaff": "generated.dto.UpdateProgramType",
  "generated.dto.UpdateRatingProgramStaff": "generated.dto.UpdateRatingProgram",
  "generated.dto.UpdateRatingStaff": "generated.dto.UpdateRating",
  "generated.dto.UpdateRecurringDonationStaff": "generated.dto.UpdateRecurringDonation",
  "generated.dto.UpdateRoleAssignmentStaff": "generated.dto.UpdateRoleAssignment",
  "generated.dto.UpdateRolePermissionStaff": "generated.dto.UpdateRolePermission",
  "generated.dto.UpdateRoleStaff": "generated.dto.UpdateRole",
  "generated.dto.UpdateScopesStaff": "generated.dto.UpdateScopes",
  "generated.dto.UpdateStockChangeStaff": "generated.dto.UpdateStockChange",
  "generated.dto.UpdateSunsetTimeStaff": "generated.dto.UpdateSunsetTime",
  "generated.dto.UpdateSwimProofMethodStaff": "generated.dto.UpdateSwimProofMethod",
  "generated.dto.UpdateTagStaff": "generated.dto.UpdateTag",
  "generated.dto.UpdateUserPermissionStaff": "generated.dto.UpdateUserPermission",
  "generated.dto.UpdateYearlyDateItemStaff": "generated.dto.UpdateYearlyDateItem",
  "generated.dto.UpdateYearlyDateStaff": "generated.dto.UpdateYearlyDate",
  "generated.dto.UserPermissionStaffFetchOptions": "generated.dto.UserPermissionFetchOptions",
  "generated.dto.YearlyDateStaffFetchOptions": "generated.dto.YearlyDateFetchOptions",
};

export const deserializeCbiDto = <T>(value: unknown, dto: string): T =>
  transformCbiDto(value, dto, false) as T;

export const serializeCbiDto = (value: unknown, dto: string): unknown =>
  transformCbiDto(value, dto, true);

export const encodeRequestParam = (value: unknown, dto: string): string =>
  JSON.stringify(serializeCbiDto(value, dto));

function transformCbiDto(value: unknown, name: string, toWire: boolean): unknown {
  const dto = cbiDtoAliases[name] ?? name;
  if (Array.isArray(value)) return value.map((item) => transformCbiDto(item, dto, toWire));
  if (!isRecord(value)) return value;
  const result: Record<string, unknown> = { ...value };
  for (const field of cbiDtoFieldCodecs[dto] ?? []) {
    const current = result[field.field];
    if (current == null) continue;
    const transform = (item: unknown): unknown => {
      if (field.kind === "dto") return transformCbiDto(item, field.dto, toWire);
      return toWire ? formatCbiDate(item, field.kind) : parseCbiDate(item, field.kind);
    };
    result[field.field] = field.collection ? requireArray(current, field.field).map(transform) : transform(current);
  }
  if (!toWire) {
    const ctor = cbiDtoConstructors[dto];
    if (ctor) {
      Object.setPrototypeOf(result, ctor.prototype);
      (result as { cbiServiceContext?: unknown }).cbiServiceContext = cbiFrontendServiceContext;
    }
  }
  return result;
}

function parseCbiDate(value: unknown, kind: "date" | "date-time"): Date {
  if (value instanceof Date) return value;
  if (typeof value !== "string") throw new TypeError(`Expected ISO ${kind} string`);
  const date = kind === "date" ? parseCbiLocalDate(value) : new Date(value);
  if (Number.isNaN(date.getTime())) throw new TypeError(`Invalid ISO ${kind} string: ${value}`);
  return date;
}

function formatCbiDate(value: unknown, kind: "date" | "date-time"): string {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) throw new TypeError(`Expected valid Date for ${kind}`);
  const date = formatCbiLocalDate(value);
  if (kind === "date") return date;
  return `${date}T${pad(value.getHours())}:${pad(value.getMinutes())}:${pad(value.getSeconds())}.${pad(value.getMilliseconds(), 3)}`;
}

function parseCbiLocalDate(value: string): Date {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) throw new TypeError(`Invalid ISO date string: ${value}`);
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (formatCbiLocalDate(date) !== value) throw new TypeError(`Invalid ISO date string: ${value}`);
  return date;
}

function formatCbiLocalDate(value: Date): string {
  return `${pad(value.getFullYear(), 4)}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
}

function pad(value: number, width = 2): string {
  return String(value).padStart(width, "0");
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function requireArray(value: unknown, field: string): unknown[] {
  if (!Array.isArray(value)) throw new TypeError(`Expected array for ${field}`);
  return value;
}
